
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire21de"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire21de"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5z4M4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jYqtV"));

});
parcelRegister("jYqtV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e8a829a2b672c9cd$export$ffb0004e005737fa; }, function (v) { return $e8a829a2b672c9cd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e8a829a2b672c9cd$export$34b9dba7ce09269b; }, function (v) { return $e8a829a2b672c9cd$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e8a829a2b672c9cd$export$25062201e9e25d76; }, function (v) { return $e8a829a2b672c9cd$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8a829a2b672c9cd$export$ffb0004e005737fa;
var $e8a829a2b672c9cd$export$34b9dba7ce09269b;
var $e8a829a2b672c9cd$export$25062201e9e25d76;
"use strict";
var $e8a829a2b672c9cd$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e8a829a2b672c9cd$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $e8a829a2b672c9cd$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $e8a829a2b672c9cd$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$e8a829a2b672c9cd$export$ffb0004e005737fa = $e8a829a2b672c9cd$var$REACT_FRAGMENT_TYPE;
$e8a829a2b672c9cd$export$34b9dba7ce09269b = $e8a829a2b672c9cd$var$jsxProd;
$e8a829a2b672c9cd$export$25062201e9e25d76 = $e8a829a2b672c9cd$var$jsxProd;

});


parcelRegister("jGswQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("761wi"));

});
parcelRegister("761wi", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $52aa45c6494dbedf$export$dca3b0875bd9a954; }, function (v) { return $52aa45c6494dbedf$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $52aa45c6494dbedf$export$16fa2f45be04daa8; }, function (v) { return $52aa45c6494dbedf$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $52aa45c6494dbedf$export$ffb0004e005737fa; }, function (v) { return $52aa45c6494dbedf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $52aa45c6494dbedf$export$e2c29f18771995cb; }, function (v) { return $52aa45c6494dbedf$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $52aa45c6494dbedf$export$221d75b3f55bb0bd; }, function (v) { return $52aa45c6494dbedf$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $52aa45c6494dbedf$export$5f8d39834fd61797; }, function (v) { return $52aa45c6494dbedf$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $52aa45c6494dbedf$export$74bf444e3cd11ea5; }, function (v) { return $52aa45c6494dbedf$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $52aa45c6494dbedf$export$1ced07cd6b1985ce; }, function (v) { return $52aa45c6494dbedf$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $52aa45c6494dbedf$export$abd8e32b826d7ea7; }, function (v) { return $52aa45c6494dbedf$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $52aa45c6494dbedf$export$69a3209f1a06c04d; }, function (v) { return $52aa45c6494dbedf$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $52aa45c6494dbedf$export$e530037191fcd5d7; }, function (v) { return $52aa45c6494dbedf$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $52aa45c6494dbedf$export$fd42f52fd3ae1109; }, function (v) { return $52aa45c6494dbedf$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $52aa45c6494dbedf$export$c8a8987d4410bf2d; }, function (v) { return $52aa45c6494dbedf$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $52aa45c6494dbedf$export$7d1e3a5e95ceca43; }, function (v) { return $52aa45c6494dbedf$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $52aa45c6494dbedf$export$257a8862b851cb5b; }, function (v) { return $52aa45c6494dbedf$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $52aa45c6494dbedf$export$a8257692ac88316c; }, function (v) { return $52aa45c6494dbedf$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $52aa45c6494dbedf$export$488013bae63b21da; }, function (v) { return $52aa45c6494dbedf$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $52aa45c6494dbedf$export$7c73462e0d25e514; }, function (v) { return $52aa45c6494dbedf$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $52aa45c6494dbedf$export$7568632d0d33d16d; }, function (v) { return $52aa45c6494dbedf$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $52aa45c6494dbedf$export$f93f40ac0ca7e3a8; }, function (v) { return $52aa45c6494dbedf$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $52aa45c6494dbedf$export$1f96ae73734a86cc; }, function (v) { return $52aa45c6494dbedf$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $52aa45c6494dbedf$export$9a47ced3238df325; }, function (v) { return $52aa45c6494dbedf$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $52aa45c6494dbedf$export$35808ee640e87ca7; }, function (v) { return $52aa45c6494dbedf$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $52aa45c6494dbedf$export$fae74005e78b1a27; }, function (v) { return $52aa45c6494dbedf$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $52aa45c6494dbedf$export$dc8fbce3eb94dc1e; }, function (v) { return $52aa45c6494dbedf$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $52aa45c6494dbedf$export$6a7bc4e911dc01cf; }, function (v) { return $52aa45c6494dbedf$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $52aa45c6494dbedf$export$6d9c69b0de29b591; }, function (v) { return $52aa45c6494dbedf$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $52aa45c6494dbedf$export$f680877a34711e37; }, function (v) { return $52aa45c6494dbedf$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $52aa45c6494dbedf$export$d5a552a76deda3c2; }, function (v) { return $52aa45c6494dbedf$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $52aa45c6494dbedf$export$aaabe4eda9ed9969; }, function (v) { return $52aa45c6494dbedf$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $52aa45c6494dbedf$export$e5c5a5f917a5871c; }, function (v) { return $52aa45c6494dbedf$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $52aa45c6494dbedf$export$1538c33de8887b59; }, function (v) { return $52aa45c6494dbedf$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $52aa45c6494dbedf$export$fca7f784ae7a249a; }, function (v) { return $52aa45c6494dbedf$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $52aa45c6494dbedf$export$13e3392192263954; }, function (v) { return $52aa45c6494dbedf$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $52aa45c6494dbedf$export$b8f5890fc79d6aca; }, function (v) { return $52aa45c6494dbedf$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $52aa45c6494dbedf$export$60241385465d0a34; }, function (v) { return $52aa45c6494dbedf$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $52aa45c6494dbedf$export$306c0aa65ff9ec16; }, function (v) { return $52aa45c6494dbedf$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $52aa45c6494dbedf$export$7b286972b8d8ccbf; }, function (v) { return $52aa45c6494dbedf$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $52aa45c6494dbedf$export$83d89fbfd8236492; }, function (v) { return $52aa45c6494dbedf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $52aa45c6494dbedf$export$dca3b0875bd9a954;
var $52aa45c6494dbedf$export$16fa2f45be04daa8;
var $52aa45c6494dbedf$export$ffb0004e005737fa;
var $52aa45c6494dbedf$export$e2c29f18771995cb;
var $52aa45c6494dbedf$export$221d75b3f55bb0bd;
var $52aa45c6494dbedf$export$5f8d39834fd61797;
var $52aa45c6494dbedf$export$74bf444e3cd11ea5;
var $52aa45c6494dbedf$export$1ced07cd6b1985ce;
var $52aa45c6494dbedf$export$abd8e32b826d7ea7;
var $52aa45c6494dbedf$export$69a3209f1a06c04d;
var $52aa45c6494dbedf$export$e530037191fcd5d7;
var $52aa45c6494dbedf$export$fd42f52fd3ae1109;
var $52aa45c6494dbedf$export$c8a8987d4410bf2d;
var $52aa45c6494dbedf$export$7d1e3a5e95ceca43;
var $52aa45c6494dbedf$export$257a8862b851cb5b;
var $52aa45c6494dbedf$export$a8257692ac88316c;
var $52aa45c6494dbedf$export$488013bae63b21da;
var $52aa45c6494dbedf$export$7c73462e0d25e514;
var $52aa45c6494dbedf$export$7568632d0d33d16d;
var $52aa45c6494dbedf$export$f93f40ac0ca7e3a8;
var $52aa45c6494dbedf$export$1f96ae73734a86cc;
var $52aa45c6494dbedf$export$9a47ced3238df325;
var $52aa45c6494dbedf$export$35808ee640e87ca7;
var $52aa45c6494dbedf$export$fae74005e78b1a27;
var $52aa45c6494dbedf$export$dc8fbce3eb94dc1e;
var $52aa45c6494dbedf$export$6a7bc4e911dc01cf;
var $52aa45c6494dbedf$export$6d9c69b0de29b591;
var $52aa45c6494dbedf$export$f680877a34711e37;
var $52aa45c6494dbedf$export$d5a552a76deda3c2;
var $52aa45c6494dbedf$export$aaabe4eda9ed9969;
var $52aa45c6494dbedf$export$e5c5a5f917a5871c;
var $52aa45c6494dbedf$export$1538c33de8887b59;
var $52aa45c6494dbedf$export$fca7f784ae7a249a;
var $52aa45c6494dbedf$export$13e3392192263954;
var $52aa45c6494dbedf$export$b8f5890fc79d6aca;
var $52aa45c6494dbedf$export$60241385465d0a34;
var $52aa45c6494dbedf$export$306c0aa65ff9ec16;
var $52aa45c6494dbedf$export$7b286972b8d8ccbf;
var $52aa45c6494dbedf$export$83d89fbfd8236492;
"use strict";
var $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $52aa45c6494dbedf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $52aa45c6494dbedf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $52aa45c6494dbedf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $52aa45c6494dbedf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $52aa45c6494dbedf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $52aa45c6494dbedf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $52aa45c6494dbedf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $52aa45c6494dbedf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $52aa45c6494dbedf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $52aa45c6494dbedf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $52aa45c6494dbedf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $52aa45c6494dbedf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $52aa45c6494dbedf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$52aa45c6494dbedf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $52aa45c6494dbedf$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $52aa45c6494dbedf$var$assign = Object.assign, $52aa45c6494dbedf$var$emptyObject = {};
function $52aa45c6494dbedf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $52aa45c6494dbedf$var$emptyObject;
    this.updater = updater || $52aa45c6494dbedf$var$ReactNoopUpdateQueue;
}
$52aa45c6494dbedf$var$Component.prototype.isReactComponent = {};
$52aa45c6494dbedf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$52aa45c6494dbedf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $52aa45c6494dbedf$var$ComponentDummy() {}
$52aa45c6494dbedf$var$ComponentDummy.prototype = $52aa45c6494dbedf$var$Component.prototype;
function $52aa45c6494dbedf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $52aa45c6494dbedf$var$emptyObject;
    this.updater = updater || $52aa45c6494dbedf$var$ReactNoopUpdateQueue;
}
var $52aa45c6494dbedf$var$pureComponentPrototype = $52aa45c6494dbedf$var$PureComponent.prototype = new $52aa45c6494dbedf$var$ComponentDummy();
$52aa45c6494dbedf$var$pureComponentPrototype.constructor = $52aa45c6494dbedf$var$PureComponent;
$52aa45c6494dbedf$var$assign($52aa45c6494dbedf$var$pureComponentPrototype, $52aa45c6494dbedf$var$Component.prototype);
$52aa45c6494dbedf$var$pureComponentPrototype.isPureReactComponent = !0;
var $52aa45c6494dbedf$var$isArrayImpl = Array.isArray, $52aa45c6494dbedf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $52aa45c6494dbedf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $52aa45c6494dbedf$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $52aa45c6494dbedf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $52aa45c6494dbedf$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $52aa45c6494dbedf$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE;
}
function $52aa45c6494dbedf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $52aa45c6494dbedf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $52aa45c6494dbedf$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $52aa45c6494dbedf$var$escape("" + element.key) : index.toString(36);
}
function $52aa45c6494dbedf$var$noop$1() {}
function $52aa45c6494dbedf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($52aa45c6494dbedf$var$noop$1, $52aa45c6494dbedf$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $52aa45c6494dbedf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE:
                case $52aa45c6494dbedf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $52aa45c6494dbedf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $52aa45c6494dbedf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $52aa45c6494dbedf$var$getElementKey(children, 0) : nameSoFar, $52aa45c6494dbedf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($52aa45c6494dbedf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $52aa45c6494dbedf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($52aa45c6494dbedf$var$isValidElement(callback) && (callback = $52aa45c6494dbedf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($52aa45c6494dbedf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($52aa45c6494dbedf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $52aa45c6494dbedf$var$getElementKey(nameSoFar, i), invokeCallback += $52aa45c6494dbedf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $52aa45c6494dbedf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $52aa45c6494dbedf$var$getElementKey(nameSoFar, i++), invokeCallback += $52aa45c6494dbedf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $52aa45c6494dbedf$var$mapIntoArray($52aa45c6494dbedf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $52aa45c6494dbedf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $52aa45c6494dbedf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $52aa45c6494dbedf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $52aa45c6494dbedf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $52aa45c6494dbedf$var$noop() {}
$52aa45c6494dbedf$export$dca3b0875bd9a954 = {
    map: $52aa45c6494dbedf$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $52aa45c6494dbedf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $52aa45c6494dbedf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $52aa45c6494dbedf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$52aa45c6494dbedf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$52aa45c6494dbedf$export$16fa2f45be04daa8 = $52aa45c6494dbedf$var$Component;
$52aa45c6494dbedf$export$ffb0004e005737fa = $52aa45c6494dbedf$var$REACT_FRAGMENT_TYPE;
$52aa45c6494dbedf$export$e2c29f18771995cb = $52aa45c6494dbedf$var$REACT_PROFILER_TYPE;
$52aa45c6494dbedf$export$221d75b3f55bb0bd = $52aa45c6494dbedf$var$PureComponent;
$52aa45c6494dbedf$export$5f8d39834fd61797 = $52aa45c6494dbedf$var$REACT_STRICT_MODE_TYPE;
$52aa45c6494dbedf$export$74bf444e3cd11ea5 = $52aa45c6494dbedf$var$REACT_SUSPENSE_TYPE;
$52aa45c6494dbedf$export$1ced07cd6b1985ce = $52aa45c6494dbedf$var$ReactSharedInternals;
$52aa45c6494dbedf$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $52aa45c6494dbedf$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$52aa45c6494dbedf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$52aa45c6494dbedf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $52aa45c6494dbedf$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$52aa45c6494dbedf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $52aa45c6494dbedf$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$52aa45c6494dbedf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $52aa45c6494dbedf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $52aa45c6494dbedf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$52aa45c6494dbedf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$52aa45c6494dbedf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $52aa45c6494dbedf$var$ReactElement(type, key, void 0, void 0, null, props);
};
$52aa45c6494dbedf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$52aa45c6494dbedf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$52aa45c6494dbedf$export$a8257692ac88316c = $52aa45c6494dbedf$var$isValidElement;
$52aa45c6494dbedf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $52aa45c6494dbedf$var$lazyInitializer
    };
};
$52aa45c6494dbedf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$52aa45c6494dbedf$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $52aa45c6494dbedf$var$ReactSharedInternals.T, currentTransition = {};
    $52aa45c6494dbedf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $52aa45c6494dbedf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($52aa45c6494dbedf$var$noop, $52aa45c6494dbedf$var$reportGlobalError);
    } catch (error) {
        $52aa45c6494dbedf$var$reportGlobalError(error);
    } finally{
        $52aa45c6494dbedf$var$ReactSharedInternals.T = prevTransition;
    }
};
$52aa45c6494dbedf$export$f93f40ac0ca7e3a8 = function() {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useCacheRefresh();
};
$52aa45c6494dbedf$export$1f96ae73734a86cc = function(usable) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.use(usable);
};
$52aa45c6494dbedf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$52aa45c6494dbedf$export$35808ee640e87ca7 = function(callback, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$52aa45c6494dbedf$export$fae74005e78b1a27 = function(Context) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useContext(Context);
};
$52aa45c6494dbedf$export$dc8fbce3eb94dc1e = function() {};
$52aa45c6494dbedf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$52aa45c6494dbedf$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $52aa45c6494dbedf$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$52aa45c6494dbedf$export$f680877a34711e37 = function() {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useId();
};
$52aa45c6494dbedf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$52aa45c6494dbedf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$52aa45c6494dbedf$export$e5c5a5f917a5871c = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$52aa45c6494dbedf$export$1538c33de8887b59 = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$52aa45c6494dbedf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$52aa45c6494dbedf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$52aa45c6494dbedf$export$b8f5890fc79d6aca = function(initialValue) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useRef(initialValue);
};
$52aa45c6494dbedf$export$60241385465d0a34 = function(initialState) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useState(initialState);
};
$52aa45c6494dbedf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$52aa45c6494dbedf$export$7b286972b8d8ccbf = function() {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useTransition();
};
$52aa45c6494dbedf$export$83d89fbfd8236492 = "19.1.1";

});


parcelRegister("He5iZ", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $081ef12b46fbcaa0$export$882461b6382ed46c; }, function (v) { return $081ef12b46fbcaa0$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $081ef12b46fbcaa0$export$757ceba2d55c277e; }, function (v) { return $081ef12b46fbcaa0$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $081ef12b46fbcaa0$export$83d89fbfd8236492; }, function (v) { return $081ef12b46fbcaa0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $081ef12b46fbcaa0$export$882461b6382ed46c;
var $081ef12b46fbcaa0$export$757ceba2d55c277e;
var $081ef12b46fbcaa0$export$83d89fbfd8236492;
"use strict";

var $fndEB = parcelRequire("fndEB");

var $jGswQ = parcelRequire("jGswQ");

var $5hICV = parcelRequire("5hICV");
function $081ef12b46fbcaa0$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $081ef12b46fbcaa0$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $081ef12b46fbcaa0$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $081ef12b46fbcaa0$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $081ef12b46fbcaa0$var$assertIsMounted(fiber) {
    if ($081ef12b46fbcaa0$var$getNearestMountedFiber(fiber) !== fiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
}
function $081ef12b46fbcaa0$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $081ef12b46fbcaa0$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $081ef12b46fbcaa0$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $081ef12b46fbcaa0$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $081ef12b46fbcaa0$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $081ef12b46fbcaa0$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $081ef12b46fbcaa0$var$assign = Object.assign, $081ef12b46fbcaa0$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $081ef12b46fbcaa0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $081ef12b46fbcaa0$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $081ef12b46fbcaa0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $081ef12b46fbcaa0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $081ef12b46fbcaa0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $081ef12b46fbcaa0$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $081ef12b46fbcaa0$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $081ef12b46fbcaa0$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $081ef12b46fbcaa0$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$081ef12b46fbcaa0$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $081ef12b46fbcaa0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $081ef12b46fbcaa0$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $081ef12b46fbcaa0$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $081ef12b46fbcaa0$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $081ef12b46fbcaa0$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $081ef12b46fbcaa0$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $081ef12b46fbcaa0$var$getComponentNameFromType(type.type) || "Memo";
        case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $081ef12b46fbcaa0$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $081ef12b46fbcaa0$var$isArrayImpl = Array.isArray, $081ef12b46fbcaa0$var$ReactSharedInternals = $jGswQ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $081ef12b46fbcaa0$var$ReactDOMSharedInternals = $5hICV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $081ef12b46fbcaa0$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $081ef12b46fbcaa0$var$valueStack = [], $081ef12b46fbcaa0$var$index = -1;
function $081ef12b46fbcaa0$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $081ef12b46fbcaa0$var$pop(cursor) {
    0 > $081ef12b46fbcaa0$var$index || (cursor.current = $081ef12b46fbcaa0$var$valueStack[$081ef12b46fbcaa0$var$index], $081ef12b46fbcaa0$var$valueStack[$081ef12b46fbcaa0$var$index] = null, $081ef12b46fbcaa0$var$index--);
}
function $081ef12b46fbcaa0$var$push(cursor, value) {
    $081ef12b46fbcaa0$var$index++;
    $081ef12b46fbcaa0$var$valueStack[$081ef12b46fbcaa0$var$index] = cursor.current;
    cursor.current = value;
}
var $081ef12b46fbcaa0$var$contextStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$contextFiberStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$rootInstanceStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$hostTransitionProviderCursor = $081ef12b46fbcaa0$var$createCursor(null);
function $081ef12b46fbcaa0$var$pushHostContainer(fiber, nextRootInstance) {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$rootInstanceStackCursor, nextRootInstance);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextFiberStackCursor, fiber);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $081ef12b46fbcaa0$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $081ef12b46fbcaa0$var$getOwnHostContext(nextRootInstance), fiber = $081ef12b46fbcaa0$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextStackCursor);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextStackCursor, fiber);
}
function $081ef12b46fbcaa0$var$popHostContainer() {
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextFiberStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$rootInstanceStackCursor);
}
function $081ef12b46fbcaa0$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$hostTransitionProviderCursor, fiber);
    var context = $081ef12b46fbcaa0$var$contextStackCursor.current;
    var JSCompiler_inline_result = $081ef12b46fbcaa0$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextFiberStackCursor, fiber), $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextStackCursor, JSCompiler_inline_result));
}
function $081ef12b46fbcaa0$var$popHostContext(fiber) {
    $081ef12b46fbcaa0$var$contextFiberStackCursor.current === fiber && ($081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextStackCursor), $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextFiberStackCursor));
    $081ef12b46fbcaa0$var$hostTransitionProviderCursor.current === fiber && ($081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$hostTransitionProviderCursor), $081ef12b46fbcaa0$var$HostTransitionContext._currentValue = $081ef12b46fbcaa0$var$sharedNotPendingObject);
}
var $081ef12b46fbcaa0$var$hasOwnProperty = Object.prototype.hasOwnProperty, $081ef12b46fbcaa0$var$scheduleCallback$3 = $fndEB.unstable_scheduleCallback, $081ef12b46fbcaa0$var$cancelCallback$1 = $fndEB.unstable_cancelCallback, $081ef12b46fbcaa0$var$shouldYield = $fndEB.unstable_shouldYield, $081ef12b46fbcaa0$var$requestPaint = $fndEB.unstable_requestPaint, $081ef12b46fbcaa0$var$now = $fndEB.unstable_now, $081ef12b46fbcaa0$var$getCurrentPriorityLevel = $fndEB.unstable_getCurrentPriorityLevel, $081ef12b46fbcaa0$var$ImmediatePriority = $fndEB.unstable_ImmediatePriority, $081ef12b46fbcaa0$var$UserBlockingPriority = $fndEB.unstable_UserBlockingPriority, $081ef12b46fbcaa0$var$NormalPriority$1 = $fndEB.unstable_NormalPriority, $081ef12b46fbcaa0$var$LowPriority = $fndEB.unstable_LowPriority, $081ef12b46fbcaa0$var$IdlePriority = $fndEB.unstable_IdlePriority, $081ef12b46fbcaa0$var$log$1 = $fndEB.log, $081ef12b46fbcaa0$var$unstable_setDisableYieldValue = $fndEB.unstable_setDisableYieldValue, $081ef12b46fbcaa0$var$rendererID = null, $081ef12b46fbcaa0$var$injectedHook = null;
function $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $081ef12b46fbcaa0$var$log$1 && $081ef12b46fbcaa0$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.setStrictMode) try {
        $081ef12b46fbcaa0$var$injectedHook.setStrictMode($081ef12b46fbcaa0$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $081ef12b46fbcaa0$var$clz32 = Math.clz32 ? Math.clz32 : $081ef12b46fbcaa0$var$clz32Fallback, $081ef12b46fbcaa0$var$log = Math.log, $081ef12b46fbcaa0$var$LN2 = Math.LN2;
function $081ef12b46fbcaa0$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($081ef12b46fbcaa0$var$log(x) / $081ef12b46fbcaa0$var$LN2 | 0) | 0;
}
var $081ef12b46fbcaa0$var$nextTransitionLane = 256, $081ef12b46fbcaa0$var$nextRetryLane = 4194304;
function $081ef12b46fbcaa0$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $081ef12b46fbcaa0$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $081ef12b46fbcaa0$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $081ef12b46fbcaa0$var$claimNextTransitionLane() {
    var lane = $081ef12b46fbcaa0$var$nextTransitionLane;
    $081ef12b46fbcaa0$var$nextTransitionLane <<= 1;
    0 === ($081ef12b46fbcaa0$var$nextTransitionLane & 4194048) && ($081ef12b46fbcaa0$var$nextTransitionLane = 256);
    return lane;
}
function $081ef12b46fbcaa0$var$claimNextRetryLane() {
    var lane = $081ef12b46fbcaa0$var$nextRetryLane;
    $081ef12b46fbcaa0$var$nextRetryLane <<= 1;
    0 === ($081ef12b46fbcaa0$var$nextRetryLane & 62914560) && ($081ef12b46fbcaa0$var$nextRetryLane = 4194304);
    return lane;
}
function $081ef12b46fbcaa0$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $081ef12b46fbcaa0$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $081ef12b46fbcaa0$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $081ef12b46fbcaa0$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $081ef12b46fbcaa0$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $081ef12b46fbcaa0$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $081ef12b46fbcaa0$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $081ef12b46fbcaa0$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $081ef12b46fbcaa0$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $081ef12b46fbcaa0$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $081ef12b46fbcaa0$var$resolveUpdatePriority() {
    var updatePriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $081ef12b46fbcaa0$var$getEventPriority(updatePriority.type);
}
function $081ef12b46fbcaa0$var$runWithPriority(priority, fn) {
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        return $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $081ef12b46fbcaa0$var$randomKey = Math.random().toString(36).slice(2), $081ef12b46fbcaa0$var$internalInstanceKey = "__reactFiber$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalPropsKey = "__reactProps$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalContainerInstanceKey = "__reactContainer$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalEventHandlersKey = "__reactEvents$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalEventHandlerListenersKey = "__reactListeners$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalEventHandlesSetKey = "__reactHandles$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalRootNodeResourcesKey = "__reactResources$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalHoistableMarker = "__reactMarker$" + $081ef12b46fbcaa0$var$randomKey;
function $081ef12b46fbcaa0$var$detachDeletedInstance(node) {
    delete node[$081ef12b46fbcaa0$var$internalInstanceKey];
    delete node[$081ef12b46fbcaa0$var$internalPropsKey];
    delete node[$081ef12b46fbcaa0$var$internalEventHandlersKey];
    delete node[$081ef12b46fbcaa0$var$internalEventHandlerListenersKey];
    delete node[$081ef12b46fbcaa0$var$internalEventHandlesSetKey];
}
function $081ef12b46fbcaa0$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$081ef12b46fbcaa0$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$081ef12b46fbcaa0$var$internalContainerInstanceKey] || parentNode[$081ef12b46fbcaa0$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $081ef12b46fbcaa0$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$081ef12b46fbcaa0$var$internalInstanceKey]) return parentNode;
                targetNode = $081ef12b46fbcaa0$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $081ef12b46fbcaa0$var$getInstanceFromNode(node) {
    if (node = node[$081ef12b46fbcaa0$var$internalInstanceKey] || node[$081ef12b46fbcaa0$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $081ef12b46fbcaa0$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(33));
}
function $081ef12b46fbcaa0$var$getResourcesFromRoot(root) {
    var resources = root[$081ef12b46fbcaa0$var$internalRootNodeResourcesKey];
    resources || (resources = root[$081ef12b46fbcaa0$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $081ef12b46fbcaa0$var$markNodeAsHoistable(node) {
    node[$081ef12b46fbcaa0$var$internalHoistableMarker] = !0;
}
var $081ef12b46fbcaa0$var$allNativeEvents = new Set(), $081ef12b46fbcaa0$var$registrationNameDependencies = {};
function $081ef12b46fbcaa0$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $081ef12b46fbcaa0$var$registerDirectEvent(registrationName, dependencies);
    $081ef12b46fbcaa0$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $081ef12b46fbcaa0$var$registerDirectEvent(registrationName, dependencies) {
    $081ef12b46fbcaa0$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$081ef12b46fbcaa0$var$allNativeEvents.add(dependencies[registrationName]);
}
var $081ef12b46fbcaa0$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $081ef12b46fbcaa0$var$illegalAttributeNameCache = {}, $081ef12b46fbcaa0$var$validatedAttributeNameCache = {};
function $081ef12b46fbcaa0$var$isAttributeNameSafe(attributeName) {
    if ($081ef12b46fbcaa0$var$hasOwnProperty.call($081ef12b46fbcaa0$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($081ef12b46fbcaa0$var$hasOwnProperty.call($081ef12b46fbcaa0$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($081ef12b46fbcaa0$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $081ef12b46fbcaa0$var$validatedAttributeNameCache[attributeName] = !0;
    $081ef12b46fbcaa0$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $081ef12b46fbcaa0$var$setValueForAttribute(node, name, value) {
    if ($081ef12b46fbcaa0$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $081ef12b46fbcaa0$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $081ef12b46fbcaa0$var$prefix, $081ef12b46fbcaa0$var$suffix;
function $081ef12b46fbcaa0$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $081ef12b46fbcaa0$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $081ef12b46fbcaa0$var$prefix = match && match[1] || "";
        $081ef12b46fbcaa0$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $081ef12b46fbcaa0$var$prefix + name + $081ef12b46fbcaa0$var$suffix;
}
var $081ef12b46fbcaa0$var$reentry = !1;
function $081ef12b46fbcaa0$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $081ef12b46fbcaa0$var$reentry) return "";
    $081ef12b46fbcaa0$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $081ef12b46fbcaa0$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $081ef12b46fbcaa0$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $081ef12b46fbcaa0$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $081ef12b46fbcaa0$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $081ef12b46fbcaa0$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $081ef12b46fbcaa0$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $081ef12b46fbcaa0$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $081ef12b46fbcaa0$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $081ef12b46fbcaa0$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $081ef12b46fbcaa0$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $081ef12b46fbcaa0$var$trackValueOnNode(node) {
    var valueField = $081ef12b46fbcaa0$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $081ef12b46fbcaa0$var$track(node) {
    node._valueTracker || (node._valueTracker = $081ef12b46fbcaa0$var$trackValueOnNode(node));
}
function $081ef12b46fbcaa0$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $081ef12b46fbcaa0$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $081ef12b46fbcaa0$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $081ef12b46fbcaa0$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $081ef12b46fbcaa0$var$getToStringValue(value);
        } else element.value !== "" + $081ef12b46fbcaa0$var$getToStringValue(value) && (element.value = "" + $081ef12b46fbcaa0$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $081ef12b46fbcaa0$var$setDefaultValue(element, type, $081ef12b46fbcaa0$var$getToStringValue(value)) : null != defaultValue ? $081ef12b46fbcaa0$var$setDefaultValue(element, type, $081ef12b46fbcaa0$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $081ef12b46fbcaa0$var$getToStringValue(name) : element.removeAttribute("name");
}
function $081ef12b46fbcaa0$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $081ef12b46fbcaa0$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $081ef12b46fbcaa0$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $081ef12b46fbcaa0$var$setDefaultValue(node, type, value) {
    "number" === type && $081ef12b46fbcaa0$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $081ef12b46fbcaa0$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $081ef12b46fbcaa0$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $081ef12b46fbcaa0$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $081ef12b46fbcaa0$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $081ef12b46fbcaa0$var$getToStringValue(defaultValue) : "";
}
function $081ef12b46fbcaa0$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(92));
            if ($081ef12b46fbcaa0$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $081ef12b46fbcaa0$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $081ef12b46fbcaa0$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $081ef12b46fbcaa0$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $081ef12b46fbcaa0$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $081ef12b46fbcaa0$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $081ef12b46fbcaa0$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $081ef12b46fbcaa0$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $081ef12b46fbcaa0$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $081ef12b46fbcaa0$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $081ef12b46fbcaa0$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $081ef12b46fbcaa0$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $081ef12b46fbcaa0$var$sanitizeURL(url) {
    return $081ef12b46fbcaa0$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $081ef12b46fbcaa0$var$currentReplayingEvent = null;
function $081ef12b46fbcaa0$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $081ef12b46fbcaa0$var$restoreTarget = null, $081ef12b46fbcaa0$var$restoreQueue = null;
function $081ef12b46fbcaa0$var$restoreStateOfTarget(target) {
    var internalInstance = $081ef12b46fbcaa0$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$081ef12b46fbcaa0$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $081ef12b46fbcaa0$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$081ef12b46fbcaa0$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(90));
                            $081ef12b46fbcaa0$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $081ef12b46fbcaa0$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $081ef12b46fbcaa0$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $081ef12b46fbcaa0$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $081ef12b46fbcaa0$var$isInsideEventHandler = !1;
function $081ef12b46fbcaa0$var$batchedUpdates$1(fn, a, b) {
    if ($081ef12b46fbcaa0$var$isInsideEventHandler) return fn(a, b);
    $081ef12b46fbcaa0$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($081ef12b46fbcaa0$var$isInsideEventHandler = !1, null !== $081ef12b46fbcaa0$var$restoreTarget || null !== $081ef12b46fbcaa0$var$restoreQueue) {
            if ($081ef12b46fbcaa0$var$flushSyncWork$1(), $081ef12b46fbcaa0$var$restoreTarget && (a = $081ef12b46fbcaa0$var$restoreTarget, fn = $081ef12b46fbcaa0$var$restoreQueue, $081ef12b46fbcaa0$var$restoreQueue = $081ef12b46fbcaa0$var$restoreTarget = null, $081ef12b46fbcaa0$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$081ef12b46fbcaa0$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $081ef12b46fbcaa0$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$081ef12b46fbcaa0$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $081ef12b46fbcaa0$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $081ef12b46fbcaa0$var$passiveBrowserEventsSupported = !1;
if ($081ef12b46fbcaa0$var$canUseDOM) try {
    var $081ef12b46fbcaa0$var$options = {};
    Object.defineProperty($081ef12b46fbcaa0$var$options, "passive", {
        get: function() {
            $081ef12b46fbcaa0$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $081ef12b46fbcaa0$var$options, $081ef12b46fbcaa0$var$options);
    window.removeEventListener("test", $081ef12b46fbcaa0$var$options, $081ef12b46fbcaa0$var$options);
} catch (e) {
    $081ef12b46fbcaa0$var$passiveBrowserEventsSupported = !1;
}
var $081ef12b46fbcaa0$var$root = null, $081ef12b46fbcaa0$var$startText = null, $081ef12b46fbcaa0$var$fallbackText = null;
function $081ef12b46fbcaa0$var$getData() {
    if ($081ef12b46fbcaa0$var$fallbackText) return $081ef12b46fbcaa0$var$fallbackText;
    var start, startValue = $081ef12b46fbcaa0$var$startText, startLength = startValue.length, end, endValue = "value" in $081ef12b46fbcaa0$var$root ? $081ef12b46fbcaa0$var$root.value : $081ef12b46fbcaa0$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $081ef12b46fbcaa0$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $081ef12b46fbcaa0$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $081ef12b46fbcaa0$var$functionThatReturnsTrue() {
    return !0;
}
function $081ef12b46fbcaa0$var$functionThatReturnsFalse() {
    return !1;
}
function $081ef12b46fbcaa0$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $081ef12b46fbcaa0$var$functionThatReturnsTrue : $081ef12b46fbcaa0$var$functionThatReturnsFalse;
        this.isPropagationStopped = $081ef12b46fbcaa0$var$functionThatReturnsFalse;
        return this;
    }
    $081ef12b46fbcaa0$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $081ef12b46fbcaa0$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $081ef12b46fbcaa0$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $081ef12b46fbcaa0$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $081ef12b46fbcaa0$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $081ef12b46fbcaa0$var$SyntheticEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$EventInterface), $081ef12b46fbcaa0$var$UIEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    view: 0,
    detail: 0
}), $081ef12b46fbcaa0$var$SyntheticUIEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$UIEventInterface), $081ef12b46fbcaa0$var$lastMovementX, $081ef12b46fbcaa0$var$lastMovementY, $081ef12b46fbcaa0$var$lastMouseEvent, $081ef12b46fbcaa0$var$MouseEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $081ef12b46fbcaa0$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $081ef12b46fbcaa0$var$lastMouseEvent && ($081ef12b46fbcaa0$var$lastMouseEvent && "mousemove" === event.type ? ($081ef12b46fbcaa0$var$lastMovementX = event.screenX - $081ef12b46fbcaa0$var$lastMouseEvent.screenX, $081ef12b46fbcaa0$var$lastMovementY = event.screenY - $081ef12b46fbcaa0$var$lastMouseEvent.screenY) : $081ef12b46fbcaa0$var$lastMovementY = $081ef12b46fbcaa0$var$lastMovementX = 0, $081ef12b46fbcaa0$var$lastMouseEvent = event);
        return $081ef12b46fbcaa0$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $081ef12b46fbcaa0$var$lastMovementY;
    }
}), $081ef12b46fbcaa0$var$SyntheticMouseEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$MouseEventInterface), $081ef12b46fbcaa0$var$DragEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$MouseEventInterface, {
    dataTransfer: 0
}), $081ef12b46fbcaa0$var$SyntheticDragEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$DragEventInterface), $081ef12b46fbcaa0$var$FocusEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    relatedTarget: 0
}), $081ef12b46fbcaa0$var$SyntheticFocusEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$FocusEventInterface), $081ef12b46fbcaa0$var$AnimationEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $081ef12b46fbcaa0$var$SyntheticAnimationEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$AnimationEventInterface), $081ef12b46fbcaa0$var$ClipboardEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $081ef12b46fbcaa0$var$SyntheticClipboardEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$ClipboardEventInterface), $081ef12b46fbcaa0$var$CompositionEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    data: 0
}), $081ef12b46fbcaa0$var$SyntheticCompositionEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$CompositionEventInterface), $081ef12b46fbcaa0$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $081ef12b46fbcaa0$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $081ef12b46fbcaa0$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $081ef12b46fbcaa0$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $081ef12b46fbcaa0$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $081ef12b46fbcaa0$var$getEventModifierState() {
    return $081ef12b46fbcaa0$var$modifierStateGetter;
}
var $081ef12b46fbcaa0$var$KeyboardEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $081ef12b46fbcaa0$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $081ef12b46fbcaa0$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $081ef12b46fbcaa0$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $081ef12b46fbcaa0$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $081ef12b46fbcaa0$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $081ef12b46fbcaa0$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $081ef12b46fbcaa0$var$SyntheticKeyboardEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$KeyboardEventInterface), $081ef12b46fbcaa0$var$PointerEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $081ef12b46fbcaa0$var$SyntheticPointerEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$PointerEventInterface), $081ef12b46fbcaa0$var$TouchEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $081ef12b46fbcaa0$var$getEventModifierState
}), $081ef12b46fbcaa0$var$SyntheticTouchEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$TouchEventInterface), $081ef12b46fbcaa0$var$TransitionEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $081ef12b46fbcaa0$var$SyntheticTransitionEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$TransitionEventInterface), $081ef12b46fbcaa0$var$WheelEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $081ef12b46fbcaa0$var$SyntheticWheelEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$WheelEventInterface), $081ef12b46fbcaa0$var$ToggleEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $081ef12b46fbcaa0$var$SyntheticToggleEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$ToggleEventInterface), $081ef12b46fbcaa0$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $081ef12b46fbcaa0$var$canUseCompositionEvent = $081ef12b46fbcaa0$var$canUseDOM && "CompositionEvent" in window, $081ef12b46fbcaa0$var$documentMode = null;
$081ef12b46fbcaa0$var$canUseDOM && "documentMode" in document && ($081ef12b46fbcaa0$var$documentMode = document.documentMode);
var $081ef12b46fbcaa0$var$canUseTextInputEvent = $081ef12b46fbcaa0$var$canUseDOM && "TextEvent" in window && !$081ef12b46fbcaa0$var$documentMode, $081ef12b46fbcaa0$var$useFallbackCompositionData = $081ef12b46fbcaa0$var$canUseDOM && (!$081ef12b46fbcaa0$var$canUseCompositionEvent || $081ef12b46fbcaa0$var$documentMode && 8 < $081ef12b46fbcaa0$var$documentMode && 11 >= $081ef12b46fbcaa0$var$documentMode), $081ef12b46fbcaa0$var$SPACEBAR_CHAR = String.fromCharCode(32), $081ef12b46fbcaa0$var$hasSpaceKeypress = !1;
function $081ef12b46fbcaa0$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $081ef12b46fbcaa0$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $081ef12b46fbcaa0$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $081ef12b46fbcaa0$var$isComposing = !1;
function $081ef12b46fbcaa0$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $081ef12b46fbcaa0$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $081ef12b46fbcaa0$var$hasSpaceKeypress = !0;
            return $081ef12b46fbcaa0$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $081ef12b46fbcaa0$var$SPACEBAR_CHAR && $081ef12b46fbcaa0$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $081ef12b46fbcaa0$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($081ef12b46fbcaa0$var$isComposing) return "compositionend" === domEventName || !$081ef12b46fbcaa0$var$canUseCompositionEvent && $081ef12b46fbcaa0$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $081ef12b46fbcaa0$var$getData(), $081ef12b46fbcaa0$var$fallbackText = $081ef12b46fbcaa0$var$startText = $081ef12b46fbcaa0$var$root = null, $081ef12b46fbcaa0$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $081ef12b46fbcaa0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $081ef12b46fbcaa0$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $081ef12b46fbcaa0$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$081ef12b46fbcaa0$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $081ef12b46fbcaa0$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $081ef12b46fbcaa0$var$restoreTarget ? $081ef12b46fbcaa0$var$restoreQueue ? $081ef12b46fbcaa0$var$restoreQueue.push(target) : $081ef12b46fbcaa0$var$restoreQueue = [
        target
    ] : $081ef12b46fbcaa0$var$restoreTarget = target;
    inst = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $081ef12b46fbcaa0$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $081ef12b46fbcaa0$var$activeElement$1 = null, $081ef12b46fbcaa0$var$activeElementInst$1 = null;
function $081ef12b46fbcaa0$var$runEventInBatch(dispatchQueue) {
    $081ef12b46fbcaa0$var$processDispatchQueue(dispatchQueue, 0);
}
function $081ef12b46fbcaa0$var$getInstIfValueChanged(targetInst) {
    var targetNode = $081ef12b46fbcaa0$var$getNodeFromInstance(targetInst);
    if ($081ef12b46fbcaa0$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $081ef12b46fbcaa0$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $081ef12b46fbcaa0$var$isInputEventSupported = !1;
if ($081ef12b46fbcaa0$var$canUseDOM) {
    var $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$282;
    if ($081ef12b46fbcaa0$var$canUseDOM) {
        var $081ef12b46fbcaa0$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$081ef12b46fbcaa0$var$isSupported$jscomp$inline_417) {
            var $081ef12b46fbcaa0$var$element$jscomp$inline_418 = document.createElement("div");
            $081ef12b46fbcaa0$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $081ef12b46fbcaa0$var$isSupported$jscomp$inline_417 = "function" === typeof $081ef12b46fbcaa0$var$element$jscomp$inline_418.oninput;
        }
        $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$282 = $081ef12b46fbcaa0$var$isSupported$jscomp$inline_417;
    } else $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$282 = !1;
    $081ef12b46fbcaa0$var$isInputEventSupported = $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $081ef12b46fbcaa0$var$stopWatchingForValueChange() {
    $081ef12b46fbcaa0$var$activeElement$1 && ($081ef12b46fbcaa0$var$activeElement$1.detachEvent("onpropertychange", $081ef12b46fbcaa0$var$handlePropertyChange), $081ef12b46fbcaa0$var$activeElementInst$1 = $081ef12b46fbcaa0$var$activeElement$1 = null);
}
function $081ef12b46fbcaa0$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $081ef12b46fbcaa0$var$getInstIfValueChanged($081ef12b46fbcaa0$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $081ef12b46fbcaa0$var$createAndAccumulateChangeEvent(dispatchQueue, $081ef12b46fbcaa0$var$activeElementInst$1, nativeEvent, $081ef12b46fbcaa0$var$getEventTarget(nativeEvent));
        $081ef12b46fbcaa0$var$batchedUpdates$1($081ef12b46fbcaa0$var$runEventInBatch, dispatchQueue);
    }
}
function $081ef12b46fbcaa0$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($081ef12b46fbcaa0$var$stopWatchingForValueChange(), $081ef12b46fbcaa0$var$activeElement$1 = target, $081ef12b46fbcaa0$var$activeElementInst$1 = targetInst, $081ef12b46fbcaa0$var$activeElement$1.attachEvent("onpropertychange", $081ef12b46fbcaa0$var$handlePropertyChange)) : "focusout" === domEventName && $081ef12b46fbcaa0$var$stopWatchingForValueChange();
}
function $081ef12b46fbcaa0$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $081ef12b46fbcaa0$var$getInstIfValueChanged($081ef12b46fbcaa0$var$activeElementInst$1);
}
function $081ef12b46fbcaa0$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $081ef12b46fbcaa0$var$getInstIfValueChanged(targetInst);
}
function $081ef12b46fbcaa0$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $081ef12b46fbcaa0$var$getInstIfValueChanged(targetInst);
}
function $081ef12b46fbcaa0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $081ef12b46fbcaa0$var$objectIs = "function" === typeof Object.is ? Object.is : $081ef12b46fbcaa0$var$is;
function $081ef12b46fbcaa0$var$shallowEqual(objA, objB) {
    if ($081ef12b46fbcaa0$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$081ef12b46fbcaa0$var$hasOwnProperty.call(objB, currentKey) || !$081ef12b46fbcaa0$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $081ef12b46fbcaa0$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $081ef12b46fbcaa0$var$getNodeForCharacterOffset(root, offset) {
    var node = $081ef12b46fbcaa0$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $081ef12b46fbcaa0$var$getLeafNode(node);
    }
}
function $081ef12b46fbcaa0$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $081ef12b46fbcaa0$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $081ef12b46fbcaa0$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $081ef12b46fbcaa0$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $081ef12b46fbcaa0$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $081ef12b46fbcaa0$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $081ef12b46fbcaa0$var$skipSelectionChangeEvent = $081ef12b46fbcaa0$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $081ef12b46fbcaa0$var$activeElement = null, $081ef12b46fbcaa0$var$activeElementInst = null, $081ef12b46fbcaa0$var$lastSelection = null, $081ef12b46fbcaa0$var$mouseDown = !1;
function $081ef12b46fbcaa0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $081ef12b46fbcaa0$var$mouseDown || null == $081ef12b46fbcaa0$var$activeElement || $081ef12b46fbcaa0$var$activeElement !== $081ef12b46fbcaa0$var$getActiveElement(doc) || (doc = $081ef12b46fbcaa0$var$activeElement, "selectionStart" in doc && $081ef12b46fbcaa0$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $081ef12b46fbcaa0$var$lastSelection && $081ef12b46fbcaa0$var$shallowEqual($081ef12b46fbcaa0$var$lastSelection, doc) || ($081ef12b46fbcaa0$var$lastSelection = doc, doc = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners($081ef12b46fbcaa0$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $081ef12b46fbcaa0$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $081ef12b46fbcaa0$var$activeElement)));
}
function $081ef12b46fbcaa0$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $081ef12b46fbcaa0$var$vendorPrefixes = {
    animationend: $081ef12b46fbcaa0$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $081ef12b46fbcaa0$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $081ef12b46fbcaa0$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionEnd")
}, $081ef12b46fbcaa0$var$prefixedEventNames = {}, $081ef12b46fbcaa0$var$style = {};
$081ef12b46fbcaa0$var$canUseDOM && ($081ef12b46fbcaa0$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $081ef12b46fbcaa0$var$vendorPrefixes.animationend.animation, delete $081ef12b46fbcaa0$var$vendorPrefixes.animationiteration.animation, delete $081ef12b46fbcaa0$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $081ef12b46fbcaa0$var$vendorPrefixes.transitionend.transition);
function $081ef12b46fbcaa0$var$getVendorPrefixedEventName(eventName) {
    if ($081ef12b46fbcaa0$var$prefixedEventNames[eventName]) return $081ef12b46fbcaa0$var$prefixedEventNames[eventName];
    if (!$081ef12b46fbcaa0$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $081ef12b46fbcaa0$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $081ef12b46fbcaa0$var$style) return $081ef12b46fbcaa0$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $081ef12b46fbcaa0$var$ANIMATION_END = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("animationend"), $081ef12b46fbcaa0$var$ANIMATION_ITERATION = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("animationiteration"), $081ef12b46fbcaa0$var$ANIMATION_START = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("animationstart"), $081ef12b46fbcaa0$var$TRANSITION_RUN = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitionrun"), $081ef12b46fbcaa0$var$TRANSITION_START = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitionstart"), $081ef12b46fbcaa0$var$TRANSITION_CANCEL = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitioncancel"), $081ef12b46fbcaa0$var$TRANSITION_END = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitionend"), $081ef12b46fbcaa0$var$topLevelEventsToReactNames = new Map(), $081ef12b46fbcaa0$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$081ef12b46fbcaa0$var$simpleEventPluginEvents.push("scrollEnd");
function $081ef12b46fbcaa0$var$registerSimpleEvent(domEventName, reactName) {
    $081ef12b46fbcaa0$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $081ef12b46fbcaa0$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $081ef12b46fbcaa0$var$CapturedStacks = new WeakMap();
function $081ef12b46fbcaa0$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $081ef12b46fbcaa0$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $081ef12b46fbcaa0$var$getStackByFiberInDevAndProd(source)
        };
        $081ef12b46fbcaa0$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $081ef12b46fbcaa0$var$getStackByFiberInDevAndProd(source)
    };
}
var $081ef12b46fbcaa0$var$concurrentQueues = [], $081ef12b46fbcaa0$var$concurrentQueuesIndex = 0, $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes = 0;
function $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $081ef12b46fbcaa0$var$concurrentQueuesIndex, i = $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes = $081ef12b46fbcaa0$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        var queue = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        var update = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        var lane = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $081ef12b46fbcaa0$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = fiber;
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = queue;
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = update;
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = lane;
    $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
}
function $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, null, null, lane);
    return $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
}
function $081ef12b46fbcaa0$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $081ef12b46fbcaa0$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $081ef12b46fbcaa0$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $081ef12b46fbcaa0$var$nestedUpdateCount) throw $081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = null, Error($081ef12b46fbcaa0$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $081ef12b46fbcaa0$var$emptyContextObject = {};
function $081ef12b46fbcaa0$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $081ef12b46fbcaa0$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $081ef12b46fbcaa0$var$FiberNode(tag, pendingProps, key, mode);
}
function $081ef12b46fbcaa0$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $081ef12b46fbcaa0$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $081ef12b46fbcaa0$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $081ef12b46fbcaa0$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $081ef12b46fbcaa0$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $081ef12b46fbcaa0$var$isHostHoistableType(type, pendingProps, $081ef12b46fbcaa0$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE:
            return $081ef12b46fbcaa0$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $081ef12b46fbcaa0$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_PROVIDER_TYPE:
                case $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $081ef12b46fbcaa0$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $081ef12b46fbcaa0$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $081ef12b46fbcaa0$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $081ef12b46fbcaa0$var$createFiberFromText(content, mode, lanes) {
    content = $081ef12b46fbcaa0$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $081ef12b46fbcaa0$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $081ef12b46fbcaa0$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $081ef12b46fbcaa0$var$forkStack = [], $081ef12b46fbcaa0$var$forkStackIndex = 0, $081ef12b46fbcaa0$var$treeForkProvider = null, $081ef12b46fbcaa0$var$treeForkCount = 0, $081ef12b46fbcaa0$var$idStack = [], $081ef12b46fbcaa0$var$idStackIndex = 0, $081ef12b46fbcaa0$var$treeContextProvider = null, $081ef12b46fbcaa0$var$treeContextId = 1, $081ef12b46fbcaa0$var$treeContextOverflow = "";
function $081ef12b46fbcaa0$var$pushTreeFork(workInProgress, totalChildren) {
    $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex++] = $081ef12b46fbcaa0$var$treeForkCount;
    $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex++] = $081ef12b46fbcaa0$var$treeForkProvider;
    $081ef12b46fbcaa0$var$treeForkProvider = workInProgress;
    $081ef12b46fbcaa0$var$treeForkCount = totalChildren;
}
function $081ef12b46fbcaa0$var$pushTreeId(workInProgress, totalChildren, index) {
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextId;
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextOverflow;
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextProvider;
    $081ef12b46fbcaa0$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $081ef12b46fbcaa0$var$treeContextId;
    workInProgress = $081ef12b46fbcaa0$var$treeContextOverflow;
    var baseLength = 32 - $081ef12b46fbcaa0$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $081ef12b46fbcaa0$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $081ef12b46fbcaa0$var$treeContextId = 1 << 32 - $081ef12b46fbcaa0$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $081ef12b46fbcaa0$var$treeContextOverflow = length + workInProgress;
    } else $081ef12b46fbcaa0$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $081ef12b46fbcaa0$var$treeContextOverflow = workInProgress;
}
function $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($081ef12b46fbcaa0$var$pushTreeFork(workInProgress, 1), $081ef12b46fbcaa0$var$pushTreeId(workInProgress, 1, 0));
}
function $081ef12b46fbcaa0$var$popTreeContext(workInProgress) {
    for(; workInProgress === $081ef12b46fbcaa0$var$treeForkProvider;)$081ef12b46fbcaa0$var$treeForkProvider = $081ef12b46fbcaa0$var$forkStack[--$081ef12b46fbcaa0$var$forkStackIndex], $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex] = null, $081ef12b46fbcaa0$var$treeForkCount = $081ef12b46fbcaa0$var$forkStack[--$081ef12b46fbcaa0$var$forkStackIndex], $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex] = null;
    for(; workInProgress === $081ef12b46fbcaa0$var$treeContextProvider;)$081ef12b46fbcaa0$var$treeContextProvider = $081ef12b46fbcaa0$var$idStack[--$081ef12b46fbcaa0$var$idStackIndex], $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex] = null, $081ef12b46fbcaa0$var$treeContextOverflow = $081ef12b46fbcaa0$var$idStack[--$081ef12b46fbcaa0$var$idStackIndex], $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex] = null, $081ef12b46fbcaa0$var$treeContextId = $081ef12b46fbcaa0$var$idStack[--$081ef12b46fbcaa0$var$idStackIndex], $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex] = null;
}
var $081ef12b46fbcaa0$var$hydrationParentFiber = null, $081ef12b46fbcaa0$var$nextHydratableInstance = null, $081ef12b46fbcaa0$var$isHydrating = !1, $081ef12b46fbcaa0$var$hydrationErrors = null, $081ef12b46fbcaa0$var$rootOrSingletonContext = !1, $081ef12b46fbcaa0$var$HydrationMismatchException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(519));
function $081ef12b46fbcaa0$var$throwOnHydrationMismatch(fiber) {
    var error = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(418, ""));
    $081ef12b46fbcaa0$var$queueHydrationError($081ef12b46fbcaa0$var$createCapturedValueAtFiber(error, fiber));
    throw $081ef12b46fbcaa0$var$HydrationMismatchException;
}
function $081ef12b46fbcaa0$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$081ef12b46fbcaa0$var$internalInstanceKey] = fiber;
    instance[$081ef12b46fbcaa0$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("cancel", instance);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $081ef12b46fbcaa0$var$mediaEventTypes.length; type++)$081ef12b46fbcaa0$var$listenToNonDelegatedEvent($081ef12b46fbcaa0$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", instance);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", instance);
            $081ef12b46fbcaa0$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $081ef12b46fbcaa0$var$track(instance);
            break;
        case "select":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", instance), $081ef12b46fbcaa0$var$initTextarea(instance, props.value, props.defaultValue, props.children), $081ef12b46fbcaa0$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $081ef12b46fbcaa0$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($081ef12b46fbcaa0$var$listenToNonDelegatedEvent("beforetoggle", instance), $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $081ef12b46fbcaa0$var$noop$1), instance = !0) : instance = !1;
    instance || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(fiber);
}
function $081ef12b46fbcaa0$var$popToNextHostParent(fiber) {
    for($081ef12b46fbcaa0$var$hydrationParentFiber = fiber.return; $081ef12b46fbcaa0$var$hydrationParentFiber;)switch($081ef12b46fbcaa0$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $081ef12b46fbcaa0$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $081ef12b46fbcaa0$var$rootOrSingletonContext = !0;
            return;
        default:
            $081ef12b46fbcaa0$var$hydrationParentFiber = $081ef12b46fbcaa0$var$hydrationParentFiber.return;
    }
}
function $081ef12b46fbcaa0$var$popHydrationState(fiber) {
    if (fiber !== $081ef12b46fbcaa0$var$hydrationParentFiber) return !1;
    if (!$081ef12b46fbcaa0$var$isHydrating) return $081ef12b46fbcaa0$var$popToNextHostParent(fiber), $081ef12b46fbcaa0$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $081ef12b46fbcaa0$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $081ef12b46fbcaa0$var$nextHydratableInstance && $081ef12b46fbcaa0$var$throwOnHydrationMismatch(fiber);
    $081ef12b46fbcaa0$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $081ef12b46fbcaa0$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $081ef12b46fbcaa0$var$nextHydratableInstance, $081ef12b46fbcaa0$var$isSingletonScope(fiber.type) ? (fiber = $081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton, $081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton = null, $081ef12b46fbcaa0$var$nextHydratableInstance = fiber) : $081ef12b46fbcaa0$var$nextHydratableInstance = tag) : $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$hydrationParentFiber ? $081ef12b46fbcaa0$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $081ef12b46fbcaa0$var$resetHydrationState() {
    $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$hydrationParentFiber = null;
    $081ef12b46fbcaa0$var$isHydrating = !1;
}
function $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $081ef12b46fbcaa0$var$hydrationErrors;
    null !== queuedErrors && (null === $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors ? $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = queuedErrors : $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors.push.apply($081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, queuedErrors), $081ef12b46fbcaa0$var$hydrationErrors = null);
    return queuedErrors;
}
function $081ef12b46fbcaa0$var$queueHydrationError(error) {
    null === $081ef12b46fbcaa0$var$hydrationErrors ? $081ef12b46fbcaa0$var$hydrationErrors = [
        error
    ] : $081ef12b46fbcaa0$var$hydrationErrors.push(error);
}
var $081ef12b46fbcaa0$var$valueCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null, $081ef12b46fbcaa0$var$lastContextDependency = null;
function $081ef12b46fbcaa0$var$pushProvider(providerFiber, context, nextValue) {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $081ef12b46fbcaa0$var$popProvider(context) {
    context._currentValue = $081ef12b46fbcaa0$var$valueCursor.current;
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$valueCursor);
}
function $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $081ef12b46fbcaa0$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $081ef12b46fbcaa0$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($081ef12b46fbcaa0$var$HostTransitionContext) : current = [
                $081ef12b46fbcaa0$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $081ef12b46fbcaa0$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$081ef12b46fbcaa0$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = workInProgress;
    $081ef12b46fbcaa0$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $081ef12b46fbcaa0$var$readContext(context) {
    return $081ef12b46fbcaa0$var$readContextForConsumer($081ef12b46fbcaa0$var$currentlyRenderingFiber$1, context);
}
function $081ef12b46fbcaa0$var$readContextDuringReconciliation(consumer, context) {
    null === $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 && $081ef12b46fbcaa0$var$prepareToReadContext(consumer);
    return $081ef12b46fbcaa0$var$readContextForConsumer(consumer, context);
}
function $081ef12b46fbcaa0$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $081ef12b46fbcaa0$var$lastContextDependency) {
        if (null === consumer) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(308));
        $081ef12b46fbcaa0$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$lastContextDependency.next = context;
    return value;
}
var $081ef12b46fbcaa0$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $081ef12b46fbcaa0$var$scheduleCallback$2 = $fndEB.unstable_scheduleCallback, $081ef12b46fbcaa0$var$NormalPriority = $fndEB.unstable_NormalPriority, $081ef12b46fbcaa0$var$CacheContext = {
    $$typeof: $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $081ef12b46fbcaa0$var$createCache() {
    return {
        controller: new $081ef12b46fbcaa0$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $081ef12b46fbcaa0$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $081ef12b46fbcaa0$var$scheduleCallback$2($081ef12b46fbcaa0$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $081ef12b46fbcaa0$var$currentEntangledListeners = null, $081ef12b46fbcaa0$var$currentEntangledPendingCount = 0, $081ef12b46fbcaa0$var$currentEntangledLane = 0, $081ef12b46fbcaa0$var$currentEntangledActionThenable = null;
function $081ef12b46fbcaa0$var$entangleAsyncAction(transition, thenable) {
    if (null === $081ef12b46fbcaa0$var$currentEntangledListeners) {
        var entangledListeners = $081ef12b46fbcaa0$var$currentEntangledListeners = [];
        $081ef12b46fbcaa0$var$currentEntangledPendingCount = 0;
        $081ef12b46fbcaa0$var$currentEntangledLane = $081ef12b46fbcaa0$var$requestTransitionLane();
        $081ef12b46fbcaa0$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $081ef12b46fbcaa0$var$currentEntangledPendingCount++;
    thenable.then($081ef12b46fbcaa0$var$pingEngtangledActionScope, $081ef12b46fbcaa0$var$pingEngtangledActionScope);
    return thenable;
}
function $081ef12b46fbcaa0$var$pingEngtangledActionScope() {
    if (0 === --$081ef12b46fbcaa0$var$currentEntangledPendingCount && null !== $081ef12b46fbcaa0$var$currentEntangledListeners) {
        null !== $081ef12b46fbcaa0$var$currentEntangledActionThenable && ($081ef12b46fbcaa0$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $081ef12b46fbcaa0$var$currentEntangledListeners;
        $081ef12b46fbcaa0$var$currentEntangledListeners = null;
        $081ef12b46fbcaa0$var$currentEntangledLane = 0;
        $081ef12b46fbcaa0$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $081ef12b46fbcaa0$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $081ef12b46fbcaa0$var$prevOnStartTransitionFinish = $081ef12b46fbcaa0$var$ReactSharedInternals.S;
$081ef12b46fbcaa0$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $081ef12b46fbcaa0$var$entangleAsyncAction(transition, returnValue);
    null !== $081ef12b46fbcaa0$var$prevOnStartTransitionFinish && $081ef12b46fbcaa0$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $081ef12b46fbcaa0$var$resumedCache = $081ef12b46fbcaa0$var$createCursor(null);
function $081ef12b46fbcaa0$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $081ef12b46fbcaa0$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $081ef12b46fbcaa0$var$workInProgressRoot.pooledCache;
}
function $081ef12b46fbcaa0$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$resumedCache, $081ef12b46fbcaa0$var$resumedCache.current) : $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$resumedCache, prevCachePool.pool);
}
function $081ef12b46fbcaa0$var$getSuspendedCache() {
    var cacheFromPool = $081ef12b46fbcaa0$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $081ef12b46fbcaa0$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $081ef12b46fbcaa0$var$SuspenseException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(460)), $081ef12b46fbcaa0$var$SuspenseyCommitException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(474)), $081ef12b46fbcaa0$var$SuspenseActionException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(542)), $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $081ef12b46fbcaa0$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $081ef12b46fbcaa0$var$noop$3() {}
function $081ef12b46fbcaa0$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($081ef12b46fbcaa0$var$noop$3, $081ef12b46fbcaa0$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $081ef12b46fbcaa0$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($081ef12b46fbcaa0$var$noop$3, $081ef12b46fbcaa0$var$noop$3);
            else {
                thenableState = $081ef12b46fbcaa0$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $081ef12b46fbcaa0$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $081ef12b46fbcaa0$var$suspendedThenable = thenable;
            throw $081ef12b46fbcaa0$var$SuspenseException;
    }
}
var $081ef12b46fbcaa0$var$suspendedThenable = null;
function $081ef12b46fbcaa0$var$getSuspendedThenable() {
    if (null === $081ef12b46fbcaa0$var$suspendedThenable) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(459));
    var thenable = $081ef12b46fbcaa0$var$suspendedThenable;
    $081ef12b46fbcaa0$var$suspendedThenable = null;
    return thenable;
}
function $081ef12b46fbcaa0$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $081ef12b46fbcaa0$var$SuspenseException || rejectedReason === $081ef12b46fbcaa0$var$SuspenseActionException) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(483));
}
var $081ef12b46fbcaa0$var$hasForceUpdate = !1;
function $081ef12b46fbcaa0$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $081ef12b46fbcaa0$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $081ef12b46fbcaa0$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
        $081ef12b46fbcaa0$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
}
function $081ef12b46fbcaa0$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $081ef12b46fbcaa0$var$markRootEntangled(root, lane);
    }
}
function $081ef12b46fbcaa0$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction = !1;
function $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $081ef12b46fbcaa0$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $081ef12b46fbcaa0$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $081ef12b46fbcaa0$var$currentEntangledLane && ($081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $081ef12b46fbcaa0$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $081ef12b46fbcaa0$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $081ef12b46fbcaa0$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $081ef12b46fbcaa0$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$081ef12b46fbcaa0$var$callCallback(callbacks[updateQueue], context);
}
var $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor = $081ef12b46fbcaa0$var$createCursor(0);
function $081ef12b46fbcaa0$var$pushHiddenContext(fiber, context) {
    fiber = $081ef12b46fbcaa0$var$entangledRenderLanes;
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor, fiber);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$currentTreeHiddenStackCursor, context);
    $081ef12b46fbcaa0$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $081ef12b46fbcaa0$var$reuseHiddenContextOnStack() {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor, $081ef12b46fbcaa0$var$entangledRenderLanes);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$currentTreeHiddenStackCursor, $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current);
}
function $081ef12b46fbcaa0$var$popHiddenContext() {
    $081ef12b46fbcaa0$var$entangledRenderLanes = $081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor.current;
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$currentTreeHiddenStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor);
}
var $081ef12b46fbcaa0$var$renderLanes = 0, $081ef12b46fbcaa0$var$currentlyRenderingFiber = null, $081ef12b46fbcaa0$var$currentHook = null, $081ef12b46fbcaa0$var$workInProgressHook = null, $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !1, $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $081ef12b46fbcaa0$var$localIdCounter = 0, $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0, $081ef12b46fbcaa0$var$thenableState$1 = null, $081ef12b46fbcaa0$var$globalClientIdCounter = 0;
function $081ef12b46fbcaa0$var$throwInvalidHookError() {
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(321));
}
function $081ef12b46fbcaa0$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$081ef12b46fbcaa0$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $081ef12b46fbcaa0$var$renderLanes = nextRenderLanes;
    $081ef12b46fbcaa0$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $081ef12b46fbcaa0$var$HooksDispatcherOnMount : $081ef12b46fbcaa0$var$HooksDispatcherOnUpdate;
    $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $081ef12b46fbcaa0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $081ef12b46fbcaa0$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $081ef12b46fbcaa0$var$finishRenderingHooks(current) {
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $081ef12b46fbcaa0$var$currentHook && null !== $081ef12b46fbcaa0$var$currentHook.next;
    $081ef12b46fbcaa0$var$renderLanes = 0;
    $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$currentHook = $081ef12b46fbcaa0$var$currentlyRenderingFiber = null;
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !1;
    $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0;
    $081ef12b46fbcaa0$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(300));
    null === current || $081ef12b46fbcaa0$var$didReceiveUpdate || (current = current.dependencies, null !== current && $081ef12b46fbcaa0$var$checkIfContextChanged(current) && ($081ef12b46fbcaa0$var$didReceiveUpdate = !0));
}
function $081ef12b46fbcaa0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass && ($081ef12b46fbcaa0$var$thenableState$1 = null);
        $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0;
        $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $081ef12b46fbcaa0$var$TransitionAwareHostComponent() {
    var dispatcher = $081ef12b46fbcaa0$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $081ef12b46fbcaa0$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $081ef12b46fbcaa0$var$currentHook ? $081ef12b46fbcaa0$var$currentHook.memoizedState : null) !== dispatcher && ($081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $081ef12b46fbcaa0$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $081ef12b46fbcaa0$var$localIdCounter;
    $081ef12b46fbcaa0$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $081ef12b46fbcaa0$var$resetHooksOnUnwind(workInProgress) {
    if ($081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !1;
    }
    $081ef12b46fbcaa0$var$renderLanes = 0;
    $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$currentHook = $081ef12b46fbcaa0$var$currentlyRenderingFiber = null;
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $081ef12b46fbcaa0$var$thenableIndexCounter$1 = $081ef12b46fbcaa0$var$localIdCounter = 0;
    $081ef12b46fbcaa0$var$thenableState$1 = null;
}
function $081ef12b46fbcaa0$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $081ef12b46fbcaa0$var$workInProgressHook ? $081ef12b46fbcaa0$var$currentlyRenderingFiber.memoizedState = $081ef12b46fbcaa0$var$workInProgressHook = hook : $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$workInProgressHook.next = hook;
    return $081ef12b46fbcaa0$var$workInProgressHook;
}
function $081ef12b46fbcaa0$var$updateWorkInProgressHook() {
    if (null === $081ef12b46fbcaa0$var$currentHook) {
        var nextCurrentHook = $081ef12b46fbcaa0$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $081ef12b46fbcaa0$var$currentHook.next;
    var nextWorkInProgressHook = null === $081ef12b46fbcaa0$var$workInProgressHook ? $081ef12b46fbcaa0$var$currentlyRenderingFiber.memoizedState : $081ef12b46fbcaa0$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $081ef12b46fbcaa0$var$workInProgressHook = nextWorkInProgressHook, $081ef12b46fbcaa0$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $081ef12b46fbcaa0$var$currentlyRenderingFiber.alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(467));
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(310));
        }
        $081ef12b46fbcaa0$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $081ef12b46fbcaa0$var$currentHook.memoizedState,
            baseState: $081ef12b46fbcaa0$var$currentHook.baseState,
            baseQueue: $081ef12b46fbcaa0$var$currentHook.baseQueue,
            queue: $081ef12b46fbcaa0$var$currentHook.queue,
            next: null
        };
        null === $081ef12b46fbcaa0$var$workInProgressHook ? $081ef12b46fbcaa0$var$currentlyRenderingFiber.memoizedState = $081ef12b46fbcaa0$var$workInProgressHook = nextCurrentHook : $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$workInProgressHook.next = nextCurrentHook;
    }
    return $081ef12b46fbcaa0$var$workInProgressHook;
}
function $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $081ef12b46fbcaa0$var$useThenable(thenable) {
    var index = $081ef12b46fbcaa0$var$thenableIndexCounter$1;
    $081ef12b46fbcaa0$var$thenableIndexCounter$1 += 1;
    null === $081ef12b46fbcaa0$var$thenableState$1 && ($081ef12b46fbcaa0$var$thenableState$1 = []);
    thenable = $081ef12b46fbcaa0$var$trackUsedThenable($081ef12b46fbcaa0$var$thenableState$1, thenable, index);
    index = $081ef12b46fbcaa0$var$currentlyRenderingFiber;
    null === (null === $081ef12b46fbcaa0$var$workInProgressHook ? index.memoizedState : $081ef12b46fbcaa0$var$workInProgressHook.next) && (index = index.alternate, $081ef12b46fbcaa0$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $081ef12b46fbcaa0$var$HooksDispatcherOnMount : $081ef12b46fbcaa0$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $081ef12b46fbcaa0$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $081ef12b46fbcaa0$var$useThenable(usable);
        if (usable.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return $081ef12b46fbcaa0$var$readContext(usable);
    }
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(438, String(usable)));
}
function $081ef12b46fbcaa0$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $081ef12b46fbcaa0$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $081ef12b46fbcaa0$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $081ef12b46fbcaa0$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $081ef12b46fbcaa0$var$updateReducer(reducer) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    return $081ef12b46fbcaa0$var$updateReducerImpl(hook, $081ef12b46fbcaa0$var$currentHook, reducer);
}
function $081ef12b46fbcaa0$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($081ef12b46fbcaa0$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $081ef12b46fbcaa0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($081ef12b46fbcaa0$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $081ef12b46fbcaa0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= revertLane, $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= updateLane, $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$081ef12b46fbcaa0$var$objectIs(pendingQueue, hook.memoizedState) && ($081ef12b46fbcaa0$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $081ef12b46fbcaa0$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $081ef12b46fbcaa0$var$rerenderReducer(reducer) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $081ef12b46fbcaa0$var$objectIs(newState, hook.memoizedState) || ($081ef12b46fbcaa0$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $081ef12b46fbcaa0$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $081ef12b46fbcaa0$var$currentlyRenderingFiber, hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $081ef12b46fbcaa0$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$081ef12b46fbcaa0$var$objectIs(($081ef12b46fbcaa0$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $081ef12b46fbcaa0$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $081ef12b46fbcaa0$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $081ef12b46fbcaa0$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $081ef12b46fbcaa0$var$workInProgressHook && $081ef12b46fbcaa0$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $081ef12b46fbcaa0$var$pushSimpleEffect(9, $081ef12b46fbcaa0$var$createEffectInstance(), $081ef12b46fbcaa0$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $081ef12b46fbcaa0$var$workInProgressRoot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($081ef12b46fbcaa0$var$renderLanes & 124) || $081ef12b46fbcaa0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $081ef12b46fbcaa0$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $081ef12b46fbcaa0$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $081ef12b46fbcaa0$var$checkIfSnapshotChanged(inst) && $081ef12b46fbcaa0$var$forceStoreRerender(fiber);
}
function $081ef12b46fbcaa0$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $081ef12b46fbcaa0$var$checkIfSnapshotChanged(inst) && $081ef12b46fbcaa0$var$forceStoreRerender(fiber);
    });
}
function $081ef12b46fbcaa0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$081ef12b46fbcaa0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $081ef12b46fbcaa0$var$forceStoreRerender(fiber) {
    var root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $081ef12b46fbcaa0$var$mountStateImpl(initialState) {
    var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $081ef12b46fbcaa0$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $081ef12b46fbcaa0$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $081ef12b46fbcaa0$var$updateReducerImpl(hook, $081ef12b46fbcaa0$var$currentHook, "function" === typeof reducer ? reducer : $081ef12b46fbcaa0$var$basicStateReducer);
}
function $081ef12b46fbcaa0$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $081ef12b46fbcaa0$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $081ef12b46fbcaa0$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $081ef12b46fbcaa0$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T, currentTransition = {};
        $081ef12b46fbcaa0$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $081ef12b46fbcaa0$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $081ef12b46fbcaa0$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $081ef12b46fbcaa0$var$onActionError(actionQueue, node, error);
        } finally{
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $081ef12b46fbcaa0$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $081ef12b46fbcaa0$var$onActionError(actionQueue, node, error$38);
    }
}
function $081ef12b46fbcaa0$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $081ef12b46fbcaa0$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $081ef12b46fbcaa0$var$onActionError(actionQueue, node, error);
    }) : $081ef12b46fbcaa0$var$onActionSuccess(actionQueue, node, returnValue);
}
function $081ef12b46fbcaa0$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $081ef12b46fbcaa0$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $081ef12b46fbcaa0$var$runActionStateAction(actionQueue, nextState)));
}
function $081ef12b46fbcaa0$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $081ef12b46fbcaa0$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $081ef12b46fbcaa0$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $081ef12b46fbcaa0$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $081ef12b46fbcaa0$var$mountActionState(action, initialStateProp) {
    if ($081ef12b46fbcaa0$var$isHydrating) {
        var ssrFormState = $081ef12b46fbcaa0$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $081ef12b46fbcaa0$var$currentlyRenderingFiber;
                if ($081ef12b46fbcaa0$var$isHydrating) {
                    if ($081ef12b46fbcaa0$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $081ef12b46fbcaa0$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $081ef12b46fbcaa0$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $081ef12b46fbcaa0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $081ef12b46fbcaa0$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $081ef12b46fbcaa0$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $081ef12b46fbcaa0$var$dispatchSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $081ef12b46fbcaa0$var$mountStateImpl(!1);
    inRootOrSingleton = $081ef12b46fbcaa0$var$dispatchOptimisticSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $081ef12b46fbcaa0$var$dispatchActionState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $081ef12b46fbcaa0$var$updateActionState(action) {
    var stateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    return $081ef12b46fbcaa0$var$updateActionStateImpl(stateHook, $081ef12b46fbcaa0$var$currentHook, action);
}
function $081ef12b46fbcaa0$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $081ef12b46fbcaa0$var$updateReducerImpl(stateHook, currentStateHook, $081ef12b46fbcaa0$var$actionStateReducer)[0];
    stateHook = $081ef12b46fbcaa0$var$updateReducer($081ef12b46fbcaa0$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $081ef12b46fbcaa0$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $081ef12b46fbcaa0$var$SuspenseException) throw $081ef12b46fbcaa0$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= 2048, $081ef12b46fbcaa0$var$pushSimpleEffect(9, $081ef12b46fbcaa0$var$createEffectInstance(), $081ef12b46fbcaa0$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $081ef12b46fbcaa0$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $081ef12b46fbcaa0$var$rerenderActionState(action) {
    var stateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook(), currentStateHook = $081ef12b46fbcaa0$var$currentHook;
    if (null !== currentStateHook) return $081ef12b46fbcaa0$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $081ef12b46fbcaa0$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $081ef12b46fbcaa0$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $081ef12b46fbcaa0$var$updateRef() {
    return $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
}
function $081ef12b46fbcaa0$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $081ef12b46fbcaa0$var$pushSimpleEffect(1 | hookFlags, $081ef12b46fbcaa0$var$createEffectInstance(), create, createDeps);
}
function $081ef12b46fbcaa0$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $081ef12b46fbcaa0$var$currentHook && null !== deps && $081ef12b46fbcaa0$var$areHookInputsEqual(deps, $081ef12b46fbcaa0$var$currentHook.memoizedState.deps) ? hook.memoizedState = $081ef12b46fbcaa0$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $081ef12b46fbcaa0$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $081ef12b46fbcaa0$var$mountEffect(create, createDeps) {
    $081ef12b46fbcaa0$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $081ef12b46fbcaa0$var$updateEffect(create, createDeps) {
    $081ef12b46fbcaa0$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $081ef12b46fbcaa0$var$updateInsertionEffect(create, deps) {
    return $081ef12b46fbcaa0$var$updateEffectImpl(4, 2, create, deps);
}
function $081ef12b46fbcaa0$var$updateLayoutEffect(create, deps) {
    return $081ef12b46fbcaa0$var$updateEffectImpl(4, 4, create, deps);
}
function $081ef12b46fbcaa0$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $081ef12b46fbcaa0$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $081ef12b46fbcaa0$var$updateEffectImpl(4, 4, $081ef12b46fbcaa0$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $081ef12b46fbcaa0$var$mountDebugValue() {}
function $081ef12b46fbcaa0$var$updateCallback(callback, deps) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $081ef12b46fbcaa0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $081ef12b46fbcaa0$var$updateMemo(nextCreate, deps) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $081ef12b46fbcaa0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($081ef12b46fbcaa0$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $081ef12b46fbcaa0$var$requestDeferredLane();
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= hook;
    $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $081ef12b46fbcaa0$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($081ef12b46fbcaa0$var$objectIs(value, prevValue)) return value;
    if (null !== $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current) return hook = $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue), $081ef12b46fbcaa0$var$objectIs(hook, prevValue) || ($081ef12b46fbcaa0$var$didReceiveUpdate = !0), hook;
    if (0 === ($081ef12b46fbcaa0$var$renderLanes & 42)) return $081ef12b46fbcaa0$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $081ef12b46fbcaa0$var$requestDeferredLane();
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= hook;
    $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $081ef12b46fbcaa0$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T, currentTransition = {};
    $081ef12b46fbcaa0$var$ReactSharedInternals.T = currentTransition;
    $081ef12b46fbcaa0$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $081ef12b46fbcaa0$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $081ef12b46fbcaa0$var$chainThenableValue(returnValue, finishedState);
            $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $081ef12b46fbcaa0$var$requestUpdateLane(fiber));
        } else $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, finishedState, $081ef12b46fbcaa0$var$requestUpdateLane(fiber));
    } catch (error) {
        $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $081ef12b46fbcaa0$var$requestUpdateLane());
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $081ef12b46fbcaa0$var$noop$2() {}
function $081ef12b46fbcaa0$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(476));
    var queue = $081ef12b46fbcaa0$var$ensureFormComponentIsStateful(formFiber).queue;
    $081ef12b46fbcaa0$var$startTransition(formFiber, queue, pendingState, $081ef12b46fbcaa0$var$sharedNotPendingObject, null === action ? $081ef12b46fbcaa0$var$noop$2 : function() {
        $081ef12b46fbcaa0$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $081ef12b46fbcaa0$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $081ef12b46fbcaa0$var$sharedNotPendingObject,
        baseState: $081ef12b46fbcaa0$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $081ef12b46fbcaa0$var$basicStateReducer,
            lastRenderedState: $081ef12b46fbcaa0$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $081ef12b46fbcaa0$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $081ef12b46fbcaa0$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $081ef12b46fbcaa0$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $081ef12b46fbcaa0$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $081ef12b46fbcaa0$var$requestUpdateLane());
}
function $081ef12b46fbcaa0$var$useHostTransitionStatus() {
    return $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$HostTransitionContext);
}
function $081ef12b46fbcaa0$var$updateId() {
    return $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
}
function $081ef12b46fbcaa0$var$updateRefresh() {
    return $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
}
function $081ef12b46fbcaa0$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
                fiber = $081ef12b46fbcaa0$var$createUpdate(lane);
                var root$41 = $081ef12b46fbcaa0$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root$41, provider, lane), $081ef12b46fbcaa0$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $081ef12b46fbcaa0$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $081ef12b46fbcaa0$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber) ? $081ef12b46fbcaa0$var$enqueueRenderPhaseUpdate(queue, action) : (action = $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(action, fiber, lane), $081ef12b46fbcaa0$var$entangleTransitionUpdate(action, queue, lane)));
}
function $081ef12b46fbcaa0$var$dispatchSetState(fiber, queue, action) {
    var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
    $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber)) $081ef12b46fbcaa0$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($081ef12b46fbcaa0$var$objectIs(eagerState, currentState)) return $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, queue, update, 0), null === $081ef12b46fbcaa0$var$workInProgressRoot && $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(action, fiber, lane), $081ef12b46fbcaa0$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $081ef12b46fbcaa0$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $081ef12b46fbcaa0$var$currentlyRenderingFiber || null !== alternate && alternate === $081ef12b46fbcaa0$var$currentlyRenderingFiber;
}
function $081ef12b46fbcaa0$var$enqueueRenderPhaseUpdate(queue, update) {
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $081ef12b46fbcaa0$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $081ef12b46fbcaa0$var$markRootEntangled(root, lane);
    }
}
var $081ef12b46fbcaa0$var$ContextOnlyDispatcher = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useContext: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useEffect: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useImperativeHandle: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useLayoutEffect: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useInsertionEffect: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useMemo: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useReducer: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useRef: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useState: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useDebugValue: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useDeferredValue: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useTransition: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useSyncExternalStore: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useId: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useHostTransitionStatus: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useFormState: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useActionState: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useOptimistic: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useMemoCache: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useCacheRefresh: $081ef12b46fbcaa0$var$throwInvalidHookError
}, $081ef12b46fbcaa0$var$HooksDispatcherOnMount = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: function(callback, deps) {
        $081ef12b46fbcaa0$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $081ef12b46fbcaa0$var$readContext,
    useEffect: $081ef12b46fbcaa0$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $081ef12b46fbcaa0$var$mountEffectImpl(4194308, 4, $081ef12b46fbcaa0$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $081ef12b46fbcaa0$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $081ef12b46fbcaa0$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $081ef12b46fbcaa0$var$dispatchReducerAction.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $081ef12b46fbcaa0$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $081ef12b46fbcaa0$var$dispatchSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $081ef12b46fbcaa0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        return $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $081ef12b46fbcaa0$var$mountStateImpl(!1);
        stateHook = $081ef12b46fbcaa0$var$startTransition.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $081ef12b46fbcaa0$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $081ef12b46fbcaa0$var$currentlyRenderingFiber, hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        if ($081ef12b46fbcaa0$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $081ef12b46fbcaa0$var$workInProgressRoot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(349));
            0 !== ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 124) || $081ef12b46fbcaa0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $081ef12b46fbcaa0$var$mountEffect($081ef12b46fbcaa0$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $081ef12b46fbcaa0$var$pushSimpleEffect(9, $081ef12b46fbcaa0$var$createEffectInstance(), $081ef12b46fbcaa0$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook(), identifierPrefix = $081ef12b46fbcaa0$var$workInProgressRoot.identifierPrefix;
        if ($081ef12b46fbcaa0$var$isHydrating) {
            var JSCompiler_inline_result = $081ef12b46fbcaa0$var$treeContextOverflow;
            var idWithLeadingBit = $081ef12b46fbcaa0$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $081ef12b46fbcaa0$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $081ef12b46fbcaa0$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $081ef12b46fbcaa0$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $081ef12b46fbcaa0$var$useHostTransitionStatus,
    useFormState: $081ef12b46fbcaa0$var$mountActionState,
    useActionState: $081ef12b46fbcaa0$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $081ef12b46fbcaa0$var$dispatchOptimisticSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $081ef12b46fbcaa0$var$useMemoCache,
    useCacheRefresh: function() {
        return $081ef12b46fbcaa0$var$mountWorkInProgressHook().memoizedState = $081ef12b46fbcaa0$var$refreshCache.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber);
    }
}, $081ef12b46fbcaa0$var$HooksDispatcherOnUpdate = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: $081ef12b46fbcaa0$var$updateCallback,
    useContext: $081ef12b46fbcaa0$var$readContext,
    useEffect: $081ef12b46fbcaa0$var$updateEffect,
    useImperativeHandle: $081ef12b46fbcaa0$var$updateImperativeHandle,
    useInsertionEffect: $081ef12b46fbcaa0$var$updateInsertionEffect,
    useLayoutEffect: $081ef12b46fbcaa0$var$updateLayoutEffect,
    useMemo: $081ef12b46fbcaa0$var$updateMemo,
    useReducer: $081ef12b46fbcaa0$var$updateReducer,
    useRef: $081ef12b46fbcaa0$var$updateRef,
    useState: function() {
        return $081ef12b46fbcaa0$var$updateReducer($081ef12b46fbcaa0$var$basicStateReducer);
    },
    useDebugValue: $081ef12b46fbcaa0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        return $081ef12b46fbcaa0$var$updateDeferredValueImpl(hook, $081ef12b46fbcaa0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $081ef12b46fbcaa0$var$updateReducer($081ef12b46fbcaa0$var$basicStateReducer)[0], start = $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $081ef12b46fbcaa0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $081ef12b46fbcaa0$var$updateSyncExternalStore,
    useId: $081ef12b46fbcaa0$var$updateId,
    useHostTransitionStatus: $081ef12b46fbcaa0$var$useHostTransitionStatus,
    useFormState: $081ef12b46fbcaa0$var$updateActionState,
    useActionState: $081ef12b46fbcaa0$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        return $081ef12b46fbcaa0$var$updateOptimisticImpl(hook, $081ef12b46fbcaa0$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $081ef12b46fbcaa0$var$useMemoCache,
    useCacheRefresh: $081ef12b46fbcaa0$var$updateRefresh
}, $081ef12b46fbcaa0$var$HooksDispatcherOnRerender = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: $081ef12b46fbcaa0$var$updateCallback,
    useContext: $081ef12b46fbcaa0$var$readContext,
    useEffect: $081ef12b46fbcaa0$var$updateEffect,
    useImperativeHandle: $081ef12b46fbcaa0$var$updateImperativeHandle,
    useInsertionEffect: $081ef12b46fbcaa0$var$updateInsertionEffect,
    useLayoutEffect: $081ef12b46fbcaa0$var$updateLayoutEffect,
    useMemo: $081ef12b46fbcaa0$var$updateMemo,
    useReducer: $081ef12b46fbcaa0$var$rerenderReducer,
    useRef: $081ef12b46fbcaa0$var$updateRef,
    useState: function() {
        return $081ef12b46fbcaa0$var$rerenderReducer($081ef12b46fbcaa0$var$basicStateReducer);
    },
    useDebugValue: $081ef12b46fbcaa0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        return null === $081ef12b46fbcaa0$var$currentHook ? $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue) : $081ef12b46fbcaa0$var$updateDeferredValueImpl(hook, $081ef12b46fbcaa0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $081ef12b46fbcaa0$var$rerenderReducer($081ef12b46fbcaa0$var$basicStateReducer)[0], start = $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $081ef12b46fbcaa0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $081ef12b46fbcaa0$var$updateSyncExternalStore,
    useId: $081ef12b46fbcaa0$var$updateId,
    useHostTransitionStatus: $081ef12b46fbcaa0$var$useHostTransitionStatus,
    useFormState: $081ef12b46fbcaa0$var$rerenderActionState,
    useActionState: $081ef12b46fbcaa0$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        if (null !== $081ef12b46fbcaa0$var$currentHook) return $081ef12b46fbcaa0$var$updateOptimisticImpl(hook, $081ef12b46fbcaa0$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $081ef12b46fbcaa0$var$useMemoCache,
    useCacheRefresh: $081ef12b46fbcaa0$var$updateRefresh
}, $081ef12b46fbcaa0$var$thenableState = null, $081ef12b46fbcaa0$var$thenableIndexCounter = 0;
function $081ef12b46fbcaa0$var$unwrapThenable(thenable) {
    var index = $081ef12b46fbcaa0$var$thenableIndexCounter;
    $081ef12b46fbcaa0$var$thenableIndexCounter += 1;
    null === $081ef12b46fbcaa0$var$thenableState && ($081ef12b46fbcaa0$var$thenableState = []);
    return $081ef12b46fbcaa0$var$trackUsedThenable($081ef12b46fbcaa0$var$thenableState, thenable, index);
}
function $081ef12b46fbcaa0$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $081ef12b46fbcaa0$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $081ef12b46fbcaa0$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $081ef12b46fbcaa0$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $081ef12b46fbcaa0$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $081ef12b46fbcaa0$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $081ef12b46fbcaa0$var$REACT_LAZY_TYPE && $081ef12b46fbcaa0$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $081ef12b46fbcaa0$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $081ef12b46fbcaa0$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $081ef12b46fbcaa0$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $081ef12b46fbcaa0$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $081ef12b46fbcaa0$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    return lanes = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $081ef12b46fbcaa0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    return newChild = $081ef12b46fbcaa0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild) || $081ef12b46fbcaa0$var$getIteratorFn(newChild)) return newChild = $081ef12b46fbcaa0$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild) || $081ef12b46fbcaa0$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild) || $081ef12b46fbcaa0$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $081ef12b46fbcaa0$var$REACT_LAZY_TYPE && $081ef12b46fbcaa0$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $081ef12b46fbcaa0$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE ? (lanes = $081ef12b46fbcaa0$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $081ef12b46fbcaa0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $081ef12b46fbcaa0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($081ef12b46fbcaa0$var$getIteratorFn(newChild)) {
                key = $081ef12b46fbcaa0$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $081ef12b46fbcaa0$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $081ef12b46fbcaa0$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $081ef12b46fbcaa0$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $081ef12b46fbcaa0$var$SuspenseException || x === $081ef12b46fbcaa0$var$SuspenseActionException) throw x;
            var fiber = $081ef12b46fbcaa0$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $081ef12b46fbcaa0$var$reconcileChildFibers = $081ef12b46fbcaa0$var$createChildReconciler(!0), $081ef12b46fbcaa0$var$mountChildFibers = $081ef12b46fbcaa0$var$createChildReconciler(!1), $081ef12b46fbcaa0$var$suspenseHandlerStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$shellBoundary = null;
function $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current & 1);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, handler);
    null === $081ef12b46fbcaa0$var$shellBoundary && (null === current || null !== $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current ? $081ef12b46fbcaa0$var$shellBoundary = handler : null !== current.memoizedState && ($081ef12b46fbcaa0$var$shellBoundary = handler));
}
function $081ef12b46fbcaa0$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current), $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, fiber), null === $081ef12b46fbcaa0$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($081ef12b46fbcaa0$var$shellBoundary = fiber);
        }
    } else $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(fiber);
}
function $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack() {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current);
}
function $081ef12b46fbcaa0$var$popSuspenseHandler(fiber) {
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseHandlerStackCursor);
    $081ef12b46fbcaa0$var$shellBoundary === fiber && ($081ef12b46fbcaa0$var$shellBoundary = null);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseStackCursor);
}
var $081ef12b46fbcaa0$var$suspenseStackCursor = $081ef12b46fbcaa0$var$createCursor(0);
function $081ef12b46fbcaa0$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $081ef12b46fbcaa0$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $081ef12b46fbcaa0$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane(), update = $081ef12b46fbcaa0$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $081ef12b46fbcaa0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(payload, inst, lane), $081ef12b46fbcaa0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane(), update = $081ef12b46fbcaa0$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $081ef12b46fbcaa0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(payload, inst, lane), $081ef12b46fbcaa0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane(), update = $081ef12b46fbcaa0$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $081ef12b46fbcaa0$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(callback, inst, lane), $081ef12b46fbcaa0$var$entangleTransitions(callback, inst, lane));
    }
};
function $081ef12b46fbcaa0$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$081ef12b46fbcaa0$var$shallowEqual(oldProps, newProps) || !$081ef12b46fbcaa0$var$shallowEqual(oldState, newState) : !0;
}
function $081ef12b46fbcaa0$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $081ef12b46fbcaa0$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $081ef12b46fbcaa0$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $081ef12b46fbcaa0$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $081ef12b46fbcaa0$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $081ef12b46fbcaa0$var$defaultOnUncaughtError(error) {
    $081ef12b46fbcaa0$var$reportGlobalError(error);
}
function $081ef12b46fbcaa0$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $081ef12b46fbcaa0$var$defaultOnRecoverableError(error) {
    $081ef12b46fbcaa0$var$reportGlobalError(error);
}
function $081ef12b46fbcaa0$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $081ef12b46fbcaa0$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $081ef12b46fbcaa0$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $081ef12b46fbcaa0$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $081ef12b46fbcaa0$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $081ef12b46fbcaa0$var$createClassErrorUpdate(lane) {
    lane = $081ef12b46fbcaa0$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $081ef12b46fbcaa0$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $081ef12b46fbcaa0$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $081ef12b46fbcaa0$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed ? $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $081ef12b46fbcaa0$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $081ef12b46fbcaa0$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $081ef12b46fbcaa0$var$shellBoundary ? $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $081ef12b46fbcaa0$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $081ef12b46fbcaa0$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $081ef12b46fbcaa0$var$attachPingListener(root, value, rootRenderLanes);
        $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($081ef12b46fbcaa0$var$isHydrating) return returnFiber = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $081ef12b46fbcaa0$var$HydrationMismatchException && (root = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(422), {
        cause: value
    }), $081ef12b46fbcaa0$var$queueHydrationError($081ef12b46fbcaa0$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $081ef12b46fbcaa0$var$HydrationMismatchException && (returnFiber = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(423), {
        cause: value
    }), $081ef12b46fbcaa0$var$queueHydrationError($081ef12b46fbcaa0$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $081ef12b46fbcaa0$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $081ef12b46fbcaa0$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors ? $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $081ef12b46fbcaa0$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $081ef12b46fbcaa0$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed || !$081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $081ef12b46fbcaa0$var$createClassErrorUpdate(rootRenderLanes), $081ef12b46fbcaa0$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $081ef12b46fbcaa0$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $081ef12b46fbcaa0$var$SelectiveHydrationException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(461)), $081ef12b46fbcaa0$var$didReceiveUpdate = !1;
function $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $081ef12b46fbcaa0$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $081ef12b46fbcaa0$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    nextProps = $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $081ef12b46fbcaa0$var$checkDidRenderIdHook();
    if (null !== current && !$081ef12b46fbcaa0$var$didReceiveUpdate) return $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, renderLanes), $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $081ef12b46fbcaa0$var$isHydrating && key && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$081ef12b46fbcaa0$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $081ef12b46fbcaa0$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $081ef12b46fbcaa0$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $081ef12b46fbcaa0$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $081ef12b46fbcaa0$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($081ef12b46fbcaa0$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($081ef12b46fbcaa0$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($081ef12b46fbcaa0$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $081ef12b46fbcaa0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $081ef12b46fbcaa0$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $081ef12b46fbcaa0$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $081ef12b46fbcaa0$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $081ef12b46fbcaa0$var$pushHiddenContext(workInProgress, prevState) : $081ef12b46fbcaa0$var$reuseHiddenContextOnStack(), $081ef12b46fbcaa0$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $081ef12b46fbcaa0$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($081ef12b46fbcaa0$var$pushTransition(workInProgress, prevState.cachePool), $081ef12b46fbcaa0$var$pushHiddenContext(workInProgress, prevState), $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $081ef12b46fbcaa0$var$pushTransition(workInProgress, null), $081ef12b46fbcaa0$var$reuseHiddenContextOnStack(), $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress));
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $081ef12b46fbcaa0$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $081ef12b46fbcaa0$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $081ef12b46fbcaa0$var$pushTransition(workInProgress, null);
    $081ef12b46fbcaa0$var$reuseHiddenContextOnStack();
    $081ef12b46fbcaa0$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $081ef12b46fbcaa0$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $081ef12b46fbcaa0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    Component = $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $081ef12b46fbcaa0$var$checkDidRenderIdHook();
    if (null !== current && !$081ef12b46fbcaa0$var$didReceiveUpdate) return $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, renderLanes), $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $081ef12b46fbcaa0$var$isHydrating && nextProps && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $081ef12b46fbcaa0$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $081ef12b46fbcaa0$var$finishRenderingHooks(current);
    Component = $081ef12b46fbcaa0$var$checkDidRenderIdHook();
    if (null !== current && !$081ef12b46fbcaa0$var$didReceiveUpdate) return $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, renderLanes), $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $081ef12b46fbcaa0$var$isHydrating && Component && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $081ef12b46fbcaa0$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $081ef12b46fbcaa0$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $081ef12b46fbcaa0$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $081ef12b46fbcaa0$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $081ef12b46fbcaa0$var$readContext(contextType) : $081ef12b46fbcaa0$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $081ef12b46fbcaa0$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $081ef12b46fbcaa0$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $081ef12b46fbcaa0$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $081ef12b46fbcaa0$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $081ef12b46fbcaa0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $081ef12b46fbcaa0$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $081ef12b46fbcaa0$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $081ef12b46fbcaa0$var$hasForceUpdate || $081ef12b46fbcaa0$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $081ef12b46fbcaa0$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $081ef12b46fbcaa0$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $081ef12b46fbcaa0$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $081ef12b46fbcaa0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $081ef12b46fbcaa0$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $081ef12b46fbcaa0$var$hasForceUpdate || null !== current && null !== current.dependencies && $081ef12b46fbcaa0$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $081ef12b46fbcaa0$var$hasForceUpdate || $081ef12b46fbcaa0$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $081ef12b46fbcaa0$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $081ef12b46fbcaa0$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $081ef12b46fbcaa0$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $081ef12b46fbcaa0$var$resetHydrationState();
    workInProgress.flags |= 256;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $081ef12b46fbcaa0$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $081ef12b46fbcaa0$var$getSuspendedCache()
    };
}
function $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $081ef12b46fbcaa0$var$workInProgressDeferredLane);
    return current;
}
function $081ef12b46fbcaa0$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($081ef12b46fbcaa0$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($081ef12b46fbcaa0$var$isHydrating) {
            showFallback ? $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($081ef12b46fbcaa0$var$isHydrating) {
                var nextInstance = $081ef12b46fbcaa0$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $081ef12b46fbcaa0$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $081ef12b46fbcaa0$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $081ef12b46fbcaa0$var$treeContextProvider ? {
                            id: $081ef12b46fbcaa0$var$treeContextId,
                            overflow: $081ef12b46fbcaa0$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $081ef12b46fbcaa0$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $081ef12b46fbcaa0$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $081ef12b46fbcaa0$var$SUSPENDED_MARKER, nextProps;
        $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $081ef12b46fbcaa0$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $081ef12b46fbcaa0$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress), $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $081ef12b46fbcaa0$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($081ef12b46fbcaa0$var$didReceiveUpdate || $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $081ef12b46fbcaa0$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $081ef12b46fbcaa0$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(current, nextProps), $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $081ef12b46fbcaa0$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible();
            workInProgress = $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(nextInstance.nextSibling), $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$isHydrating = !0, $081ef12b46fbcaa0$var$hydrationErrors = null, $081ef12b46fbcaa0$var$rootOrSingletonContext = !1, null !== current && ($081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextId, $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextOverflow, $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextProvider, $081ef12b46fbcaa0$var$treeContextId = current.id, $081ef12b46fbcaa0$var$treeContextOverflow = current.overflow, $081ef12b46fbcaa0$var$treeContextProvider = workInProgress), workInProgress = $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $081ef12b46fbcaa0$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $081ef12b46fbcaa0$var$createWorkInProgress(digest, showFallback) : (showFallback = $081ef12b46fbcaa0$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $081ef12b46fbcaa0$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $081ef12b46fbcaa0$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $081ef12b46fbcaa0$var$SUSPENDED_MARKER, nextProps;
    $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $081ef12b46fbcaa0$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $081ef12b46fbcaa0$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $081ef12b46fbcaa0$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $081ef12b46fbcaa0$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $081ef12b46fbcaa0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $081ef12b46fbcaa0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $081ef12b46fbcaa0$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $081ef12b46fbcaa0$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $081ef12b46fbcaa0$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $081ef12b46fbcaa0$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $081ef12b46fbcaa0$var$checkIfContextChanged(current) ? !0 : !1;
}
function $081ef12b46fbcaa0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, current.memoizedState.cache);
            $081ef12b46fbcaa0$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $081ef12b46fbcaa0$var$pushHostContext(workInProgress);
            break;
        case 4:
            $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $081ef12b46fbcaa0$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $081ef12b46fbcaa0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $081ef12b46fbcaa0$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, current.memoizedState.cache);
    }
    return $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $081ef12b46fbcaa0$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $081ef12b46fbcaa0$var$didReceiveUpdate = !0;
        else {
            if (!$081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $081ef12b46fbcaa0$var$didReceiveUpdate = !1, $081ef12b46fbcaa0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $081ef12b46fbcaa0$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $081ef12b46fbcaa0$var$didReceiveUpdate = !1, $081ef12b46fbcaa0$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $081ef12b46fbcaa0$var$pushTreeId(workInProgress, $081ef12b46fbcaa0$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $081ef12b46fbcaa0$var$shouldConstruct(lazyComponent) ? (current = $081ef12b46fbcaa0$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $081ef12b46fbcaa0$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $081ef12b46fbcaa0$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $081ef12b46fbcaa0$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $081ef12b46fbcaa0$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $081ef12b46fbcaa0$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $081ef12b46fbcaa0$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $081ef12b46fbcaa0$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $081ef12b46fbcaa0$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $081ef12b46fbcaa0$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress);
                $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, [
                    $081ef12b46fbcaa0$var$CacheContext
                ], renderLanes, !0);
                $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $081ef12b46fbcaa0$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(Error($081ef12b46fbcaa0$var$formatProdErrorMessage(424)), workInProgress);
                        $081ef12b46fbcaa0$var$queueHydrationError(init);
                        workInProgress = $081ef12b46fbcaa0$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(current.firstChild);
                        $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress;
                        $081ef12b46fbcaa0$var$isHydrating = !0;
                        $081ef12b46fbcaa0$var$hydrationErrors = null;
                        $081ef12b46fbcaa0$var$rootOrSingletonContext = !0;
                        renderLanes = $081ef12b46fbcaa0$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $081ef12b46fbcaa0$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $081ef12b46fbcaa0$var$markRef(current, workInProgress), null === current ? (renderLanes = $081ef12b46fbcaa0$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $081ef12b46fbcaa0$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer($081ef12b46fbcaa0$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress, lazyComponent[$081ef12b46fbcaa0$var$internalPropsKey] = current, $081ef12b46fbcaa0$var$setInitialProperties(lazyComponent, renderLanes, current), $081ef12b46fbcaa0$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $081ef12b46fbcaa0$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $081ef12b46fbcaa0$var$pushHostContext(workInProgress), null === current && $081ef12b46fbcaa0$var$isHydrating && (lazyComponent = workInProgress.stateNode = $081ef12b46fbcaa0$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootInstanceStackCursor.current), $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$rootOrSingletonContext = !0, init = $081ef12b46fbcaa0$var$nextHydratableInstance, $081ef12b46fbcaa0$var$isSingletonScope(workInProgress.type) ? ($081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton = init, $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(lazyComponent.firstChild)) : $081ef12b46fbcaa0$var$nextHydratableInstance = init), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $081ef12b46fbcaa0$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $081ef12b46fbcaa0$var$isHydrating) {
                if (init = lazyComponent = $081ef12b46fbcaa0$var$nextHydratableInstance) lazyComponent = $081ef12b46fbcaa0$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(lazyComponent.firstChild), $081ef12b46fbcaa0$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            }
            $081ef12b46fbcaa0$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $081ef12b46fbcaa0$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $081ef12b46fbcaa0$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, $081ef12b46fbcaa0$var$TransitionAwareHostComponent, null, null, renderLanes), $081ef12b46fbcaa0$var$HostTransitionContext._currentValue = init);
            $081ef12b46fbcaa0$var$markRef(current, workInProgress);
            $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $081ef12b46fbcaa0$var$isHydrating) {
                if (current = renderLanes = $081ef12b46fbcaa0$var$nextHydratableInstance) renderLanes = $081ef12b46fbcaa0$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $081ef12b46fbcaa0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $081ef12b46fbcaa0$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $081ef12b46fbcaa0$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress), init = $081ef12b46fbcaa0$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $081ef12b46fbcaa0$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $081ef12b46fbcaa0$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $081ef12b46fbcaa0$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $081ef12b46fbcaa0$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress), lazyComponent = $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$CacheContext), null === current ? (init = $081ef12b46fbcaa0$var$peekCacheFromPool(), null === init && (init = $081ef12b46fbcaa0$var$workInProgressRoot, prevState = $081ef12b46fbcaa0$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $081ef12b46fbcaa0$var$initializeUpdateQueue(workInProgress), $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress), $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, null, null, renderLanes), $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, [
                $081ef12b46fbcaa0$var$CacheContext
            ], renderLanes, !0))), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $081ef12b46fbcaa0$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $081ef12b46fbcaa0$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$081ef12b46fbcaa0$var$preloadResource(resource)) {
        resource = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 4194048) === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes ? null !== $081ef12b46fbcaa0$var$shellBoundary : ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 62914560) !== $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && 0 === ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 536870912) || resource !== $081ef12b46fbcaa0$var$shellBoundary)) throw $081ef12b46fbcaa0$var$suspendedThenable = $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable, $081ef12b46fbcaa0$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $081ef12b46fbcaa0$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $081ef12b46fbcaa0$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$081ef12b46fbcaa0$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $081ef12b46fbcaa0$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $081ef12b46fbcaa0$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $081ef12b46fbcaa0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 1:
            return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext);
            $081ef12b46fbcaa0$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $081ef12b46fbcaa0$var$popHydrationState(workInProgress) ? $081ef12b46fbcaa0$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable());
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($081ef12b46fbcaa0$var$markUpdate(workInProgress), null !== renderLanes ? ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), $081ef12b46fbcaa0$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($081ef12b46fbcaa0$var$markUpdate(workInProgress), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), $081ef12b46fbcaa0$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $081ef12b46fbcaa0$var$popHostContext(workInProgress);
            renderLanes = $081ef12b46fbcaa0$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(166));
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $081ef12b46fbcaa0$var$contextStackCursor.current;
                $081ef12b46fbcaa0$var$popHydrationState(workInProgress) ? $081ef12b46fbcaa0$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $081ef12b46fbcaa0$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $081ef12b46fbcaa0$var$markUpdate(workInProgress));
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $081ef12b46fbcaa0$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(166));
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $081ef12b46fbcaa0$var$contextStackCursor.current;
                if ($081ef12b46fbcaa0$var$popHydrationState(workInProgress)) $081ef12b46fbcaa0$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer($081ef12b46fbcaa0$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    current[$081ef12b46fbcaa0$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($081ef12b46fbcaa0$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
                }
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(166));
                current = $081ef12b46fbcaa0$var$rootInstanceStackCursor.current;
                if ($081ef12b46fbcaa0$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $081ef12b46fbcaa0$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $081ef12b46fbcaa0$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
                } else current = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $081ef12b46fbcaa0$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(317));
                        type[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    } else $081ef12b46fbcaa0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $081ef12b46fbcaa0$var$popHostContainer(), null === current && $081ef12b46fbcaa0$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 10:
            return $081ef12b46fbcaa0$var$popProvider(workInProgress.type), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 19:
            $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $081ef12b46fbcaa0$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $081ef12b46fbcaa0$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $081ef12b46fbcaa0$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $081ef12b46fbcaa0$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$081ef12b46fbcaa0$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $081ef12b46fbcaa0$var$now() > $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $081ef12b46fbcaa0$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $081ef12b46fbcaa0$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, current), $081ef12b46fbcaa0$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$081ef12b46fbcaa0$var$isHydrating) return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
                    } else 2 * $081ef12b46fbcaa0$var$now() - type.renderingStartTime > $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $081ef12b46fbcaa0$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $081ef12b46fbcaa0$var$now(), workInProgress.sibling = null, current = $081ef12b46fbcaa0$var$suspenseStackCursor.current, $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), $081ef12b46fbcaa0$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $081ef12b46fbcaa0$var$unwindWork(current, workInProgress) {
    $081ef12b46fbcaa0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext), $081ef12b46fbcaa0$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $081ef12b46fbcaa0$var$popHostContext(workInProgress), null;
        case 13:
            $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(340));
                $081ef12b46fbcaa0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseStackCursor), null;
        case 4:
            return $081ef12b46fbcaa0$var$popHostContainer(), null;
        case 10:
            return $081ef12b46fbcaa0$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), $081ef12b46fbcaa0$var$popHiddenContext(), null !== current && $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $081ef12b46fbcaa0$var$unwindInterruptedWork(current, interruptedWork) {
    $081ef12b46fbcaa0$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext);
            $081ef12b46fbcaa0$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $081ef12b46fbcaa0$var$popHostContext(interruptedWork);
            break;
        case 4:
            $081ef12b46fbcaa0$var$popHostContainer();
            break;
        case 13:
            $081ef12b46fbcaa0$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseStackCursor);
            break;
        case 10:
            $081ef12b46fbcaa0$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $081ef12b46fbcaa0$var$popSuspenseHandler(interruptedWork);
            $081ef12b46fbcaa0$var$popHiddenContext();
            null !== current && $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$resumedCache);
            break;
        case 24:
            $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext);
    }
}
function $081ef12b46fbcaa0$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $081ef12b46fbcaa0$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $081ef12b46fbcaa0$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $081ef12b46fbcaa0$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $081ef12b46fbcaa0$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $081ef12b46fbcaa0$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $081ef12b46fbcaa0$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $081ef12b46fbcaa0$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $081ef12b46fbcaa0$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$081ef12b46fbcaa0$var$internalPropsKey] = newProps;
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $081ef12b46fbcaa0$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $081ef12b46fbcaa0$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $081ef12b46fbcaa0$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $081ef12b46fbcaa0$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $081ef12b46fbcaa0$var$noop$1));
    else if (4 !== tag && (27 === tag && $081ef12b46fbcaa0$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $081ef12b46fbcaa0$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $081ef12b46fbcaa0$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($081ef12b46fbcaa0$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$081ef12b46fbcaa0$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $081ef12b46fbcaa0$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $081ef12b46fbcaa0$var$setInitialProperties(singleton, type, props);
        singleton[$081ef12b46fbcaa0$var$internalInstanceKey] = finishedWork;
        singleton[$081ef12b46fbcaa0$var$internalPropsKey] = props;
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = !1, $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = !1, $081ef12b46fbcaa0$var$needsFormReset = !1, $081ef12b46fbcaa0$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $081ef12b46fbcaa0$var$nextEffect = null;
function $081ef12b46fbcaa0$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $081ef12b46fbcaa0$var$eventsEnabled = $081ef12b46fbcaa0$var$_enabled;
    root = $081ef12b46fbcaa0$var$getActiveElementDeep(root);
    if ($081ef12b46fbcaa0$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $081ef12b46fbcaa0$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $081ef12b46fbcaa0$var$_enabled = !1;
    for($081ef12b46fbcaa0$var$nextEffect = firstChild; null !== $081ef12b46fbcaa0$var$nextEffect;)if (firstChild = $081ef12b46fbcaa0$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $081ef12b46fbcaa0$var$nextEffect = root;
    else for(; null !== $081ef12b46fbcaa0$var$nextEffect;){
        firstChild = $081ef12b46fbcaa0$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $081ef12b46fbcaa0$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $081ef12b46fbcaa0$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $081ef12b46fbcaa0$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $081ef12b46fbcaa0$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $081ef12b46fbcaa0$var$nextEffect = root;
            break;
        }
        $081ef12b46fbcaa0$var$nextEffect = firstChild.return;
    }
}
function $081ef12b46fbcaa0$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $081ef12b46fbcaa0$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $081ef12b46fbcaa0$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $081ef12b46fbcaa0$var$commitClassCallbacks(finishedWork);
            flags & 512 && $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $081ef12b46fbcaa0$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostMount(finishedWork);
            flags & 512 && $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $081ef12b46fbcaa0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $081ef12b46fbcaa0$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $081ef12b46fbcaa0$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden;
                prevProps = $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden;
                $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = flags;
                ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = prevProps;
                $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $081ef12b46fbcaa0$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $081ef12b46fbcaa0$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $081ef12b46fbcaa0$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $081ef12b46fbcaa0$var$hostParent = null, $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
function $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$081ef12b46fbcaa0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $081ef12b46fbcaa0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.onCommitFiberUnmount) try {
        $081ef12b46fbcaa0$var$injectedHook.onCommitFiberUnmount($081ef12b46fbcaa0$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $081ef12b46fbcaa0$var$hostParent, prevHostParentIsContainer = $081ef12b46fbcaa0$var$hostParentIsContainer;
            $081ef12b46fbcaa0$var$isSingletonScope(deletedFiber.type) && ($081ef12b46fbcaa0$var$hostParent = deletedFiber.stateNode, $081ef12b46fbcaa0$var$hostParentIsContainer = !1);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$releaseSingletonInstance(deletedFiber.stateNode);
            $081ef12b46fbcaa0$var$hostParent = prevHostParent;
            $081ef12b46fbcaa0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $081ef12b46fbcaa0$var$hostParent;
            prevHostParentIsContainer = $081ef12b46fbcaa0$var$hostParentIsContainer;
            $081ef12b46fbcaa0$var$hostParent = null;
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$hostParent = prevHostParent;
            $081ef12b46fbcaa0$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $081ef12b46fbcaa0$var$hostParent) {
                if ($081ef12b46fbcaa0$var$hostParentIsContainer) try {
                    (9 === $081ef12b46fbcaa0$var$hostParent.nodeType ? $081ef12b46fbcaa0$var$hostParent.body : "HTML" === $081ef12b46fbcaa0$var$hostParent.nodeName ? $081ef12b46fbcaa0$var$hostParent.ownerDocument.body : $081ef12b46fbcaa0$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $081ef12b46fbcaa0$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $081ef12b46fbcaa0$var$hostParent && ($081ef12b46fbcaa0$var$hostParentIsContainer ? (finishedRoot = $081ef12b46fbcaa0$var$hostParent, $081ef12b46fbcaa0$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $081ef12b46fbcaa0$var$retryIfBlockedOn(finishedRoot)) : $081ef12b46fbcaa0$var$clearSuspenseBoundary($081ef12b46fbcaa0$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $081ef12b46fbcaa0$var$hostParent;
            prevHostParentIsContainer = $081ef12b46fbcaa0$var$hostParentIsContainer;
            $081ef12b46fbcaa0$var$hostParent = deletedFiber.stateNode.containerInfo;
            $081ef12b46fbcaa0$var$hostParentIsContainer = !0;
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$hostParent = prevHostParent;
            $081ef12b46fbcaa0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || ($081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $081ef12b46fbcaa0$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = (prevHostParent = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $081ef12b46fbcaa0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $081ef12b46fbcaa0$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $081ef12b46fbcaa0$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $081ef12b46fbcaa0$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $081ef12b46fbcaa0$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $081ef12b46fbcaa0$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($081ef12b46fbcaa0$var$isSingletonScope(parent.type)) {
                        $081ef12b46fbcaa0$var$hostParent = parent.stateNode;
                        $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $081ef12b46fbcaa0$var$hostParent = parent.stateNode;
                    $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $081ef12b46fbcaa0$var$hostParent = parent.stateNode.containerInfo;
                    $081ef12b46fbcaa0$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $081ef12b46fbcaa0$var$hostParent) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(160));
        $081ef12b46fbcaa0$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $081ef12b46fbcaa0$var$hostParent = null;
        $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $081ef12b46fbcaa0$var$currentHoistableRoot = null;
function $081ef12b46fbcaa0$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($081ef12b46fbcaa0$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $081ef12b46fbcaa0$var$commitHookEffectListMount(3, finishedWork), $081ef12b46fbcaa0$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            flags & 64 && $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$081ef12b46fbcaa0$var$internalHoistableMarker] || currentResource[$081ef12b46fbcaa0$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $081ef12b46fbcaa0$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$081ef12b46fbcaa0$var$internalInstanceKey] = finishedWork;
                                        $081ef12b46fbcaa0$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $081ef12b46fbcaa0$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $081ef12b46fbcaa0$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $081ef12b46fbcaa0$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $081ef12b46fbcaa0$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$081ef12b46fbcaa0$var$internalInstanceKey] = finishedWork;
                                $081ef12b46fbcaa0$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $081ef12b46fbcaa0$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $081ef12b46fbcaa0$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $081ef12b46fbcaa0$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $081ef12b46fbcaa0$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $081ef12b46fbcaa0$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($081ef12b46fbcaa0$var$needsFormReset = !0);
            break;
        case 6:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $081ef12b46fbcaa0$var$tagCaches = null;
            hoistableRoot = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$currentHoistableRoot = $081ef12b46fbcaa0$var$getHoistableRoot(root.containerInfo);
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$currentHoistableRoot = hoistableRoot;
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $081ef12b46fbcaa0$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $081ef12b46fbcaa0$var$needsFormReset && ($081ef12b46fbcaa0$var$needsFormReset = !1, $081ef12b46fbcaa0$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$currentHoistableRoot = $081ef12b46fbcaa0$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            $081ef12b46fbcaa0$var$currentHoistableRoot = flags;
            break;
        case 12:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($081ef12b46fbcaa0$var$globalMostRecentFallbackTime = $081ef12b46fbcaa0$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden;
            $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $081ef12b46fbcaa0$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $081ef12b46fbcaa0$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork), $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
    }
}
function $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($081ef12b46fbcaa0$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $081ef12b46fbcaa0$var$getHostSibling(finishedWork);
                    $081ef12b46fbcaa0$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($081ef12b46fbcaa0$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $081ef12b46fbcaa0$var$getHostSibling(finishedWork);
                    $081ef12b46fbcaa0$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $081ef12b46fbcaa0$var$getHostSibling(finishedWork);
                    $081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $081ef12b46fbcaa0$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $081ef12b46fbcaa0$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $081ef12b46fbcaa0$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $081ef12b46fbcaa0$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $081ef12b46fbcaa0$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $081ef12b46fbcaa0$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$081ef12b46fbcaa0$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $081ef12b46fbcaa0$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $081ef12b46fbcaa0$var$commitClassCallbacks(finishedWork);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $081ef12b46fbcaa0$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostMount(finishedWork);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $081ef12b46fbcaa0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $081ef12b46fbcaa0$var$releaseCache(previousCache));
}
function $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $081ef12b46fbcaa0$var$releaseCache(current));
}
function $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $081ef12b46fbcaa0$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $081ef12b46fbcaa0$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $081ef12b46fbcaa0$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $081ef12b46fbcaa0$var$suspenseyCommitFlag = 8192;
function $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $081ef12b46fbcaa0$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $081ef12b46fbcaa0$var$suspenseyCommitFlag && null !== fiber.memoizedState && $081ef12b46fbcaa0$var$suspendResource($081ef12b46fbcaa0$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$currentHoistableRoot = $081ef12b46fbcaa0$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $081ef12b46fbcaa0$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $081ef12b46fbcaa0$var$suspenseyCommitFlag, $081ef12b46fbcaa0$var$suspenseyCommitFlag = 16777216, $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber), $081ef12b46fbcaa0$var$suspenseyCommitFlag = previousHoistableRoot) : $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $081ef12b46fbcaa0$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $081ef12b46fbcaa0$var$nextEffect = childToDelete;
            $081ef12b46fbcaa0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $081ef12b46fbcaa0$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $081ef12b46fbcaa0$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $081ef12b46fbcaa0$var$nextEffect = childToDelete;
            $081ef12b46fbcaa0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $081ef12b46fbcaa0$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $081ef12b46fbcaa0$var$nextEffect;){
        var fiber = $081ef12b46fbcaa0$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $081ef12b46fbcaa0$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $081ef12b46fbcaa0$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $081ef12b46fbcaa0$var$nextEffect;){
            cache = $081ef12b46fbcaa0$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $081ef12b46fbcaa0$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $081ef12b46fbcaa0$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $081ef12b46fbcaa0$var$nextEffect = sibling;
                break a;
            }
            $081ef12b46fbcaa0$var$nextEffect = returnFiber;
        }
    }
}
var $081ef12b46fbcaa0$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $081ef12b46fbcaa0$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $081ef12b46fbcaa0$var$executionContext = 0, $081ef12b46fbcaa0$var$workInProgressRoot = null, $081ef12b46fbcaa0$var$workInProgress = null, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0, $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings = !1, $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = !1, $081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener = !1, $081ef12b46fbcaa0$var$entangledRenderLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 0, $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootPingedLanes = 0, $081ef12b46fbcaa0$var$workInProgressDeferredLane = 0, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors = null, $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = null, $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $081ef12b46fbcaa0$var$globalMostRecentFallbackTime = 0, $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime = Infinity, $081ef12b46fbcaa0$var$workInProgressTransitions = null, $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed = null, $081ef12b46fbcaa0$var$pendingEffectsStatus = 0, $081ef12b46fbcaa0$var$pendingEffectsRoot = null, $081ef12b46fbcaa0$var$pendingFinishedWork = null, $081ef12b46fbcaa0$var$pendingEffectsLanes = 0, $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes = 0, $081ef12b46fbcaa0$var$pendingPassiveTransitions = null, $081ef12b46fbcaa0$var$pendingRecoverableErrors = null, $081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = null;
function $081ef12b46fbcaa0$var$requestUpdateLane() {
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 2) && 0 !== $081ef12b46fbcaa0$var$workInProgressRootRenderLanes) return $081ef12b46fbcaa0$var$workInProgressRootRenderLanes & -$081ef12b46fbcaa0$var$workInProgressRootRenderLanes;
    if (null !== $081ef12b46fbcaa0$var$ReactSharedInternals.T) {
        var actionScopeLane = $081ef12b46fbcaa0$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $081ef12b46fbcaa0$var$requestTransitionLane();
    }
    return $081ef12b46fbcaa0$var$resolveUpdatePriority();
}
function $081ef12b46fbcaa0$var$requestDeferredLane() {
    0 === $081ef12b46fbcaa0$var$workInProgressDeferredLane && ($081ef12b46fbcaa0$var$workInProgressDeferredLane = 0 === ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 536870912) || $081ef12b46fbcaa0$var$isHydrating ? $081ef12b46fbcaa0$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $081ef12b46fbcaa0$var$workInProgressDeferredLane;
}
function $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $081ef12b46fbcaa0$var$workInProgressRoot && (2 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason || 9 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $081ef12b46fbcaa0$var$prepareFreshStack(root, 0), $081ef12b46fbcaa0$var$markRootSuspended(root, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !1);
    $081ef12b46fbcaa0$var$markRootUpdated$1(root, lane);
    if (0 === ($081ef12b46fbcaa0$var$executionContext & 2) || root !== $081ef12b46fbcaa0$var$workInProgressRoot) root === $081ef12b46fbcaa0$var$workInProgressRoot && (0 === ($081ef12b46fbcaa0$var$executionContext & 2) && ($081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && $081ef12b46fbcaa0$var$markRootSuspended(root, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !1)), $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
}
function $081ef12b46fbcaa0$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 6)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $081ef12b46fbcaa0$var$renderRootConcurrent(root$jscomp$0, lanes) : $081ef12b46fbcaa0$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $081ef12b46fbcaa0$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$081ef12b46fbcaa0$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $081ef12b46fbcaa0$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($081ef12b46fbcaa0$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $081ef12b46fbcaa0$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors;
                            $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors ? $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors.push.apply($081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $081ef12b46fbcaa0$var$prepareFreshStack(root$jscomp$0, 0);
                $081ef12b46fbcaa0$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $081ef12b46fbcaa0$var$markRootSuspended(shouldTimeSlice, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !$081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $081ef12b46fbcaa0$var$globalMostRecentFallbackTime + 300 - $081ef12b46fbcaa0$var$now(), 10 < exitStatus)) {
                    $081ef12b46fbcaa0$var$markRootSuspended(shouldTimeSlice, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !$081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $081ef12b46fbcaa0$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $081ef12b46fbcaa0$var$scheduleTimeout($081ef12b46fbcaa0$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, $081ef12b46fbcaa0$var$workInProgressTransitions, $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $081ef12b46fbcaa0$var$commitRootWhenReady(shouldTimeSlice, forceSync, $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, $081ef12b46fbcaa0$var$workInProgressTransitions, $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $081ef12b46fbcaa0$var$ensureRootIsScheduled(root$jscomp$0);
}
function $081ef12b46fbcaa0$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($081ef12b46fbcaa0$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $081ef12b46fbcaa0$var$noop
        }, $081ef12b46fbcaa0$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $081ef12b46fbcaa0$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($081ef12b46fbcaa0$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $081ef12b46fbcaa0$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $081ef12b46fbcaa0$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $081ef12b46fbcaa0$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$081ef12b46fbcaa0$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $081ef12b46fbcaa0$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$081ef12b46fbcaa0$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $081ef12b46fbcaa0$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $081ef12b46fbcaa0$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $081ef12b46fbcaa0$var$flushSyncWork$1() {
    return 0 === ($081ef12b46fbcaa0$var$executionContext & 6) ? ($081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $081ef12b46fbcaa0$var$resetWorkInProgressStack() {
    if (null !== $081ef12b46fbcaa0$var$workInProgress) {
        if (0 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason) var interruptedWork = $081ef12b46fbcaa0$var$workInProgress.return;
        else interruptedWork = $081ef12b46fbcaa0$var$workInProgress, $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null, $081ef12b46fbcaa0$var$resetHooksOnUnwind(interruptedWork), $081ef12b46fbcaa0$var$thenableState = null, $081ef12b46fbcaa0$var$thenableIndexCounter = 0, interruptedWork = $081ef12b46fbcaa0$var$workInProgress;
        for(; null !== interruptedWork;)$081ef12b46fbcaa0$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $081ef12b46fbcaa0$var$workInProgress = null;
    }
}
function $081ef12b46fbcaa0$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $081ef12b46fbcaa0$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $081ef12b46fbcaa0$var$resetWorkInProgressStack();
    $081ef12b46fbcaa0$var$workInProgressRoot = root;
    $081ef12b46fbcaa0$var$workInProgress = timeoutHandle = $081ef12b46fbcaa0$var$createWorkInProgress(root.current, null);
    $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = lanes;
    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
    $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, lanes);
    $081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener = !1;
    $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes = $081ef12b46fbcaa0$var$workInProgressDeferredLane = $081ef12b46fbcaa0$var$workInProgressRootPingedLanes = $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes = $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes = $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 0;
    $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors = null;
    $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $081ef12b46fbcaa0$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $081ef12b46fbcaa0$var$entangledRenderLanes = lanes;
    $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $081ef12b46fbcaa0$var$handleThrow(root, thrownValue) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber = null;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$ContextOnlyDispatcher;
    thrownValue === $081ef12b46fbcaa0$var$SuspenseException || thrownValue === $081ef12b46fbcaa0$var$SuspenseActionException ? (thrownValue = $081ef12b46fbcaa0$var$getSuspendedThenable(), $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 3) : thrownValue === $081ef12b46fbcaa0$var$SuspenseyCommitException ? (thrownValue = $081ef12b46fbcaa0$var$getSuspendedThenable(), $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 4) : $081ef12b46fbcaa0$var$workInProgressSuspendedReason = thrownValue === $081ef12b46fbcaa0$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $081ef12b46fbcaa0$var$workInProgressThrownValue = thrownValue;
    null === $081ef12b46fbcaa0$var$workInProgress && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 1, $081ef12b46fbcaa0$var$logUncaughtError(root, $081ef12b46fbcaa0$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $081ef12b46fbcaa0$var$pushDispatcher() {
    var prevDispatcher = $081ef12b46fbcaa0$var$ReactSharedInternals.H;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $081ef12b46fbcaa0$var$ContextOnlyDispatcher : prevDispatcher;
}
function $081ef12b46fbcaa0$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $081ef12b46fbcaa0$var$ReactSharedInternals.A;
    $081ef12b46fbcaa0$var$ReactSharedInternals.A = $081ef12b46fbcaa0$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible() {
    $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 4;
    $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings || ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 4194048) !== $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && null !== $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current || ($081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = !0);
    0 === ($081ef12b46fbcaa0$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $081ef12b46fbcaa0$var$workInProgressRoot || $081ef12b46fbcaa0$var$markRootSuspended($081ef12b46fbcaa0$var$workInProgressRoot, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !1);
}
function $081ef12b46fbcaa0$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
    $081ef12b46fbcaa0$var$executionContext |= 2;
    var prevDispatcher = $081ef12b46fbcaa0$var$pushDispatcher(), prevAsyncDispatcher = $081ef12b46fbcaa0$var$pushAsyncDispatcher();
    if ($081ef12b46fbcaa0$var$workInProgressRoot !== root || $081ef12b46fbcaa0$var$workInProgressRootRenderLanes !== lanes) $081ef12b46fbcaa0$var$workInProgressTransitions = null, $081ef12b46fbcaa0$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $081ef12b46fbcaa0$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason && null !== $081ef12b46fbcaa0$var$workInProgress) {
            var unitOfWork = $081ef12b46fbcaa0$var$workInProgress, thrownValue = $081ef12b46fbcaa0$var$workInProgressThrownValue;
            switch($081ef12b46fbcaa0$var$workInProgressSuspendedReason){
                case 8:
                    $081ef12b46fbcaa0$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $081ef12b46fbcaa0$var$workInProgressSuspendedReason;
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $081ef12b46fbcaa0$var$workInProgressSuspendedReason, $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $081ef12b46fbcaa0$var$workLoopSync();
        exitStatus = $081ef12b46fbcaa0$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $081ef12b46fbcaa0$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null;
    $081ef12b46fbcaa0$var$executionContext = prevExecutionContext;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = prevDispatcher;
    $081ef12b46fbcaa0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $081ef12b46fbcaa0$var$workInProgress && ($081ef12b46fbcaa0$var$workInProgressRoot = null, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0, $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $081ef12b46fbcaa0$var$workLoopSync() {
    for(; null !== $081ef12b46fbcaa0$var$workInProgress;)$081ef12b46fbcaa0$var$performUnitOfWork($081ef12b46fbcaa0$var$workInProgress);
}
function $081ef12b46fbcaa0$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
    $081ef12b46fbcaa0$var$executionContext |= 2;
    var prevDispatcher = $081ef12b46fbcaa0$var$pushDispatcher(), prevAsyncDispatcher = $081ef12b46fbcaa0$var$pushAsyncDispatcher();
    $081ef12b46fbcaa0$var$workInProgressRoot !== root || $081ef12b46fbcaa0$var$workInProgressRootRenderLanes !== lanes ? ($081ef12b46fbcaa0$var$workInProgressTransitions = null, $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime = $081ef12b46fbcaa0$var$now() + 500, $081ef12b46fbcaa0$var$prepareFreshStack(root, lanes)) : $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason && null !== $081ef12b46fbcaa0$var$workInProgress) {
            lanes = $081ef12b46fbcaa0$var$workInProgress;
            var thrownValue = $081ef12b46fbcaa0$var$workInProgressThrownValue;
            b: switch($081ef12b46fbcaa0$var$workInProgressSuspendedReason){
                case 1:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($081ef12b46fbcaa0$var$isThenableResolved(thrownValue)) {
                        $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                        $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                        $081ef12b46fbcaa0$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason && 9 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason || $081ef12b46fbcaa0$var$workInProgressRoot !== root || ($081ef12b46fbcaa0$var$workInProgressSuspendedReason = 7);
                        $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $081ef12b46fbcaa0$var$isThenableResolved(thrownValue) ? ($081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$replaySuspendedUnitOfWork(lanes)) : ($081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($081ef12b46fbcaa0$var$workInProgress.tag){
                        case 26:
                            resource = $081ef12b46fbcaa0$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $081ef12b46fbcaa0$var$workInProgress;
                            if (resource ? $081ef12b46fbcaa0$var$preloadResource(resource) : 1) {
                                $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                                $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $081ef12b46fbcaa0$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($081ef12b46fbcaa0$var$workInProgress = returnFiber, $081ef12b46fbcaa0$var$completeUnitOfWork(returnFiber)) : $081ef12b46fbcaa0$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $081ef12b46fbcaa0$var$resetWorkInProgressStack();
                    $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(462));
            }
        }
        $081ef12b46fbcaa0$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $081ef12b46fbcaa0$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = prevDispatcher;
    $081ef12b46fbcaa0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $081ef12b46fbcaa0$var$executionContext = prevExecutionContext;
    if (null !== $081ef12b46fbcaa0$var$workInProgress) return 0;
    $081ef12b46fbcaa0$var$workInProgressRoot = null;
    $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0;
    $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates();
    return $081ef12b46fbcaa0$var$workInProgressRootExitStatus;
}
function $081ef12b46fbcaa0$var$workLoopConcurrentByScheduler() {
    for(; null !== $081ef12b46fbcaa0$var$workInProgress && !$081ef12b46fbcaa0$var$shouldYield();)$081ef12b46fbcaa0$var$performUnitOfWork($081ef12b46fbcaa0$var$workInProgress);
}
function $081ef12b46fbcaa0$var$performUnitOfWork(unitOfWork) {
    var next = $081ef12b46fbcaa0$var$beginWork(unitOfWork.alternate, unitOfWork, $081ef12b46fbcaa0$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork) : $081ef12b46fbcaa0$var$workInProgress = next;
}
function $081ef12b46fbcaa0$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $081ef12b46fbcaa0$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $081ef12b46fbcaa0$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $081ef12b46fbcaa0$var$resetHooksOnUnwind(next);
        default:
            $081ef12b46fbcaa0$var$unwindInterruptedWork(current, next), next = $081ef12b46fbcaa0$var$workInProgress = $081ef12b46fbcaa0$var$resetWorkInProgress(next, $081ef12b46fbcaa0$var$entangledRenderLanes), next = $081ef12b46fbcaa0$var$beginWork(current, next, $081ef12b46fbcaa0$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork) : $081ef12b46fbcaa0$var$workInProgress = next;
}
function $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null;
    $081ef12b46fbcaa0$var$resetHooksOnUnwind(unitOfWork);
    $081ef12b46fbcaa0$var$thenableState = null;
    $081ef12b46fbcaa0$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($081ef12b46fbcaa0$var$throwException(root, returnFiber, unitOfWork, thrownValue, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes)) {
            $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 1;
            $081ef12b46fbcaa0$var$logUncaughtError(root, $081ef12b46fbcaa0$var$createCapturedValueAtFiber(thrownValue, root.current));
            $081ef12b46fbcaa0$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $081ef12b46fbcaa0$var$workInProgress = returnFiber, error;
        $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 1;
        $081ef12b46fbcaa0$var$logUncaughtError(root, $081ef12b46fbcaa0$var$createCapturedValueAtFiber(thrownValue, root.current));
        $081ef12b46fbcaa0$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($081ef12b46fbcaa0$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($081ef12b46fbcaa0$var$workInProgressRootIsPrerendering || 0 !== ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $081ef12b46fbcaa0$var$unwindUnitOfWork(unitOfWork, root);
    } else $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork);
}
function $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $081ef12b46fbcaa0$var$unwindUnitOfWork(completedWork, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $081ef12b46fbcaa0$var$completeWork(completedWork.alternate, completedWork, $081ef12b46fbcaa0$var$entangledRenderLanes);
        if (null !== next) {
            $081ef12b46fbcaa0$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $081ef12b46fbcaa0$var$workInProgress = completedWork;
            return;
        }
        $081ef12b46fbcaa0$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 5);
}
function $081ef12b46fbcaa0$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $081ef12b46fbcaa0$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $081ef12b46fbcaa0$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $081ef12b46fbcaa0$var$workInProgress = unitOfWork;
            return;
        }
        $081ef12b46fbcaa0$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 6;
    $081ef12b46fbcaa0$var$workInProgress = null;
}
function $081ef12b46fbcaa0$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $081ef12b46fbcaa0$var$flushPendingEffects();
    while (0 !== $081ef12b46fbcaa0$var$pendingEffectsStatus);
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 6)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes;
        $081ef12b46fbcaa0$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $081ef12b46fbcaa0$var$workInProgressRoot && ($081ef12b46fbcaa0$var$workInProgress = $081ef12b46fbcaa0$var$workInProgressRoot = null, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0);
        $081ef12b46fbcaa0$var$pendingFinishedWork = finishedWork;
        $081ef12b46fbcaa0$var$pendingEffectsRoot = root;
        $081ef12b46fbcaa0$var$pendingEffectsLanes = lanes;
        $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $081ef12b46fbcaa0$var$pendingPassiveTransitions = transitions;
        $081ef12b46fbcaa0$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $081ef12b46fbcaa0$var$scheduleCallback$1($081ef12b46fbcaa0$var$NormalPriority$1, function() {
            $081ef12b46fbcaa0$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            transitions = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $081ef12b46fbcaa0$var$executionContext;
            $081ef12b46fbcaa0$var$executionContext |= 4;
            try {
                $081ef12b46fbcaa0$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $081ef12b46fbcaa0$var$executionContext = spawnedLane, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = transitions, $081ef12b46fbcaa0$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 1;
        $081ef12b46fbcaa0$var$flushMutationEffects();
        $081ef12b46fbcaa0$var$flushLayoutEffects();
        $081ef12b46fbcaa0$var$flushSpawnedWork();
    }
}
function $081ef12b46fbcaa0$var$flushMutationEffects() {
    if (1 === $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, finishedWork = $081ef12b46fbcaa0$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
            $081ef12b46fbcaa0$var$executionContext |= 4;
            try {
                $081ef12b46fbcaa0$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $081ef12b46fbcaa0$var$selectionInformation, curFocusedElem = $081ef12b46fbcaa0$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $081ef12b46fbcaa0$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $081ef12b46fbcaa0$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $081ef12b46fbcaa0$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $081ef12b46fbcaa0$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $081ef12b46fbcaa0$var$_enabled = !!$081ef12b46fbcaa0$var$eventsEnabled;
                $081ef12b46fbcaa0$var$selectionInformation = $081ef12b46fbcaa0$var$eventsEnabled = null;
            } finally{
                $081ef12b46fbcaa0$var$executionContext = prevExecutionContext, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 2;
    }
}
function $081ef12b46fbcaa0$var$flushLayoutEffects() {
    if (2 === $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, finishedWork = $081ef12b46fbcaa0$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
            $081ef12b46fbcaa0$var$executionContext |= 4;
            try {
                $081ef12b46fbcaa0$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $081ef12b46fbcaa0$var$executionContext = prevExecutionContext, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 3;
    }
}
function $081ef12b46fbcaa0$var$flushSpawnedWork() {
    if (4 === $081ef12b46fbcaa0$var$pendingEffectsStatus || 3 === $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        $081ef12b46fbcaa0$var$requestPaint();
        var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, finishedWork = $081ef12b46fbcaa0$var$pendingFinishedWork, lanes = $081ef12b46fbcaa0$var$pendingEffectsLanes, recoverableErrors = $081ef12b46fbcaa0$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $081ef12b46fbcaa0$var$pendingEffectsStatus = 5 : ($081ef12b46fbcaa0$var$pendingEffectsStatus = 0, $081ef12b46fbcaa0$var$pendingFinishedWork = $081ef12b46fbcaa0$var$pendingEffectsRoot = null, $081ef12b46fbcaa0$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $081ef12b46fbcaa0$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.onCommitFiberRoot) try {
            $081ef12b46fbcaa0$var$injectedHook.onCommitFiberRoot($081ef12b46fbcaa0$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            remainingLanes = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $081ef12b46fbcaa0$var$ReactSharedInternals.T = finishedWork, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($081ef12b46fbcaa0$var$pendingEffectsLanes & 3) && $081ef12b46fbcaa0$var$flushPendingEffects();
        $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $081ef12b46fbcaa0$var$rootWithNestedUpdates ? $081ef12b46fbcaa0$var$nestedUpdateCount++ : ($081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = root) : $081ef12b46fbcaa0$var$nestedUpdateCount = 0;
        $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $081ef12b46fbcaa0$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $081ef12b46fbcaa0$var$releaseCache(remainingLanes)));
}
function $081ef12b46fbcaa0$var$flushPendingEffects(wasDelayedCommit) {
    $081ef12b46fbcaa0$var$flushMutationEffects();
    $081ef12b46fbcaa0$var$flushLayoutEffects();
    $081ef12b46fbcaa0$var$flushSpawnedWork();
    return $081ef12b46fbcaa0$var$flushPassiveEffects(wasDelayedCommit);
}
function $081ef12b46fbcaa0$var$flushPassiveEffects() {
    if (5 !== $081ef12b46fbcaa0$var$pendingEffectsStatus) return !1;
    var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, remainingLanes = $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes;
    $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $081ef12b46fbcaa0$var$lanesToEventPriority($081ef12b46fbcaa0$var$pendingEffectsLanes), prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T, previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
        renderPriority = $081ef12b46fbcaa0$var$pendingPassiveTransitions;
        $081ef12b46fbcaa0$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $081ef12b46fbcaa0$var$pendingEffectsRoot, lanes = $081ef12b46fbcaa0$var$pendingEffectsLanes;
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        $081ef12b46fbcaa0$var$pendingFinishedWork = $081ef12b46fbcaa0$var$pendingEffectsRoot = null;
        $081ef12b46fbcaa0$var$pendingEffectsLanes = 0;
        if (0 !== ($081ef12b46fbcaa0$var$executionContext & 6)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(331));
        var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
        $081ef12b46fbcaa0$var$executionContext |= 4;
        $081ef12b46fbcaa0$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $081ef12b46fbcaa0$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $081ef12b46fbcaa0$var$executionContext = prevExecutionContext;
        $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.onPostCommitFiberRoot) try {
            $081ef12b46fbcaa0$var$injectedHook.onPostCommitFiberRoot($081ef12b46fbcaa0$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition, $081ef12b46fbcaa0$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $081ef12b46fbcaa0$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $081ef12b46fbcaa0$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $081ef12b46fbcaa0$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($081ef12b46fbcaa0$var$markRootUpdated$1(rootFiber, 2), $081ef12b46fbcaa0$var$ensureRootIsScheduled(rootFiber));
}
function $081ef12b46fbcaa0$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $081ef12b46fbcaa0$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $081ef12b46fbcaa0$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed || !$081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $081ef12b46fbcaa0$var$createClassErrorUpdate(2);
                instance = $081ef12b46fbcaa0$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($081ef12b46fbcaa0$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $081ef12b46fbcaa0$var$markRootUpdated$1(instance, 2), $081ef12b46fbcaa0$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $081ef12b46fbcaa0$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $081ef12b46fbcaa0$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $081ef12b46fbcaa0$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $081ef12b46fbcaa0$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $081ef12b46fbcaa0$var$workInProgressRoot === root && ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus || 3 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 62914560) === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && 300 > $081ef12b46fbcaa0$var$now() - $081ef12b46fbcaa0$var$globalMostRecentFallbackTime ? 0 === ($081ef12b46fbcaa0$var$executionContext & 2) && $081ef12b46fbcaa0$var$prepareFreshStack(root, 0) : $081ef12b46fbcaa0$var$workInProgressRootPingedLanes |= pingedLanes, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && ($081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes = 0));
    $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
}
function $081ef12b46fbcaa0$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $081ef12b46fbcaa0$var$claimNextRetryLane());
    boundaryFiber = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($081ef12b46fbcaa0$var$markRootUpdated$1(boundaryFiber, retryLane), $081ef12b46fbcaa0$var$ensureRootIsScheduled(boundaryFiber));
}
function $081ef12b46fbcaa0$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $081ef12b46fbcaa0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $081ef12b46fbcaa0$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $081ef12b46fbcaa0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $081ef12b46fbcaa0$var$scheduleCallback$1(priorityLevel, callback) {
    return $081ef12b46fbcaa0$var$scheduleCallback$3(priorityLevel, callback);
}
var $081ef12b46fbcaa0$var$firstScheduledRoot = null, $081ef12b46fbcaa0$var$lastScheduledRoot = null, $081ef12b46fbcaa0$var$didScheduleMicrotask = !1, $081ef12b46fbcaa0$var$mightHavePendingSyncWork = !1, $081ef12b46fbcaa0$var$isFlushingWork = !1, $081ef12b46fbcaa0$var$currentEventTransitionLane = 0;
function $081ef12b46fbcaa0$var$ensureRootIsScheduled(root) {
    root !== $081ef12b46fbcaa0$var$lastScheduledRoot && null === root.next && (null === $081ef12b46fbcaa0$var$lastScheduledRoot ? $081ef12b46fbcaa0$var$firstScheduledRoot = $081ef12b46fbcaa0$var$lastScheduledRoot = root : $081ef12b46fbcaa0$var$lastScheduledRoot = $081ef12b46fbcaa0$var$lastScheduledRoot.next = root);
    $081ef12b46fbcaa0$var$mightHavePendingSyncWork = !0;
    $081ef12b46fbcaa0$var$didScheduleMicrotask || ($081ef12b46fbcaa0$var$didScheduleMicrotask = !0, $081ef12b46fbcaa0$var$scheduleImmediateRootScheduleTask());
}
function $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$081ef12b46fbcaa0$var$isFlushingWork && $081ef12b46fbcaa0$var$mightHavePendingSyncWork) {
        $081ef12b46fbcaa0$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $081ef12b46fbcaa0$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $081ef12b46fbcaa0$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $081ef12b46fbcaa0$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $081ef12b46fbcaa0$var$getNextLanes(root$174, root$174 === $081ef12b46fbcaa0$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $081ef12b46fbcaa0$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $081ef12b46fbcaa0$var$isFlushingWork = !1;
    }
}
function $081ef12b46fbcaa0$var$processRootScheduleInImmediateTask() {
    $081ef12b46fbcaa0$var$processRootScheduleInMicrotask();
}
function $081ef12b46fbcaa0$var$processRootScheduleInMicrotask() {
    $081ef12b46fbcaa0$var$mightHavePendingSyncWork = $081ef12b46fbcaa0$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $081ef12b46fbcaa0$var$currentEventTransitionLane && ($081ef12b46fbcaa0$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $081ef12b46fbcaa0$var$currentEventTransitionLane), $081ef12b46fbcaa0$var$currentEventTransitionLane = 0);
    for(var currentTime = $081ef12b46fbcaa0$var$now(), prev = null, root = $081ef12b46fbcaa0$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $081ef12b46fbcaa0$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $081ef12b46fbcaa0$var$firstScheduledRoot = next : prev.next = next, null === next && ($081ef12b46fbcaa0$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $081ef12b46fbcaa0$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $081ef12b46fbcaa0$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $081ef12b46fbcaa0$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $081ef12b46fbcaa0$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $081ef12b46fbcaa0$var$workInProgressRoot;
    suspendedLanes = $081ef12b46fbcaa0$var$workInProgressRootRenderLanes;
    suspendedLanes = $081ef12b46fbcaa0$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason || 9 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $081ef12b46fbcaa0$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $081ef12b46fbcaa0$var$cancelCallback$1(pingedLanes);
        switch($081ef12b46fbcaa0$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $081ef12b46fbcaa0$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $081ef12b46fbcaa0$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $081ef12b46fbcaa0$var$IdlePriority;
                break;
            default:
                suspendedLanes = $081ef12b46fbcaa0$var$NormalPriority$1;
        }
        pingedLanes = $081ef12b46fbcaa0$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $081ef12b46fbcaa0$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $081ef12b46fbcaa0$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $081ef12b46fbcaa0$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $081ef12b46fbcaa0$var$pendingEffectsStatus && 5 !== $081ef12b46fbcaa0$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($081ef12b46fbcaa0$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $081ef12b46fbcaa0$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $081ef12b46fbcaa0$var$getNextLanes(root, root === $081ef12b46fbcaa0$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $081ef12b46fbcaa0$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $081ef12b46fbcaa0$var$scheduleTaskForRootDuringMicrotask(root, $081ef12b46fbcaa0$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $081ef12b46fbcaa0$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $081ef12b46fbcaa0$var$performSyncWorkOnRoot(root, lanes) {
    if ($081ef12b46fbcaa0$var$flushPendingEffects()) return null;
    $081ef12b46fbcaa0$var$performWorkOnRoot(root, lanes, !0);
}
function $081ef12b46fbcaa0$var$scheduleImmediateRootScheduleTask() {
    $081ef12b46fbcaa0$var$scheduleMicrotask(function() {
        0 !== ($081ef12b46fbcaa0$var$executionContext & 6) ? $081ef12b46fbcaa0$var$scheduleCallback$3($081ef12b46fbcaa0$var$ImmediatePriority, $081ef12b46fbcaa0$var$processRootScheduleInImmediateTask) : $081ef12b46fbcaa0$var$processRootScheduleInMicrotask();
    });
}
function $081ef12b46fbcaa0$var$requestTransitionLane() {
    0 === $081ef12b46fbcaa0$var$currentEventTransitionLane && ($081ef12b46fbcaa0$var$currentEventTransitionLane = $081ef12b46fbcaa0$var$claimNextTransitionLane());
    return $081ef12b46fbcaa0$var$currentEventTransitionLane;
}
function $081ef12b46fbcaa0$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $081ef12b46fbcaa0$var$sanitizeURL("" + actionProp);
}
function $081ef12b46fbcaa0$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $081ef12b46fbcaa0$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $081ef12b46fbcaa0$var$coerceFormActionProp((nativeEventTarget[$081ef12b46fbcaa0$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$081ef12b46fbcaa0$var$internalPropsKey] || null) ? $081ef12b46fbcaa0$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $081ef12b46fbcaa0$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $081ef12b46fbcaa0$var$currentEventTransitionLane) {
                                var formData = submitter ? $081ef12b46fbcaa0$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $081ef12b46fbcaa0$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $081ef12b46fbcaa0$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $081ef12b46fbcaa0$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $081ef12b46fbcaa0$var$i$jscomp$inline_1528 = 0; $081ef12b46fbcaa0$var$i$jscomp$inline_1528 < $081ef12b46fbcaa0$var$simpleEventPluginEvents.length; $081ef12b46fbcaa0$var$i$jscomp$inline_1528++){
    var $081ef12b46fbcaa0$var$eventName$jscomp$inline_1529 = $081ef12b46fbcaa0$var$simpleEventPluginEvents[$081ef12b46fbcaa0$var$i$jscomp$inline_1528], $081ef12b46fbcaa0$var$domEventName$jscomp$inline_1530 = $081ef12b46fbcaa0$var$eventName$jscomp$inline_1529.toLowerCase(), $081ef12b46fbcaa0$var$capitalizedEvent$jscomp$inline_1531 = $081ef12b46fbcaa0$var$eventName$jscomp$inline_1529[0].toUpperCase() + $081ef12b46fbcaa0$var$eventName$jscomp$inline_1529.slice(1);
    $081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$domEventName$jscomp$inline_1530, "on" + $081ef12b46fbcaa0$var$capitalizedEvent$jscomp$inline_1531);
}
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$ANIMATION_END, "onAnimationEnd");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$ANIMATION_ITERATION, "onAnimationIteration");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$ANIMATION_START, "onAnimationStart");
$081ef12b46fbcaa0$var$registerSimpleEvent("dblclick", "onDoubleClick");
$081ef12b46fbcaa0$var$registerSimpleEvent("focusin", "onFocus");
$081ef12b46fbcaa0$var$registerSimpleEvent("focusout", "onBlur");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_RUN, "onTransitionRun");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_START, "onTransitionStart");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_CANCEL, "onTransitionCancel");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_END, "onTransitionEnd");
$081ef12b46fbcaa0$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$081ef12b46fbcaa0$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$081ef12b46fbcaa0$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$081ef12b46fbcaa0$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $081ef12b46fbcaa0$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $081ef12b46fbcaa0$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($081ef12b46fbcaa0$var$mediaEventTypes));
function $081ef12b46fbcaa0$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $081ef12b46fbcaa0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $081ef12b46fbcaa0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $081ef12b46fbcaa0$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$081ef12b46fbcaa0$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$081ef12b46fbcaa0$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($081ef12b46fbcaa0$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $081ef12b46fbcaa0$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $081ef12b46fbcaa0$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $081ef12b46fbcaa0$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $081ef12b46fbcaa0$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$081ef12b46fbcaa0$var$listeningMarker]) {
        rootContainerElement[$081ef12b46fbcaa0$var$listeningMarker] = !0;
        $081ef12b46fbcaa0$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($081ef12b46fbcaa0$var$nonDelegatedEvents.has(domEventName) || $081ef12b46fbcaa0$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $081ef12b46fbcaa0$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$081ef12b46fbcaa0$var$listeningMarker] || (ownerDocument[$081ef12b46fbcaa0$var$listeningMarker] = !0, $081ef12b46fbcaa0$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $081ef12b46fbcaa0$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($081ef12b46fbcaa0$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $081ef12b46fbcaa0$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $081ef12b46fbcaa0$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $081ef12b46fbcaa0$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$081ef12b46fbcaa0$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $081ef12b46fbcaa0$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $081ef12b46fbcaa0$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $081ef12b46fbcaa0$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $081ef12b46fbcaa0$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticTouchEvent;
                        break;
                    case $081ef12b46fbcaa0$var$ANIMATION_END:
                    case $081ef12b46fbcaa0$var$ANIMATION_ITERATION:
                    case $081ef12b46fbcaa0$var$ANIMATION_START:
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticAnimationEvent;
                        break;
                    case $081ef12b46fbcaa0$var$TRANSITION_END:
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $081ef12b46fbcaa0$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($081ef12b46fbcaa0$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $081ef12b46fbcaa0$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($081ef12b46fbcaa0$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$081ef12b46fbcaa0$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $081ef12b46fbcaa0$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $081ef12b46fbcaa0$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $081ef12b46fbcaa0$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $081ef12b46fbcaa0$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $081ef12b46fbcaa0$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $081ef12b46fbcaa0$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $081ef12b46fbcaa0$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $081ef12b46fbcaa0$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $081ef12b46fbcaa0$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $081ef12b46fbcaa0$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $081ef12b46fbcaa0$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $081ef12b46fbcaa0$var$getParent(inCapturePhase);
                                reactEventName = $081ef12b46fbcaa0$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $081ef12b46fbcaa0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $081ef12b46fbcaa0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $081ef12b46fbcaa0$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForChangeEvent;
                else if ($081ef12b46fbcaa0$var$isTextInputElement(reactName)) {
                    if ($081ef12b46fbcaa0$var$isInputEventSupported) getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $081ef12b46fbcaa0$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $081ef12b46fbcaa0$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForChangeEvent) : getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $081ef12b46fbcaa0$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $081ef12b46fbcaa0$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $081ef12b46fbcaa0$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($081ef12b46fbcaa0$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $081ef12b46fbcaa0$var$activeElement = handleEventFunc, $081ef12b46fbcaa0$var$activeElementInst = targetInst, $081ef12b46fbcaa0$var$lastSelection = null;
                    break;
                case "focusout":
                    $081ef12b46fbcaa0$var$lastSelection = $081ef12b46fbcaa0$var$activeElementInst = $081ef12b46fbcaa0$var$activeElement = null;
                    break;
                case "mousedown":
                    $081ef12b46fbcaa0$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $081ef12b46fbcaa0$var$mouseDown = !1;
                    $081ef12b46fbcaa0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($081ef12b46fbcaa0$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $081ef12b46fbcaa0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($081ef12b46fbcaa0$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $081ef12b46fbcaa0$var$isComposing ? $081ef12b46fbcaa0$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($081ef12b46fbcaa0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($081ef12b46fbcaa0$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $081ef12b46fbcaa0$var$isComposing && (fallbackData = $081ef12b46fbcaa0$var$getData()) : ($081ef12b46fbcaa0$var$root = nativeEventTarget, $081ef12b46fbcaa0$var$startText = "value" in $081ef12b46fbcaa0$var$root ? $081ef12b46fbcaa0$var$root.value : $081ef12b46fbcaa0$var$root.textContent, $081ef12b46fbcaa0$var$isComposing = !0)), handleEventFunc = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $081ef12b46fbcaa0$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $081ef12b46fbcaa0$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $081ef12b46fbcaa0$var$canUseTextInputEvent ? $081ef12b46fbcaa0$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $081ef12b46fbcaa0$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $081ef12b46fbcaa0$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $081ef12b46fbcaa0$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $081ef12b46fbcaa0$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $081ef12b46fbcaa0$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $081ef12b46fbcaa0$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($081ef12b46fbcaa0$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $081ef12b46fbcaa0$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($081ef12b46fbcaa0$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $081ef12b46fbcaa0$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $081ef12b46fbcaa0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $081ef12b46fbcaa0$var$getListener(target, registrationName), null != stateNode && listeners.unshift($081ef12b46fbcaa0$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $081ef12b46fbcaa0$var$getListener(target, registrationName), null != stateNode && listeners.push($081ef12b46fbcaa0$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $081ef12b46fbcaa0$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $081ef12b46fbcaa0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $081ef12b46fbcaa0$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($081ef12b46fbcaa0$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($081ef12b46fbcaa0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $081ef12b46fbcaa0$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $081ef12b46fbcaa0$var$normalizeMarkupForTextOrAttribute(clientText);
    return $081ef12b46fbcaa0$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $081ef12b46fbcaa0$var$noop$1() {}
function $081ef12b46fbcaa0$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $081ef12b46fbcaa0$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $081ef12b46fbcaa0$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $081ef12b46fbcaa0$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $081ef12b46fbcaa0$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $081ef12b46fbcaa0$var$setProp(domElement, tag, "name", props.name, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($081ef12b46fbcaa0$var$setProp(domElement, tag, "encType", props.encType, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "method", props.method, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $081ef12b46fbcaa0$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $081ef12b46fbcaa0$var$noop$1);
            break;
        case "onScroll":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $081ef12b46fbcaa0$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", domElement);
            $081ef12b46fbcaa0$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $081ef12b46fbcaa0$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $081ef12b46fbcaa0$var$aliases.get(key) || key, $081ef12b46fbcaa0$var$setValueForAttribute(domElement, key, value);
    }
}
function $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $081ef12b46fbcaa0$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $081ef12b46fbcaa0$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $081ef12b46fbcaa0$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $081ef12b46fbcaa0$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$081ef12b46fbcaa0$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$081ef12b46fbcaa0$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $081ef12b46fbcaa0$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $081ef12b46fbcaa0$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                    default:
                        $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $081ef12b46fbcaa0$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $081ef12b46fbcaa0$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $081ef12b46fbcaa0$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $081ef12b46fbcaa0$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $081ef12b46fbcaa0$var$track(domElement);
            return;
        case "select":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $081ef12b46fbcaa0$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $081ef12b46fbcaa0$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(91));
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $081ef12b46fbcaa0$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $081ef12b46fbcaa0$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("cancel", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $081ef12b46fbcaa0$var$mediaEventTypes.length; hasSrc++)$081ef12b46fbcaa0$var$listenToNonDelegatedEvent($081ef12b46fbcaa0$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", domElement), $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($081ef12b46fbcaa0$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $081ef12b46fbcaa0$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $081ef12b46fbcaa0$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $081ef12b46fbcaa0$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $081ef12b46fbcaa0$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $081ef12b46fbcaa0$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $081ef12b46fbcaa0$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $081ef12b46fbcaa0$var$updateOptions(domElement, !!lastProps, tag, !0) : $081ef12b46fbcaa0$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $081ef12b46fbcaa0$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $081ef12b46fbcaa0$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($081ef12b46fbcaa0$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $081ef12b46fbcaa0$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $081ef12b46fbcaa0$var$eventsEnabled = null, $081ef12b46fbcaa0$var$selectionInformation = null;
function $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $081ef12b46fbcaa0$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $081ef12b46fbcaa0$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $081ef12b46fbcaa0$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $081ef12b46fbcaa0$var$currentPopstateTransitionEvent = null;
function $081ef12b46fbcaa0$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $081ef12b46fbcaa0$var$currentPopstateTransitionEvent) return !1;
        $081ef12b46fbcaa0$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $081ef12b46fbcaa0$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $081ef12b46fbcaa0$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $081ef12b46fbcaa0$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $081ef12b46fbcaa0$var$localPromise = "function" === typeof Promise ? Promise : void 0, $081ef12b46fbcaa0$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $081ef12b46fbcaa0$var$localPromise ? function(callback) {
    return $081ef12b46fbcaa0$var$localPromise.resolve(null).then(callback).catch($081ef12b46fbcaa0$var$handleErrorInNextTick);
} : $081ef12b46fbcaa0$var$scheduleTimeout;
function $081ef12b46fbcaa0$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $081ef12b46fbcaa0$var$isSingletonScope(type) {
    return "head" === type;
}
function $081ef12b46fbcaa0$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $081ef12b46fbcaa0$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $081ef12b46fbcaa0$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $081ef12b46fbcaa0$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$081ef12b46fbcaa0$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $081ef12b46fbcaa0$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $081ef12b46fbcaa0$var$retryIfBlockedOn(suspenseInstance);
}
function $081ef12b46fbcaa0$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $081ef12b46fbcaa0$var$clearContainerSparingly(node);
                $081ef12b46fbcaa0$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $081ef12b46fbcaa0$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$081ef12b46fbcaa0$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $081ef12b46fbcaa0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $081ef12b46fbcaa0$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $081ef12b46fbcaa0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $081ef12b46fbcaa0$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $081ef12b46fbcaa0$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton = null;
function $081ef12b46fbcaa0$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $081ef12b46fbcaa0$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(451));
    }
}
function $081ef12b46fbcaa0$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $081ef12b46fbcaa0$var$detachDeletedInstance(instance);
}
var $081ef12b46fbcaa0$var$preloadPropsMap = new Map(), $081ef12b46fbcaa0$var$preconnectsSet = new Set();
function $081ef12b46fbcaa0$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $081ef12b46fbcaa0$var$previousDispatcher = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.d;
$081ef12b46fbcaa0$var$ReactDOMSharedInternals.d = {
    f: $081ef12b46fbcaa0$var$flushSyncWork,
    r: $081ef12b46fbcaa0$var$requestFormReset,
    D: $081ef12b46fbcaa0$var$prefetchDNS,
    C: $081ef12b46fbcaa0$var$preconnect,
    L: $081ef12b46fbcaa0$var$preload,
    m: $081ef12b46fbcaa0$var$preloadModule,
    X: $081ef12b46fbcaa0$var$preinitScript,
    S: $081ef12b46fbcaa0$var$preinitStyle,
    M: $081ef12b46fbcaa0$var$preinitModuleScript
};
function $081ef12b46fbcaa0$var$flushSyncWork() {
    var previousWasRendering = $081ef12b46fbcaa0$var$previousDispatcher.f(), wasRendering = $081ef12b46fbcaa0$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $081ef12b46fbcaa0$var$requestFormReset(form) {
    var formInst = $081ef12b46fbcaa0$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $081ef12b46fbcaa0$var$requestFormReset$1(formInst) : $081ef12b46fbcaa0$var$previousDispatcher.r(form);
}
var $081ef12b46fbcaa0$var$globalDocument = "undefined" === typeof document ? null : document;
function $081ef12b46fbcaa0$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $081ef12b46fbcaa0$var$preconnectsSet.has(limitedEscapedHref) || ($081ef12b46fbcaa0$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $081ef12b46fbcaa0$var$setInitialProperties(href, "link", rel), $081ef12b46fbcaa0$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $081ef12b46fbcaa0$var$prefetchDNS(href) {
    $081ef12b46fbcaa0$var$previousDispatcher.D(href);
    $081ef12b46fbcaa0$var$preconnectAs("dns-prefetch", href, null);
}
function $081ef12b46fbcaa0$var$preconnect(href, crossOrigin) {
    $081ef12b46fbcaa0$var$previousDispatcher.C(href, crossOrigin);
    $081ef12b46fbcaa0$var$preconnectAs("preconnect", href, crossOrigin);
}
function $081ef12b46fbcaa0$var$preload(href, as, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $081ef12b46fbcaa0$var$getStyleKey(href);
                break;
            case "script":
                key = $081ef12b46fbcaa0$var$getScriptKey(href);
        }
        $081ef12b46fbcaa0$var$preloadPropsMap.has(key) || (href = $081ef12b46fbcaa0$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $081ef12b46fbcaa0$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $081ef12b46fbcaa0$var$setInitialProperties(as, "link", href), $081ef12b46fbcaa0$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $081ef12b46fbcaa0$var$preloadModule(href, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.m(href, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $081ef12b46fbcaa0$var$getScriptKey(href);
        }
        if (!$081ef12b46fbcaa0$var$preloadPropsMap.has(key) && (href = $081ef12b46fbcaa0$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $081ef12b46fbcaa0$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $081ef12b46fbcaa0$var$setInitialProperties(as, "link", href);
            $081ef12b46fbcaa0$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $081ef12b46fbcaa0$var$preinitStyle(href, precedence, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $081ef12b46fbcaa0$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $081ef12b46fbcaa0$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $081ef12b46fbcaa0$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $081ef12b46fbcaa0$var$markNodeAsHoistable(link);
                $081ef12b46fbcaa0$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $081ef12b46fbcaa0$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $081ef12b46fbcaa0$var$preinitScript(src, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.X(src, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $081ef12b46fbcaa0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $081ef12b46fbcaa0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key)), resource || (src = $081ef12b46fbcaa0$var$assign({
            src: src,
            async: !0
        }, options), (options = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $081ef12b46fbcaa0$var$markNodeAsHoistable(resource), $081ef12b46fbcaa0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $081ef12b46fbcaa0$var$preinitModuleScript(src, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.M(src, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $081ef12b46fbcaa0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $081ef12b46fbcaa0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key)), resource || (src = $081ef12b46fbcaa0$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $081ef12b46fbcaa0$var$markNodeAsHoistable(resource), $081ef12b46fbcaa0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $081ef12b46fbcaa0$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $081ef12b46fbcaa0$var$rootInstanceStackCursor.current) ? $081ef12b46fbcaa0$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $081ef12b46fbcaa0$var$getStyleKey(pendingProps.href), pendingProps = $081ef12b46fbcaa0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $081ef12b46fbcaa0$var$getStyleKey(pendingProps.href);
                var styles$244 = $081ef12b46fbcaa0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $081ef12b46fbcaa0$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $081ef12b46fbcaa0$var$preloadPropsMap.set(type, pendingProps), styles$244 || $081ef12b46fbcaa0$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $081ef12b46fbcaa0$var$getScriptKey(pendingProps), pendingProps = $081ef12b46fbcaa0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(444, type));
    }
}
function $081ef12b46fbcaa0$var$getStyleKey(href) {
    return 'href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $081ef12b46fbcaa0$var$stylesheetPropsFromRawProps(rawProps) {
    return $081ef12b46fbcaa0$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $081ef12b46fbcaa0$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $081ef12b46fbcaa0$var$setInitialProperties(key, "link", preloadProps), $081ef12b46fbcaa0$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $081ef12b46fbcaa0$var$getScriptKey(src) {
    return '[src="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $081ef12b46fbcaa0$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $081ef12b46fbcaa0$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $081ef12b46fbcaa0$var$markNodeAsHoistable(instance), instance;
            var styleProps = $081ef12b46fbcaa0$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
            $081ef12b46fbcaa0$var$setInitialProperties(instance, "style", styleProps);
            $081ef12b46fbcaa0$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $081ef12b46fbcaa0$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $081ef12b46fbcaa0$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $081ef12b46fbcaa0$var$stylesheetPropsFromRawProps(props);
            (styleProps = $081ef12b46fbcaa0$var$preloadPropsMap.get(styleProps)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $081ef12b46fbcaa0$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $081ef12b46fbcaa0$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $081ef12b46fbcaa0$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $081ef12b46fbcaa0$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $081ef12b46fbcaa0$var$preloadPropsMap.get(instance$250)) instance = $081ef12b46fbcaa0$var$assign({}, props), $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(styleProps);
            $081ef12b46fbcaa0$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $081ef12b46fbcaa0$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $081ef12b46fbcaa0$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $081ef12b46fbcaa0$var$tagCaches = null;
function $081ef12b46fbcaa0$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $081ef12b46fbcaa0$var$tagCaches) {
        var cache = new Map();
        var caches = $081ef12b46fbcaa0$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $081ef12b46fbcaa0$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$081ef12b46fbcaa0$var$internalHoistableMarker] || node[$081ef12b46fbcaa0$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $081ef12b46fbcaa0$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $081ef12b46fbcaa0$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $081ef12b46fbcaa0$var$suspendedState = null;
function $081ef12b46fbcaa0$var$noop() {}
function $081ef12b46fbcaa0$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $081ef12b46fbcaa0$var$suspendedState) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(475));
    var state = $081ef12b46fbcaa0$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $081ef12b46fbcaa0$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $081ef12b46fbcaa0$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $081ef12b46fbcaa0$var$stylesheetPropsFromRawProps(props);
            (key = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $081ef12b46fbcaa0$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $081ef12b46fbcaa0$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $081ef12b46fbcaa0$var$waitForCommitToBeReady() {
    if (null === $081ef12b46fbcaa0$var$suspendedState) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(475));
    var state = $081ef12b46fbcaa0$var$suspendedState;
    state.stylesheets && 0 === state.count && $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $081ef12b46fbcaa0$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $081ef12b46fbcaa0$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $081ef12b46fbcaa0$var$precedencesByRoot = null;
function $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $081ef12b46fbcaa0$var$precedencesByRoot = new Map(), resources.forEach($081ef12b46fbcaa0$var$insertStylesheetIntoRoot, state), $081ef12b46fbcaa0$var$precedencesByRoot = null, $081ef12b46fbcaa0$var$onUnsuspend.call(state));
}
function $081ef12b46fbcaa0$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $081ef12b46fbcaa0$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $081ef12b46fbcaa0$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $081ef12b46fbcaa0$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $081ef12b46fbcaa0$var$HostTransitionContext = {
    $$typeof: $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $081ef12b46fbcaa0$var$sharedNotPendingObject,
    _currentValue2: $081ef12b46fbcaa0$var$sharedNotPendingObject,
    _threadCount: 0
};
function $081ef12b46fbcaa0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $081ef12b46fbcaa0$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $081ef12b46fbcaa0$var$createLaneMap(0);
    this.hiddenUpdates = $081ef12b46fbcaa0$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $081ef12b46fbcaa0$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $081ef12b46fbcaa0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $081ef12b46fbcaa0$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $081ef12b46fbcaa0$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $081ef12b46fbcaa0$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $081ef12b46fbcaa0$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $081ef12b46fbcaa0$var$emptyContextObject;
    parentComponent = $081ef12b46fbcaa0$var$emptyContextObject;
    return parentComponent;
}
function $081ef12b46fbcaa0$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $081ef12b46fbcaa0$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $081ef12b46fbcaa0$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $081ef12b46fbcaa0$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(element, rootFiber, lane), $081ef12b46fbcaa0$var$entangleTransitions(element, rootFiber, lane));
}
function $081ef12b46fbcaa0$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $081ef12b46fbcaa0$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $081ef12b46fbcaa0$var$markRetryLaneImpl(fiber, retryLane);
}
function $081ef12b46fbcaa0$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $081ef12b46fbcaa0$var$_enabled = !0;
function $081ef12b46fbcaa0$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
    $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2, $081ef12b46fbcaa0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $081ef12b46fbcaa0$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
    $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 8, $081ef12b46fbcaa0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $081ef12b46fbcaa0$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($081ef12b46fbcaa0$var$_enabled) {
        var blockedOn = $081ef12b46fbcaa0$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $081ef12b46fbcaa0$var$return_targetInst, targetContainer), $081ef12b46fbcaa0$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($081ef12b46fbcaa0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($081ef12b46fbcaa0$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $081ef12b46fbcaa0$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $081ef12b46fbcaa0$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $081ef12b46fbcaa0$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $081ef12b46fbcaa0$var$ensureRootIsScheduled(fiber);
                                0 === ($081ef12b46fbcaa0$var$executionContext & 6) && ($081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime = $081ef12b46fbcaa0$var$now() + 500, $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, 2), $081ef12b46fbcaa0$var$flushSyncWork$1(), $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $081ef12b46fbcaa0$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $081ef12b46fbcaa0$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $081ef12b46fbcaa0$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $081ef12b46fbcaa0$var$getEventTarget(nativeEvent);
    return $081ef12b46fbcaa0$var$findInstanceBlockingTarget(nativeEvent);
}
var $081ef12b46fbcaa0$var$return_targetInst = null;
function $081ef12b46fbcaa0$var$findInstanceBlockingTarget(targetNode) {
    $081ef12b46fbcaa0$var$return_targetInst = null;
    targetNode = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $081ef12b46fbcaa0$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $081ef12b46fbcaa0$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $081ef12b46fbcaa0$var$return_targetInst = targetNode;
    return null;
}
function $081ef12b46fbcaa0$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($081ef12b46fbcaa0$var$getCurrentPriorityLevel()){
                case $081ef12b46fbcaa0$var$ImmediatePriority:
                    return 2;
                case $081ef12b46fbcaa0$var$UserBlockingPriority:
                    return 8;
                case $081ef12b46fbcaa0$var$NormalPriority$1:
                case $081ef12b46fbcaa0$var$LowPriority:
                    return 32;
                case $081ef12b46fbcaa0$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $081ef12b46fbcaa0$var$hasScheduledReplayAttempt = !1, $081ef12b46fbcaa0$var$queuedFocus = null, $081ef12b46fbcaa0$var$queuedDrag = null, $081ef12b46fbcaa0$var$queuedMouse = null, $081ef12b46fbcaa0$var$queuedPointers = new Map(), $081ef12b46fbcaa0$var$queuedPointerCaptures = new Map(), $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets = [], $081ef12b46fbcaa0$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $081ef12b46fbcaa0$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $081ef12b46fbcaa0$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $081ef12b46fbcaa0$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $081ef12b46fbcaa0$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $081ef12b46fbcaa0$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $081ef12b46fbcaa0$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $081ef12b46fbcaa0$var$getInstanceFromNode(blockedOn), null !== blockedOn && $081ef12b46fbcaa0$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $081ef12b46fbcaa0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $081ef12b46fbcaa0$var$queuedFocus = $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $081ef12b46fbcaa0$var$queuedDrag = $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $081ef12b46fbcaa0$var$queuedMouse = $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $081ef12b46fbcaa0$var$queuedPointers.set(pointerId, $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $081ef12b46fbcaa0$var$queuedPointerCaptures.set(pointerId, $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $081ef12b46fbcaa0$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $081ef12b46fbcaa0$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $081ef12b46fbcaa0$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
                            lane = $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $081ef12b46fbcaa0$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $081ef12b46fbcaa0$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $081ef12b46fbcaa0$var$currentReplayingEvent = null;
        } else return targetContainers = $081ef12b46fbcaa0$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $081ef12b46fbcaa0$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $081ef12b46fbcaa0$var$replayUnblockedEvents() {
    $081ef12b46fbcaa0$var$hasScheduledReplayAttempt = !1;
    null !== $081ef12b46fbcaa0$var$queuedFocus && $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent($081ef12b46fbcaa0$var$queuedFocus) && ($081ef12b46fbcaa0$var$queuedFocus = null);
    null !== $081ef12b46fbcaa0$var$queuedDrag && $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent($081ef12b46fbcaa0$var$queuedDrag) && ($081ef12b46fbcaa0$var$queuedDrag = null);
    null !== $081ef12b46fbcaa0$var$queuedMouse && $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent($081ef12b46fbcaa0$var$queuedMouse) && ($081ef12b46fbcaa0$var$queuedMouse = null);
    $081ef12b46fbcaa0$var$queuedPointers.forEach($081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEventInMap);
    $081ef12b46fbcaa0$var$queuedPointerCaptures.forEach($081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEventInMap);
}
function $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $081ef12b46fbcaa0$var$hasScheduledReplayAttempt || ($081ef12b46fbcaa0$var$hasScheduledReplayAttempt = !0, $fndEB.unstable_scheduleCallback($fndEB.unstable_NormalPriority, $081ef12b46fbcaa0$var$replayUnblockedEvents)));
}
var $081ef12b46fbcaa0$var$lastScheduledReplayQueue = null;
function $081ef12b46fbcaa0$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $081ef12b46fbcaa0$var$lastScheduledReplayQueue !== formReplayingQueue && ($081ef12b46fbcaa0$var$lastScheduledReplayQueue = formReplayingQueue, $fndEB.unstable_scheduleCallback($fndEB.unstable_NormalPriority, function() {
        $081ef12b46fbcaa0$var$lastScheduledReplayQueue === formReplayingQueue && ($081ef12b46fbcaa0$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $081ef12b46fbcaa0$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $081ef12b46fbcaa0$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $081ef12b46fbcaa0$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $081ef12b46fbcaa0$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $081ef12b46fbcaa0$var$queuedFocus && $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked($081ef12b46fbcaa0$var$queuedFocus, unblocked);
    null !== $081ef12b46fbcaa0$var$queuedDrag && $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked($081ef12b46fbcaa0$var$queuedDrag, unblocked);
    null !== $081ef12b46fbcaa0$var$queuedMouse && $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked($081ef12b46fbcaa0$var$queuedMouse, unblocked);
    $081ef12b46fbcaa0$var$queuedPointers.forEach(unblock);
    $081ef12b46fbcaa0$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.length && (i = $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$081ef12b46fbcaa0$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$081ef12b46fbcaa0$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $081ef12b46fbcaa0$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$081ef12b46fbcaa0$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $081ef12b46fbcaa0$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $081ef12b46fbcaa0$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $081ef12b46fbcaa0$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$081ef12b46fbcaa0$var$ReactDOMHydrationRoot.prototype.render = $081ef12b46fbcaa0$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(409));
    var current = root.current, lane = $081ef12b46fbcaa0$var$requestUpdateLane();
    $081ef12b46fbcaa0$var$updateContainerImpl(current, lane, children, root, null, null);
};
$081ef12b46fbcaa0$var$ReactDOMHydrationRoot.prototype.unmount = $081ef12b46fbcaa0$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $081ef12b46fbcaa0$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $081ef12b46fbcaa0$var$flushSyncWork$1();
        container[$081ef12b46fbcaa0$var$internalContainerInstanceKey] = null;
    }
};
function $081ef12b46fbcaa0$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$081ef12b46fbcaa0$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $081ef12b46fbcaa0$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets[i].priority; i++);
        $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $081ef12b46fbcaa0$var$attemptExplicitHydrationTarget(target);
    }
};
var $081ef12b46fbcaa0$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $jGswQ.version;
if ("19.1.1" !== $081ef12b46fbcaa0$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(527, $081ef12b46fbcaa0$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$081ef12b46fbcaa0$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $081ef12b46fbcaa0$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $081ef12b46fbcaa0$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $081ef12b46fbcaa0$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $081ef12b46fbcaa0$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $081ef12b46fbcaa0$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$081ef12b46fbcaa0$var$hook$jscomp$inline_2257.isDisabled && $081ef12b46fbcaa0$var$hook$jscomp$inline_2257.supportsFiber) try {
        $081ef12b46fbcaa0$var$rendererID = $081ef12b46fbcaa0$var$hook$jscomp$inline_2257.inject($081ef12b46fbcaa0$var$internals$jscomp$inline_2256), $081ef12b46fbcaa0$var$injectedHook = $081ef12b46fbcaa0$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$081ef12b46fbcaa0$export$882461b6382ed46c = function(container, options) {
    if (!$081ef12b46fbcaa0$var$isValidContainer(container)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $081ef12b46fbcaa0$var$defaultOnUncaughtError, onCaughtError = $081ef12b46fbcaa0$var$defaultOnCaughtError, onRecoverableError = $081ef12b46fbcaa0$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $081ef12b46fbcaa0$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$081ef12b46fbcaa0$var$internalContainerInstanceKey] = options.current;
    $081ef12b46fbcaa0$var$listenToAllSupportedEvents(container);
    return new $081ef12b46fbcaa0$var$ReactDOMRoot(options);
};
$081ef12b46fbcaa0$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$081ef12b46fbcaa0$var$isValidContainer(container)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $081ef12b46fbcaa0$var$defaultOnUncaughtError, onCaughtError = $081ef12b46fbcaa0$var$defaultOnCaughtError, onRecoverableError = $081ef12b46fbcaa0$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $081ef12b46fbcaa0$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $081ef12b46fbcaa0$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $081ef12b46fbcaa0$var$requestUpdateLane();
    isStrictMode = $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $081ef12b46fbcaa0$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $081ef12b46fbcaa0$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $081ef12b46fbcaa0$var$markRootUpdated$1(initialChildren, options);
    $081ef12b46fbcaa0$var$ensureRootIsScheduled(initialChildren);
    container[$081ef12b46fbcaa0$var$internalContainerInstanceKey] = initialChildren.current;
    $081ef12b46fbcaa0$var$listenToAllSupportedEvents(container);
    return new $081ef12b46fbcaa0$var$ReactDOMHydrationRoot(initialChildren);
};
$081ef12b46fbcaa0$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("fndEB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ahkwg"));

});
parcelRegister("ahkwg", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $77bb68a4b10b9c90$export$c4744153514ff05d; }, function (v) { return $77bb68a4b10b9c90$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $77bb68a4b10b9c90$export$3e506c1ccc9cc1a7; }, function (v) { return $77bb68a4b10b9c90$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $77bb68a4b10b9c90$export$e26fe2ed2fa76875; }, function (v) { return $77bb68a4b10b9c90$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $77bb68a4b10b9c90$export$502329bbf4b505b1; }, function (v) { return $77bb68a4b10b9c90$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $77bb68a4b10b9c90$export$6e3807111c4874c4; }, function (v) { return $77bb68a4b10b9c90$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $77bb68a4b10b9c90$export$c27134553091fb3a; }, function (v) { return $77bb68a4b10b9c90$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $77bb68a4b10b9c90$export$33ee1acdc04fd2a2; }, function (v) { return $77bb68a4b10b9c90$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $77bb68a4b10b9c90$export$b00a404bbd5edef2; }, function (v) { return $77bb68a4b10b9c90$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $77bb68a4b10b9c90$export$d66a1c1c77bd778b; }, function (v) { return $77bb68a4b10b9c90$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $77bb68a4b10b9c90$export$d3dfb8e4810cb555; }, function (v) { return $77bb68a4b10b9c90$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $77bb68a4b10b9c90$export$72fdf0e06517287b; }, function (v) { return $77bb68a4b10b9c90$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $77bb68a4b10b9c90$export$816d2913ae6b83b1; }, function (v) { return $77bb68a4b10b9c90$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $77bb68a4b10b9c90$export$61bcfe829111a1d0; }, function (v) { return $77bb68a4b10b9c90$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $77bb68a4b10b9c90$export$7ee8c9beb337bc3f; }, function (v) { return $77bb68a4b10b9c90$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $77bb68a4b10b9c90$export$b5836b71941fa3ed; }, function (v) { return $77bb68a4b10b9c90$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $77bb68a4b10b9c90$export$cf845f2c119da08a; }, function (v) { return $77bb68a4b10b9c90$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77bb68a4b10b9c90$export$c4744153514ff05d;
var $77bb68a4b10b9c90$export$3e506c1ccc9cc1a7;
var $77bb68a4b10b9c90$export$e26fe2ed2fa76875;
var $77bb68a4b10b9c90$export$502329bbf4b505b1;
var $77bb68a4b10b9c90$export$6e3807111c4874c4;
var $77bb68a4b10b9c90$export$c27134553091fb3a;
var $77bb68a4b10b9c90$export$33ee1acdc04fd2a2;
var $77bb68a4b10b9c90$export$b00a404bbd5edef2;
var $77bb68a4b10b9c90$export$d66a1c1c77bd778b;
var $77bb68a4b10b9c90$export$d3dfb8e4810cb555;
var $77bb68a4b10b9c90$export$72fdf0e06517287b;
var $77bb68a4b10b9c90$export$816d2913ae6b83b1;
var $77bb68a4b10b9c90$export$61bcfe829111a1d0;
var $77bb68a4b10b9c90$export$7ee8c9beb337bc3f;
var $77bb68a4b10b9c90$export$b5836b71941fa3ed;
var $77bb68a4b10b9c90$export$cf845f2c119da08a;
"use strict";
function $77bb68a4b10b9c90$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $77bb68a4b10b9c90$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $77bb68a4b10b9c90$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $77bb68a4b10b9c90$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $77bb68a4b10b9c90$var$compare(left, last)) rightIndex < length && 0 > $77bb68a4b10b9c90$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $77bb68a4b10b9c90$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $77bb68a4b10b9c90$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$77bb68a4b10b9c90$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $77bb68a4b10b9c90$var$localPerformance = performance;
    $77bb68a4b10b9c90$export$c4744153514ff05d = function() {
        return $77bb68a4b10b9c90$var$localPerformance.now();
    };
} else {
    var $77bb68a4b10b9c90$var$localDate = Date, $77bb68a4b10b9c90$var$initialTime = $77bb68a4b10b9c90$var$localDate.now();
    $77bb68a4b10b9c90$export$c4744153514ff05d = function() {
        return $77bb68a4b10b9c90$var$localDate.now() - $77bb68a4b10b9c90$var$initialTime;
    };
}
var $77bb68a4b10b9c90$var$taskQueue = [], $77bb68a4b10b9c90$var$timerQueue = [], $77bb68a4b10b9c90$var$taskIdCounter = 1, $77bb68a4b10b9c90$var$currentTask = null, $77bb68a4b10b9c90$var$currentPriorityLevel = 3, $77bb68a4b10b9c90$var$isPerformingWork = !1, $77bb68a4b10b9c90$var$isHostCallbackScheduled = !1, $77bb68a4b10b9c90$var$isHostTimeoutScheduled = !1, $77bb68a4b10b9c90$var$needsPaint = !1, $77bb68a4b10b9c90$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $77bb68a4b10b9c90$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $77bb68a4b10b9c90$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $77bb68a4b10b9c90$var$advanceTimers(currentTime) {
    for(var timer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue); null !== timer;){
        if (null === timer.callback) $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$timerQueue);
        else if (timer.startTime <= currentTime) $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$timerQueue), timer.sortIndex = timer.expirationTime, $77bb68a4b10b9c90$var$push($77bb68a4b10b9c90$var$taskQueue, timer);
        else break;
        timer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue);
    }
}
function $77bb68a4b10b9c90$var$handleTimeout(currentTime) {
    $77bb68a4b10b9c90$var$isHostTimeoutScheduled = !1;
    $77bb68a4b10b9c90$var$advanceTimers(currentTime);
    if (!$77bb68a4b10b9c90$var$isHostCallbackScheduled) {
        if (null !== $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue)) $77bb68a4b10b9c90$var$isHostCallbackScheduled = !0, $77bb68a4b10b9c90$var$isMessageLoopRunning || ($77bb68a4b10b9c90$var$isMessageLoopRunning = !0, $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue);
            null !== firstTimer && $77bb68a4b10b9c90$var$requestHostTimeout($77bb68a4b10b9c90$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $77bb68a4b10b9c90$var$isMessageLoopRunning = !1, $77bb68a4b10b9c90$var$taskTimeoutID = -1, $77bb68a4b10b9c90$var$frameInterval = 5, $77bb68a4b10b9c90$var$startTime = -1;
function $77bb68a4b10b9c90$var$shouldYieldToHost() {
    return $77bb68a4b10b9c90$var$needsPaint ? !0 : $77bb68a4b10b9c90$export$c4744153514ff05d() - $77bb68a4b10b9c90$var$startTime < $77bb68a4b10b9c90$var$frameInterval ? !1 : !0;
}
function $77bb68a4b10b9c90$var$performWorkUntilDeadline() {
    $77bb68a4b10b9c90$var$needsPaint = !1;
    if ($77bb68a4b10b9c90$var$isMessageLoopRunning) {
        var currentTime = $77bb68a4b10b9c90$export$c4744153514ff05d();
        $77bb68a4b10b9c90$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $77bb68a4b10b9c90$var$isHostCallbackScheduled = !1;
                $77bb68a4b10b9c90$var$isHostTimeoutScheduled && ($77bb68a4b10b9c90$var$isHostTimeoutScheduled = !1, $77bb68a4b10b9c90$var$localClearTimeout($77bb68a4b10b9c90$var$taskTimeoutID), $77bb68a4b10b9c90$var$taskTimeoutID = -1);
                $77bb68a4b10b9c90$var$isPerformingWork = !0;
                var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
                try {
                    b: {
                        $77bb68a4b10b9c90$var$advanceTimers(currentTime);
                        for($77bb68a4b10b9c90$var$currentTask = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue); null !== $77bb68a4b10b9c90$var$currentTask && !($77bb68a4b10b9c90$var$currentTask.expirationTime > currentTime && $77bb68a4b10b9c90$var$shouldYieldToHost());){
                            var callback = $77bb68a4b10b9c90$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $77bb68a4b10b9c90$var$currentTask.callback = null;
                                $77bb68a4b10b9c90$var$currentPriorityLevel = $77bb68a4b10b9c90$var$currentTask.priorityLevel;
                                var continuationCallback = callback($77bb68a4b10b9c90$var$currentTask.expirationTime <= currentTime);
                                currentTime = $77bb68a4b10b9c90$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $77bb68a4b10b9c90$var$currentTask.callback = continuationCallback;
                                    $77bb68a4b10b9c90$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $77bb68a4b10b9c90$var$currentTask === $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue) && $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$taskQueue);
                                $77bb68a4b10b9c90$var$advanceTimers(currentTime);
                            } else $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$taskQueue);
                            $77bb68a4b10b9c90$var$currentTask = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue);
                        }
                        if (null !== $77bb68a4b10b9c90$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue);
                            null !== firstTimer && $77bb68a4b10b9c90$var$requestHostTimeout($77bb68a4b10b9c90$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $77bb68a4b10b9c90$var$currentTask = null, $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel, $77bb68a4b10b9c90$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline() : $77bb68a4b10b9c90$var$isMessageLoopRunning = !1;
        }
    }
}
var $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $77bb68a4b10b9c90$var$localSetImmediate) $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline = function() {
    $77bb68a4b10b9c90$var$localSetImmediate($77bb68a4b10b9c90$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $77bb68a4b10b9c90$var$channel = new MessageChannel(), $77bb68a4b10b9c90$var$port = $77bb68a4b10b9c90$var$channel.port2;
    $77bb68a4b10b9c90$var$channel.port1.onmessage = $77bb68a4b10b9c90$var$performWorkUntilDeadline;
    $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline = function() {
        $77bb68a4b10b9c90$var$port.postMessage(null);
    };
} else $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline = function() {
    $77bb68a4b10b9c90$var$localSetTimeout($77bb68a4b10b9c90$var$performWorkUntilDeadline, 0);
};
function $77bb68a4b10b9c90$var$requestHostTimeout(callback, ms) {
    $77bb68a4b10b9c90$var$taskTimeoutID = $77bb68a4b10b9c90$var$localSetTimeout(function() {
        callback($77bb68a4b10b9c90$export$c4744153514ff05d());
    }, ms);
}
$77bb68a4b10b9c90$export$3e506c1ccc9cc1a7 = 5;
$77bb68a4b10b9c90$export$e26fe2ed2fa76875 = 1;
$77bb68a4b10b9c90$export$502329bbf4b505b1 = 4;
$77bb68a4b10b9c90$export$6e3807111c4874c4 = 3;
$77bb68a4b10b9c90$export$c27134553091fb3a = null;
$77bb68a4b10b9c90$export$33ee1acdc04fd2a2 = 2;
$77bb68a4b10b9c90$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$77bb68a4b10b9c90$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $77bb68a4b10b9c90$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$77bb68a4b10b9c90$export$d3dfb8e4810cb555 = function() {
    return $77bb68a4b10b9c90$var$currentPriorityLevel;
};
$77bb68a4b10b9c90$export$72fdf0e06517287b = function(eventHandler) {
    switch($77bb68a4b10b9c90$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    $77bb68a4b10b9c90$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$77bb68a4b10b9c90$export$816d2913ae6b83b1 = function() {
    $77bb68a4b10b9c90$var$needsPaint = !0;
};
$77bb68a4b10b9c90$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    $77bb68a4b10b9c90$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$77bb68a4b10b9c90$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $77bb68a4b10b9c90$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $77bb68a4b10b9c90$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $77bb68a4b10b9c90$var$push($77bb68a4b10b9c90$var$timerQueue, priorityLevel), null === $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue) && priorityLevel === $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue) && ($77bb68a4b10b9c90$var$isHostTimeoutScheduled ? ($77bb68a4b10b9c90$var$localClearTimeout($77bb68a4b10b9c90$var$taskTimeoutID), $77bb68a4b10b9c90$var$taskTimeoutID = -1) : $77bb68a4b10b9c90$var$isHostTimeoutScheduled = !0, $77bb68a4b10b9c90$var$requestHostTimeout($77bb68a4b10b9c90$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $77bb68a4b10b9c90$var$push($77bb68a4b10b9c90$var$taskQueue, priorityLevel), $77bb68a4b10b9c90$var$isHostCallbackScheduled || $77bb68a4b10b9c90$var$isPerformingWork || ($77bb68a4b10b9c90$var$isHostCallbackScheduled = !0, $77bb68a4b10b9c90$var$isMessageLoopRunning || ($77bb68a4b10b9c90$var$isMessageLoopRunning = !0, $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$77bb68a4b10b9c90$export$b5836b71941fa3ed = $77bb68a4b10b9c90$var$shouldYieldToHost;
$77bb68a4b10b9c90$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
        $77bb68a4b10b9c90$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5hICV", function(module, exports) {
'use strict';
function $3d91283959fa027f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3d91283959fa027f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3d91283959fa027f$var$checkDCE();

module.exports = (parcelRequire("7NLsj"));

});
parcelRegister("7NLsj", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0; }, function (v) { return $5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $5ae1ebb1e77c87b4$export$d39a5bbd09211389; }, function (v) { return $5ae1ebb1e77c87b4$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4; }, function (v) { return $5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $5ae1ebb1e77c87b4$export$a0816fa17a9e79be; }, function (v) { return $5ae1ebb1e77c87b4$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $5ae1ebb1e77c87b4$export$7292efcadded39f3; }, function (v) { return $5ae1ebb1e77c87b4$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $5ae1ebb1e77c87b4$export$da407abadb9b8f86; }, function (v) { return $5ae1ebb1e77c87b4$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $5ae1ebb1e77c87b4$export$314cfea32580671c; }, function (v) { return $5ae1ebb1e77c87b4$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $5ae1ebb1e77c87b4$export$513ccb98c53b8039; }, function (v) { return $5ae1ebb1e77c87b4$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $5ae1ebb1e77c87b4$export$dbca993bc2d264a; }, function (v) { return $5ae1ebb1e77c87b4$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $5ae1ebb1e77c87b4$export$4797a8006f0655d0; }, function (v) { return $5ae1ebb1e77c87b4$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5ae1ebb1e77c87b4$export$c78a37762a8d58e1; }, function (v) { return $5ae1ebb1e77c87b4$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $5ae1ebb1e77c87b4$export$606f11b2eb45ecc6; }, function (v) { return $5ae1ebb1e77c87b4$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e; }, function (v) { return $5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $5ae1ebb1e77c87b4$export$83d89fbfd8236492; }, function (v) { return $5ae1ebb1e77c87b4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0;
var $5ae1ebb1e77c87b4$export$d39a5bbd09211389;
var $5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4;
var $5ae1ebb1e77c87b4$export$a0816fa17a9e79be;
var $5ae1ebb1e77c87b4$export$7292efcadded39f3;
var $5ae1ebb1e77c87b4$export$da407abadb9b8f86;
var $5ae1ebb1e77c87b4$export$314cfea32580671c;
var $5ae1ebb1e77c87b4$export$513ccb98c53b8039;
var $5ae1ebb1e77c87b4$export$dbca993bc2d264a;
var $5ae1ebb1e77c87b4$export$4797a8006f0655d0;
var $5ae1ebb1e77c87b4$export$c78a37762a8d58e1;
var $5ae1ebb1e77c87b4$export$606f11b2eb45ecc6;
var $5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e;
var $5ae1ebb1e77c87b4$export$83d89fbfd8236492;
"use strict";

var $jGswQ = parcelRequire("jGswQ");
function $5ae1ebb1e77c87b4$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5ae1ebb1e77c87b4$var$noop() {}
var $5ae1ebb1e77c87b4$var$Internals = {
    d: {
        f: $5ae1ebb1e77c87b4$var$noop,
        r: function() {
            throw Error($5ae1ebb1e77c87b4$var$formatProdErrorMessage(522));
        },
        D: $5ae1ebb1e77c87b4$var$noop,
        C: $5ae1ebb1e77c87b4$var$noop,
        L: $5ae1ebb1e77c87b4$var$noop,
        m: $5ae1ebb1e77c87b4$var$noop,
        X: $5ae1ebb1e77c87b4$var$noop,
        S: $5ae1ebb1e77c87b4$var$noop,
        M: $5ae1ebb1e77c87b4$var$noop
    },
    p: 0,
    findDOMNode: null
}, $5ae1ebb1e77c87b4$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $5ae1ebb1e77c87b4$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5ae1ebb1e77c87b4$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $5ae1ebb1e77c87b4$var$ReactSharedInternals = $jGswQ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0 = $5ae1ebb1e77c87b4$var$Internals;
$5ae1ebb1e77c87b4$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($5ae1ebb1e77c87b4$var$formatProdErrorMessage(299));
    return $5ae1ebb1e77c87b4$var$createPortal$1(children, container, null, key);
};
$5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $5ae1ebb1e77c87b4$var$ReactSharedInternals.T, previousUpdatePriority = $5ae1ebb1e77c87b4$var$Internals.p;
    try {
        if ($5ae1ebb1e77c87b4$var$ReactSharedInternals.T = null, $5ae1ebb1e77c87b4$var$Internals.p = 2, fn) return fn();
    } finally{
        $5ae1ebb1e77c87b4$var$ReactSharedInternals.T = previousTransition, $5ae1ebb1e77c87b4$var$Internals.p = previousUpdatePriority, $5ae1ebb1e77c87b4$var$Internals.d.f();
    }
};
$5ae1ebb1e77c87b4$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $5ae1ebb1e77c87b4$var$Internals.d.C(href, options));
};
$5ae1ebb1e77c87b4$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $5ae1ebb1e77c87b4$var$Internals.d.D(href);
};
$5ae1ebb1e77c87b4$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $5ae1ebb1e77c87b4$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $5ae1ebb1e77c87b4$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$5ae1ebb1e77c87b4$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $5ae1ebb1e77c87b4$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $5ae1ebb1e77c87b4$var$Internals.d.M(href);
    }
};
$5ae1ebb1e77c87b4$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(as, options.crossOrigin);
        $5ae1ebb1e77c87b4$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$5ae1ebb1e77c87b4$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $5ae1ebb1e77c87b4$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $5ae1ebb1e77c87b4$var$Internals.d.m(href);
    }
};
$5ae1ebb1e77c87b4$export$4797a8006f0655d0 = function(form) {
    $5ae1ebb1e77c87b4$var$Internals.d.r(form);
};
$5ae1ebb1e77c87b4$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$5ae1ebb1e77c87b4$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $5ae1ebb1e77c87b4$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e = function() {
    return $5ae1ebb1e77c87b4$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$5ae1ebb1e77c87b4$export$83d89fbfd8236492 = "19.1.1";

});



parcelRegister("8CEvx", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $64714b52f75a4b07$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $64714b52f75a4b07$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $64714b52f75a4b07$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $64714b52f75a4b07$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "ScrollRestoration", function () { return $64714b52f75a4b07$export$11aac1aab828f1fa; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("dI2iO")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("dI2iO")).useNavigate; });
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jGswQ = parcelRequire("jGswQ");

var $5hICV = parcelRequire("5hICV");

var $1ZyA7 = parcelRequire("1ZyA7");
var $dI2iO = parcelRequire("dI2iO");

var $1ZyA7 = parcelRequire("1ZyA7");
function $64714b52f75a4b07$var$_extends() {
    $64714b52f75a4b07$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $64714b52f75a4b07$var$_extends.apply(this, arguments);
}
function $64714b52f75a4b07$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $64714b52f75a4b07$var$defaultMethod = "get";
const $64714b52f75a4b07$var$defaultEncType = "application/x-www-form-urlencoded";
function $64714b52f75a4b07$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $64714b52f75a4b07$var$isButtonElement(object) {
    return $64714b52f75a4b07$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $64714b52f75a4b07$var$isFormElement(object) {
    return $64714b52f75a4b07$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $64714b52f75a4b07$var$isInputElement(object) {
    return $64714b52f75a4b07$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $64714b52f75a4b07$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $64714b52f75a4b07$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$64714b52f75a4b07$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $64714b52f75a4b07$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $64714b52f75a4b07$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $64714b52f75a4b07$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $64714b52f75a4b07$var$_formDataSupportsSubmitter = null;
function $64714b52f75a4b07$var$isFormDataSubmitterSupported() {
    if ($64714b52f75a4b07$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $64714b52f75a4b07$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $64714b52f75a4b07$var$_formDataSupportsSubmitter = true;
    }
    return $64714b52f75a4b07$var$_formDataSupportsSubmitter;
}
const $64714b52f75a4b07$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $64714b52f75a4b07$var$getFormEncType(encType) {
    if (encType != null && !$64714b52f75a4b07$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $64714b52f75a4b07$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($64714b52f75a4b07$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1ZyA7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $64714b52f75a4b07$var$defaultMethod;
        encType = $64714b52f75a4b07$var$getFormEncType(target.getAttribute("enctype")) || $64714b52f75a4b07$var$defaultEncType;
        formData = new FormData(target);
    } else if ($64714b52f75a4b07$var$isButtonElement(target) || $64714b52f75a4b07$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1ZyA7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $64714b52f75a4b07$var$defaultMethod;
        encType = $64714b52f75a4b07$var$getFormEncType(target.getAttribute("formenctype")) || $64714b52f75a4b07$var$getFormEncType(form.getAttribute("enctype")) || $64714b52f75a4b07$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$64714b52f75a4b07$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($64714b52f75a4b07$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $64714b52f75a4b07$var$defaultMethod;
        action = null;
        encType = $64714b52f75a4b07$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $64714b52f75a4b07$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $64714b52f75a4b07$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $64714b52f75a4b07$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $64714b52f75a4b07$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $64714b52f75a4b07$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $64714b52f75a4b07$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1ZyA7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $64714b52f75a4b07$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ZyA7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $64714b52f75a4b07$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $dI2iO.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $64714b52f75a4b07$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1ZyA7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $64714b52f75a4b07$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ZyA7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $64714b52f75a4b07$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $dI2iO.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $64714b52f75a4b07$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $64714b52f75a4b07$var$_extends({}, state, {
        errors: $64714b52f75a4b07$var$deserializeErrors(state.errors)
    });
    return state;
}
function $64714b52f75a4b07$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1ZyA7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $64714b52f75a4b07$export$7ad602f0e94e62d1 = /*#__PURE__*/ $jGswQ.createContext({
    isTransitioning: false
});
const $64714b52f75a4b07$export$148fd98d095596d4 = /*#__PURE__*/ $jGswQ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $64714b52f75a4b07$var$START_TRANSITION = "startTransition";
const $64714b52f75a4b07$var$startTransitionImpl = $jGswQ[$64714b52f75a4b07$var$START_TRANSITION];
const $64714b52f75a4b07$var$FLUSH_SYNC = "flushSync";
const $64714b52f75a4b07$var$flushSyncImpl = $5hICV[$64714b52f75a4b07$var$FLUSH_SYNC];
const $64714b52f75a4b07$var$USE_ID = "useId";
const $64714b52f75a4b07$var$useIdImpl = $jGswQ[$64714b52f75a4b07$var$USE_ID];
function $64714b52f75a4b07$var$startTransitionSafe(cb) {
    if ($64714b52f75a4b07$var$startTransitionImpl) $64714b52f75a4b07$var$startTransitionImpl(cb);
    else cb();
}
function $64714b52f75a4b07$var$flushSyncSafe(cb) {
    if ($64714b52f75a4b07$var$flushSyncImpl) $64714b52f75a4b07$var$flushSyncImpl(cb);
    else cb();
}
class $64714b52f75a4b07$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $64714b52f75a4b07$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $jGswQ.useState(router.state);
    let [pendingState, setPendingState] = $jGswQ.useState();
    let [vtContext, setVtContext] = $jGswQ.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $jGswQ.useState();
    let [transition, setTransition] = $jGswQ.useState();
    let [interruption, setInterruption] = $jGswQ.useState();
    let fetcherData = $jGswQ.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $jGswQ.useCallback((cb)=>{
        if (v7_startTransition) $64714b52f75a4b07$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $jGswQ.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $64714b52f75a4b07$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $64714b52f75a4b07$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $64714b52f75a4b07$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $64714b52f75a4b07$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $64714b52f75a4b07$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $jGswQ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $jGswQ.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $64714b52f75a4b07$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $jGswQ.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $jGswQ.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $jGswQ.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $jGswQ.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $jGswQ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jGswQ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jGswQ.createElement($jGswQ.Fragment, null, /*#__PURE__*/ $jGswQ.createElement((0, $dI2iO.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jGswQ.createElement((0, $dI2iO.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $jGswQ.createElement($64714b52f75a4b07$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $jGswQ.createElement($64714b52f75a4b07$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $jGswQ.createElement((0, $dI2iO.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $jGswQ.createElement($64714b52f75a4b07$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $64714b52f75a4b07$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $dI2iO.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $64714b52f75a4b07$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $jGswQ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ZyA7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jGswQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jGswQ.useCallback((newState)=>{
        v7_startTransition && $64714b52f75a4b07$var$startTransitionImpl ? $64714b52f75a4b07$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jGswQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jGswQ.createElement((0, $dI2iO.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $64714b52f75a4b07$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $jGswQ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ZyA7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jGswQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jGswQ.useCallback((newState)=>{
        v7_startTransition && $64714b52f75a4b07$var$startTransitionImpl ? $64714b52f75a4b07$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jGswQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jGswQ.createElement((0, $dI2iO.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $64714b52f75a4b07$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $jGswQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jGswQ.useCallback((newState)=>{
        v7_startTransition && $64714b52f75a4b07$var$startTransitionImpl ? $64714b52f75a4b07$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jGswQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jGswQ.createElement((0, $dI2iO.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $64714b52f75a4b07$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $64714b52f75a4b07$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $64714b52f75a4b07$export$a6c7ac8248d6e38a = /*#__PURE__*/ $jGswQ.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $64714b52f75a4b07$var$_objectWithoutPropertiesLoose(_ref7, $64714b52f75a4b07$var$_excluded);
    let { basename: basename } = $jGswQ.useContext((0, $dI2iO.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $64714b52f75a4b07$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($64714b52f75a4b07$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1ZyA7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $dI2iO.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $64714b52f75a4b07$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $jGswQ.createElement("a", $64714b52f75a4b07$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $64714b52f75a4b07$export$b0d92dbee9b5b60d = /*#__PURE__*/ $jGswQ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $64714b52f75a4b07$var$_objectWithoutPropertiesLoose(_ref8, $64714b52f75a4b07$var$_excluded2);
    let path = (0, $dI2iO.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $dI2iO.useLocation)();
    let routerState = $jGswQ.useContext((0, $dI2iO.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $jGswQ.useContext((0, $dI2iO.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $64714b52f75a4b07$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1ZyA7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $jGswQ.createElement($64714b52f75a4b07$export$a6c7ac8248d6e38a, $64714b52f75a4b07$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $64714b52f75a4b07$export$a7fed597f4b8afd8 = /*#__PURE__*/ $jGswQ.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $64714b52f75a4b07$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $64714b52f75a4b07$var$_objectWithoutPropertiesLoose(_ref9, $64714b52f75a4b07$var$_excluded3);
    let submit = $64714b52f75a4b07$export$47c85c6e3a081d3();
    let formAction = $64714b52f75a4b07$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $jGswQ.createElement("form", $64714b52f75a4b07$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $64714b52f75a4b07$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $64714b52f75a4b07$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $64714b52f75a4b07$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($64714b52f75a4b07$var$DataRouterHook || ($64714b52f75a4b07$var$DataRouterHook = {}));
var $64714b52f75a4b07$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($64714b52f75a4b07$var$DataRouterStateHook || ($64714b52f75a4b07$var$DataRouterStateHook = {}));
// Internal hooks
function $64714b52f75a4b07$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $64714b52f75a4b07$var$useDataRouterContext(hookName) {
    let ctx = $jGswQ.useContext((0, $dI2iO.UNSAFE_DataRouterContext));
    !ctx && (0, $1ZyA7.UNSAFE_invariant)(false);
    return ctx;
}
function $64714b52f75a4b07$var$useDataRouterState(hookName) {
    let state = $jGswQ.useContext((0, $dI2iO.UNSAFE_DataRouterStateContext));
    !state && (0, $1ZyA7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $64714b52f75a4b07$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $dI2iO.useNavigate)();
    let location = (0, $dI2iO.useLocation)();
    let path = (0, $dI2iO.useResolvedPath)(to, {
        relative: relative
    });
    return $jGswQ.useCallback((event)=>{
        if ($64714b52f75a4b07$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1ZyA7.createPath)(location) === (0, $1ZyA7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $64714b52f75a4b07$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $jGswQ.useRef($64714b52f75a4b07$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $jGswQ.useRef(false);
    let location = (0, $dI2iO.useLocation)();
    let searchParams = $jGswQ.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $64714b52f75a4b07$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $dI2iO.useNavigate)();
    let setSearchParams = $jGswQ.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $64714b52f75a4b07$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $64714b52f75a4b07$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $64714b52f75a4b07$var$fetcherId = 0;
let $64714b52f75a4b07$var$getUniqueFetcherId = ()=>"__" + String(++$64714b52f75a4b07$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $64714b52f75a4b07$export$47c85c6e3a081d3() {
    let { router: router } = $64714b52f75a4b07$var$useDataRouterContext($64714b52f75a4b07$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $jGswQ.useContext((0, $dI2iO.UNSAFE_NavigationContext));
    let currentRouteId = (0, $dI2iO.UNSAFE_useRouteId)();
    return $jGswQ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $64714b52f75a4b07$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $64714b52f75a4b07$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $64714b52f75a4b07$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $64714b52f75a4b07$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $jGswQ.useContext((0, $dI2iO.UNSAFE_NavigationContext));
    let routeContext = $jGswQ.useContext((0, $dI2iO.UNSAFE_RouteContext));
    !routeContext && (0, $1ZyA7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $64714b52f75a4b07$var$_extends({}, (0, $dI2iO.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $dI2iO.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ZyA7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $1ZyA7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $64714b52f75a4b07$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $64714b52f75a4b07$var$useDataRouterContext($64714b52f75a4b07$var$DataRouterHook.UseFetcher);
    let state = $64714b52f75a4b07$var$useDataRouterState($64714b52f75a4b07$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $jGswQ.useContext($64714b52f75a4b07$export$148fd98d095596d4);
    let route = $jGswQ.useContext((0, $dI2iO.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1ZyA7.UNSAFE_invariant)(false);
    !route && (0, $1ZyA7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $1ZyA7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $64714b52f75a4b07$var$useIdImpl ? $64714b52f75a4b07$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $jGswQ.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($64714b52f75a4b07$var$getUniqueFetcherId());
    // Registration/cleanup
    $jGswQ.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $jGswQ.useCallback((href, opts)=>{
        !routeId && (0, $1ZyA7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $64714b52f75a4b07$export$47c85c6e3a081d3();
    let submit = $jGswQ.useCallback((target, opts)=>{
        submitImpl(target, $64714b52f75a4b07$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $jGswQ.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $jGswQ.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $jGswQ.createElement($64714b52f75a4b07$export$a7fed597f4b8afd8, $64714b52f75a4b07$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1ZyA7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $jGswQ.useMemo(()=>$64714b52f75a4b07$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $64714b52f75a4b07$export$fa996778a3a31087() {
    let state = $64714b52f75a4b07$var$useDataRouterState($64714b52f75a4b07$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $64714b52f75a4b07$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $64714b52f75a4b07$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $64714b52f75a4b07$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $64714b52f75a4b07$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $64714b52f75a4b07$var$useDataRouterContext($64714b52f75a4b07$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $64714b52f75a4b07$var$useDataRouterState($64714b52f75a4b07$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $jGswQ.useContext((0, $dI2iO.UNSAFE_NavigationContext));
    let location = (0, $dI2iO.useLocation)();
    let matches = (0, $dI2iO.useMatches)();
    let navigation = (0, $dI2iO.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $jGswQ.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $64714b52f75a4b07$var$usePageHide($jGswQ.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $64714b52f75a4b07$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $64714b52f75a4b07$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($64714b52f75a4b07$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jGswQ.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $64714b52f75a4b07$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $64714b52f75a4b07$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jGswQ.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($64714b52f75a4b07$var$_extends({}, location, {
                    pathname: (0, $1ZyA7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($64714b52f75a4b07$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jGswQ.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $64714b52f75a4b07$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jGswQ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $64714b52f75a4b07$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jGswQ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $64714b52f75a4b07$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $dI2iO.useBlocker)(when);
    $jGswQ.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jGswQ.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $64714b52f75a4b07$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $jGswQ.useContext($64714b52f75a4b07$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1ZyA7.UNSAFE_invariant)(false);
    let { basename: basename } = $64714b52f75a4b07$var$useDataRouterContext($64714b52f75a4b07$var$DataRouterHook.useViewTransitionState);
    let path = (0, $dI2iO.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1ZyA7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1ZyA7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1ZyA7.matchPath)(path.pathname, nextPath) != null || (0, $1ZyA7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("1ZyA7", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $17365025d54a95d7$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $17365025d54a95d7$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $17365025d54a95d7$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $17365025d54a95d7$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $17365025d54a95d7$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $17365025d54a95d7$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $17365025d54a95d7$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $17365025d54a95d7$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $17365025d54a95d7$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $17365025d54a95d7$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $17365025d54a95d7$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $17365025d54a95d7$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $17365025d54a95d7$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $17365025d54a95d7$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $17365025d54a95d7$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $17365025d54a95d7$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $17365025d54a95d7$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $17365025d54a95d7$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $17365025d54a95d7$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $17365025d54a95d7$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $17365025d54a95d7$var$_extends() {
    $17365025d54a95d7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17365025d54a95d7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $17365025d54a95d7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($17365025d54a95d7$export$e19cd5f9376f8cee || ($17365025d54a95d7$export$e19cd5f9376f8cee = {}));
const $17365025d54a95d7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $17365025d54a95d7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $17365025d54a95d7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $17365025d54a95d7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $17365025d54a95d7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $17365025d54a95d7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $17365025d54a95d7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $17365025d54a95d7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $17365025d54a95d7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $17365025d54a95d7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $17365025d54a95d7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $17365025d54a95d7$export$fe53371bee54353d(to);
    }
    return $17365025d54a95d7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $17365025d54a95d7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $17365025d54a95d7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $17365025d54a95d7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $17365025d54a95d7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $17365025d54a95d7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $17365025d54a95d7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $17365025d54a95d7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $17365025d54a95d7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $17365025d54a95d7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $17365025d54a95d7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $17365025d54a95d7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $17365025d54a95d7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $17365025d54a95d7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $17365025d54a95d7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $17365025d54a95d7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $17365025d54a95d7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $17365025d54a95d7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($17365025d54a95d7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $17365025d54a95d7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $17365025d54a95d7$export$e19cd5f9376f8cee.Push;
        let location = $17365025d54a95d7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $17365025d54a95d7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $17365025d54a95d7$export$e19cd5f9376f8cee.Replace;
        let location = $17365025d54a95d7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $17365025d54a95d7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $17365025d54a95d7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $17365025d54a95d7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($17365025d54a95d7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($17365025d54a95d7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $17365025d54a95d7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($17365025d54a95d7$var$ResultType || ($17365025d54a95d7$var$ResultType = {}));
const $17365025d54a95d7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $17365025d54a95d7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $17365025d54a95d7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $17365025d54a95d7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $17365025d54a95d7$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($17365025d54a95d7$var$isIndexRoute(route)) {
            let indexRoute = $17365025d54a95d7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $17365025d54a95d7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $17365025d54a95d7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $17365025d54a95d7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $17365025d54a95d7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $17365025d54a95d7$var$flattenRoutes(routes);
    $17365025d54a95d7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $17365025d54a95d7$var$decodePath(pathname);
        matches = $17365025d54a95d7$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $17365025d54a95d7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $17365025d54a95d7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $17365025d54a95d7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $17365025d54a95d7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $17365025d54a95d7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $17365025d54a95d7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $17365025d54a95d7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $17365025d54a95d7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $17365025d54a95d7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $17365025d54a95d7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $17365025d54a95d7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $17365025d54a95d7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $17365025d54a95d7$var$paramRe = /^:[\w-]+$/;
const $17365025d54a95d7$var$dynamicSegmentValue = 3;
const $17365025d54a95d7$var$indexRouteValue = 2;
const $17365025d54a95d7$var$emptySegmentValue = 1;
const $17365025d54a95d7$var$staticSegmentValue = 10;
const $17365025d54a95d7$var$splatPenalty = -2;
const $17365025d54a95d7$var$isSplat = (s)=>s === "*";
function $17365025d54a95d7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($17365025d54a95d7$var$isSplat)) initialScore += $17365025d54a95d7$var$splatPenalty;
    if (index) initialScore += $17365025d54a95d7$var$indexRouteValue;
    return segments.filter((s)=>!$17365025d54a95d7$var$isSplat(s)).reduce((score, segment)=>score + ($17365025d54a95d7$var$paramRe.test(segment) ? $17365025d54a95d7$var$dynamicSegmentValue : segment === "" ? $17365025d54a95d7$var$emptySegmentValue : $17365025d54a95d7$var$staticSegmentValue), initialScore);
}
function $17365025d54a95d7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $17365025d54a95d7$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $17365025d54a95d7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $17365025d54a95d7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $17365025d54a95d7$export$a5c6d149b50c1d86($17365025d54a95d7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $17365025d54a95d7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $17365025d54a95d7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $17365025d54a95d7$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $17365025d54a95d7$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $17365025d54a95d7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $17365025d54a95d7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $17365025d54a95d7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $17365025d54a95d7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $17365025d54a95d7$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $17365025d54a95d7$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $17365025d54a95d7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $17365025d54a95d7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $17365025d54a95d7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $17365025d54a95d7$var$normalizeSearch(search),
        hash: $17365025d54a95d7$var$normalizeHash(hash)
    };
}
function $17365025d54a95d7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $17365025d54a95d7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $17365025d54a95d7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $17365025d54a95d7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $17365025d54a95d7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $17365025d54a95d7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $17365025d54a95d7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $17365025d54a95d7$var$_extends({}, toArg);
        $17365025d54a95d7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $17365025d54a95d7$var$getInvalidPathError("?", "pathname", "search", to));
        $17365025d54a95d7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $17365025d54a95d7$var$getInvalidPathError("#", "pathname", "hash", to));
        $17365025d54a95d7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $17365025d54a95d7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $17365025d54a95d7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $17365025d54a95d7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $17365025d54a95d7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $17365025d54a95d7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $17365025d54a95d7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $17365025d54a95d7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $17365025d54a95d7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $17365025d54a95d7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $17365025d54a95d7$export$42a99a7a4bc0e76a extends Error {
}
class $17365025d54a95d7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $17365025d54a95d7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $17365025d54a95d7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $17365025d54a95d7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $17365025d54a95d7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $17365025d54a95d7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $17365025d54a95d7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $17365025d54a95d7$var$unwrapTrackedPromise(value) {
    if (!$17365025d54a95d7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $17365025d54a95d7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $17365025d54a95d7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $17365025d54a95d7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $17365025d54a95d7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $17365025d54a95d7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $17365025d54a95d7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $17365025d54a95d7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $17365025d54a95d7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $17365025d54a95d7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $17365025d54a95d7$var$validMutationMethods = new Set($17365025d54a95d7$var$validMutationMethodsArr);
const $17365025d54a95d7$var$validRequestMethodsArr = [
    "get",
    ...$17365025d54a95d7$var$validMutationMethodsArr
];
const $17365025d54a95d7$var$validRequestMethods = new Set($17365025d54a95d7$var$validRequestMethodsArr);
const $17365025d54a95d7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $17365025d54a95d7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $17365025d54a95d7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $17365025d54a95d7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $17365025d54a95d7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $17365025d54a95d7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $17365025d54a95d7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $17365025d54a95d7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $17365025d54a95d7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $17365025d54a95d7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $17365025d54a95d7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $17365025d54a95d7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $17365025d54a95d7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $17365025d54a95d7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $17365025d54a95d7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $17365025d54a95d7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $17365025d54a95d7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $17365025d54a95d7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $17365025d54a95d7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $17365025d54a95d7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $17365025d54a95d7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$17365025d54a95d7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($17365025d54a95d7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $17365025d54a95d7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $17365025d54a95d7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $17365025d54a95d7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $17365025d54a95d7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $17365025d54a95d7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $17365025d54a95d7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $17365025d54a95d7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $17365025d54a95d7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $17365025d54a95d7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($17365025d54a95d7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $17365025d54a95d7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $17365025d54a95d7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $17365025d54a95d7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $17365025d54a95d7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $17365025d54a95d7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $17365025d54a95d7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $17365025d54a95d7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $17365025d54a95d7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $17365025d54a95d7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $17365025d54a95d7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $17365025d54a95d7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $17365025d54a95d7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $17365025d54a95d7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $17365025d54a95d7$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $17365025d54a95d7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $17365025d54a95d7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $17365025d54a95d7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$17365025d54a95d7$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $17365025d54a95d7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $17365025d54a95d7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $17365025d54a95d7$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $17365025d54a95d7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $17365025d54a95d7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $17365025d54a95d7$var$ResultType.error,
            error: $17365025d54a95d7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $17365025d54a95d7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($17365025d54a95d7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($17365025d54a95d7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $17365025d54a95d7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $17365025d54a95d7$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($17365025d54a95d7$var$isDeferredResult(result)) throw $17365025d54a95d7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $17365025d54a95d7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $17365025d54a95d7$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $17365025d54a95d7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $17365025d54a95d7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $17365025d54a95d7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($17365025d54a95d7$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $17365025d54a95d7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $17365025d54a95d7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $17365025d54a95d7$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $17365025d54a95d7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $17365025d54a95d7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $17365025d54a95d7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $17365025d54a95d7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $17365025d54a95d7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $17365025d54a95d7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $17365025d54a95d7$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $17365025d54a95d7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $17365025d54a95d7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $17365025d54a95d7$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($17365025d54a95d7$var$isRedirectResult(actionResult) || $17365025d54a95d7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $17365025d54a95d7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($17365025d54a95d7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $17365025d54a95d7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $17365025d54a95d7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($17365025d54a95d7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($17365025d54a95d7$var$isDeferredResult(actionResult)) throw $17365025d54a95d7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $17365025d54a95d7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $17365025d54a95d7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $17365025d54a95d7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $17365025d54a95d7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $17365025d54a95d7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $17365025d54a95d7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $17365025d54a95d7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $17365025d54a95d7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $17365025d54a95d7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $17365025d54a95d7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $17365025d54a95d7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $17365025d54a95d7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $17365025d54a95d7$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $17365025d54a95d7$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($17365025d54a95d7$var$isDeferredResult(result)) result = await $17365025d54a95d7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $17365025d54a95d7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($17365025d54a95d7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $17365025d54a95d7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($17365025d54a95d7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $17365025d54a95d7$export$3e9cee6b33872309(!$17365025d54a95d7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $17365025d54a95d7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $17365025d54a95d7$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $17365025d54a95d7$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($17365025d54a95d7$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $17365025d54a95d7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $17365025d54a95d7$export$e19cd5f9376f8cee.Replace : $17365025d54a95d7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $17365025d54a95d7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($17365025d54a95d7$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $17365025d54a95d7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $17365025d54a95d7$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $17365025d54a95d7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$17365025d54a95d7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $17365025d54a95d7$var$callLoaderOrAction("loader", $17365025d54a95d7$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $17365025d54a95d7$var$ResultType.error,
                        error: $17365025d54a95d7$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $17365025d54a95d7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $17365025d54a95d7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $17365025d54a95d7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $17365025d54a95d7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $17365025d54a95d7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $17365025d54a95d7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $17365025d54a95d7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $17365025d54a95d7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $17365025d54a95d7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $17365025d54a95d7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $17365025d54a95d7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $17365025d54a95d7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $17365025d54a95d7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$17365025d54a95d7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $17365025d54a95d7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $17365025d54a95d7$export$4d0306f8f6a4585b = Symbol("deferred");
function $17365025d54a95d7$export$3336b097a6fbc59a(routes, opts) {
    $17365025d54a95d7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $17365025d54a95d7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $17365025d54a95d7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $17365025d54a95d7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $17365025d54a95d7$var$createLocation("", $17365025d54a95d7$export$fe53371bee54353d(url), null, "default");
        let matches = $17365025d54a95d7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$17365025d54a95d7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $17365025d54a95d7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $17365025d54a95d7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $17365025d54a95d7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $17365025d54a95d7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($17365025d54a95d7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $17365025d54a95d7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $17365025d54a95d7$var$createLocation("", $17365025d54a95d7$export$fe53371bee54353d(url), null, "default");
        let matches = $17365025d54a95d7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$17365025d54a95d7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $17365025d54a95d7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $17365025d54a95d7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $17365025d54a95d7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $17365025d54a95d7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $17365025d54a95d7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($17365025d54a95d7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$17365025d54a95d7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $17365025d54a95d7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($17365025d54a95d7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $17365025d54a95d7$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $17365025d54a95d7$var$isResponse(result) ? result : $17365025d54a95d7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($17365025d54a95d7$var$isQueryRouteResponse(e)) {
                if (e.type === $17365025d54a95d7$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($17365025d54a95d7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $17365025d54a95d7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $17365025d54a95d7$var$ResultType.error,
                error: error
            };
        } else {
            result = await $17365025d54a95d7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $17365025d54a95d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($17365025d54a95d7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($17365025d54a95d7$var$isDeferredResult(result)) {
            let error = $17365025d54a95d7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $17365025d54a95d7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($17365025d54a95d7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($17365025d54a95d7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $17365025d54a95d7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $17365025d54a95d7$var$_extends({}, context, {
                statusCode: $17365025d54a95d7$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $17365025d54a95d7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $17365025d54a95d7$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $17365025d54a95d7$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $17365025d54a95d7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $17365025d54a95d7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$17365025d54a95d7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $17365025d54a95d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $17365025d54a95d7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $17365025d54a95d7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $17365025d54a95d7$export$fec11da027c70692(routes, context, error) {
    let newContext = $17365025d54a95d7$var$_extends({}, context, {
        statusCode: $17365025d54a95d7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $17365025d54a95d7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $17365025d54a95d7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $17365025d54a95d7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $17365025d54a95d7$export$cae722b0cc860f13(to ? to : ".", $17365025d54a95d7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $17365025d54a95d7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$17365025d54a95d7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $17365025d54a95d7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $17365025d54a95d7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $17365025d54a95d7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$17365025d54a95d7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$17365025d54a95d7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $17365025d54a95d7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $17365025d54a95d7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $17365025d54a95d7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$17365025d54a95d7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$17365025d54a95d7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $17365025d54a95d7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $17365025d54a95d7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $17365025d54a95d7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $17365025d54a95d7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $17365025d54a95d7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($17365025d54a95d7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $17365025d54a95d7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $17365025d54a95d7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $17365025d54a95d7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $17365025d54a95d7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $17365025d54a95d7$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $17365025d54a95d7$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($17365025d54a95d7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $17365025d54a95d7$var$shouldRevalidateLoader(match, $17365025d54a95d7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $17365025d54a95d7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $17365025d54a95d7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $17365025d54a95d7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $17365025d54a95d7$var$shouldRevalidateLoader(fetcherMatch, $17365025d54a95d7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $17365025d54a95d7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $17365025d54a95d7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $17365025d54a95d7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $17365025d54a95d7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $17365025d54a95d7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $17365025d54a95d7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$17365025d54a95d7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $17365025d54a95d7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $17365025d54a95d7$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $17365025d54a95d7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $17365025d54a95d7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $17365025d54a95d7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $17365025d54a95d7$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $17365025d54a95d7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $17365025d54a95d7$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $17365025d54a95d7$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($17365025d54a95d7$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($17365025d54a95d7$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $17365025d54a95d7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$17365025d54a95d7$var$ABSOLUTE_URL_REGEX.test(location)) location = $17365025d54a95d7$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $17365025d54a95d7$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $17365025d54a95d7$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $17365025d54a95d7$var$ResultType.error ? $17365025d54a95d7$var$ResultType.error : $17365025d54a95d7$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $17365025d54a95d7$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $17365025d54a95d7$var$ResultType.error) return {
            type: resultType,
            error: new $17365025d54a95d7$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $17365025d54a95d7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $17365025d54a95d7$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($17365025d54a95d7$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $17365025d54a95d7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $17365025d54a95d7$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $17365025d54a95d7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($17365025d54a95d7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $17365025d54a95d7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $17365025d54a95d7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $17365025d54a95d7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $17365025d54a95d7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $17365025d54a95d7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $17365025d54a95d7$export$3e9cee6b33872309(!$17365025d54a95d7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($17365025d54a95d7$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $17365025d54a95d7$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $17365025d54a95d7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($17365025d54a95d7$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $17365025d54a95d7$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $17365025d54a95d7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $17365025d54a95d7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($17365025d54a95d7$var$isErrorResult(result)) {
            let boundaryMatch = $17365025d54a95d7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $17365025d54a95d7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($17365025d54a95d7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $17365025d54a95d7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($17365025d54a95d7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $17365025d54a95d7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $17365025d54a95d7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $17365025d54a95d7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $17365025d54a95d7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $17365025d54a95d7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $17365025d54a95d7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $17365025d54a95d7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $17365025d54a95d7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $17365025d54a95d7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($17365025d54a95d7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $17365025d54a95d7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(path) : path;
    return $17365025d54a95d7$export$fe53371bee54353d($17365025d54a95d7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $17365025d54a95d7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $17365025d54a95d7$var$isDeferredResult(result) {
    return result.type === $17365025d54a95d7$var$ResultType.deferred;
}
function $17365025d54a95d7$var$isErrorResult(result) {
    return result.type === $17365025d54a95d7$var$ResultType.error;
}
function $17365025d54a95d7$var$isRedirectResult(result) {
    return (result && result.type) === $17365025d54a95d7$var$ResultType.redirect;
}
function $17365025d54a95d7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $17365025d54a95d7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $17365025d54a95d7$var$isRedirectResponse(result) {
    if (!$17365025d54a95d7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $17365025d54a95d7$var$isQueryRouteResponse(obj) {
    return obj && $17365025d54a95d7$var$isResponse(obj.response) && (obj.type === $17365025d54a95d7$var$ResultType.data || obj.type === $17365025d54a95d7$var$ResultType.error);
}
function $17365025d54a95d7$var$isValidMethod(method) {
    return $17365025d54a95d7$var$validRequestMethods.has(method.toLowerCase());
}
function $17365025d54a95d7$var$isMutationMethod(method) {
    return $17365025d54a95d7$var$validMutationMethods.has(method.toLowerCase());
}
async function $17365025d54a95d7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$17365025d54a95d7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($17365025d54a95d7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $17365025d54a95d7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $17365025d54a95d7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $17365025d54a95d7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $17365025d54a95d7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $17365025d54a95d7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $17365025d54a95d7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $17365025d54a95d7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $17365025d54a95d7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $17365025d54a95d7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $17365025d54a95d7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $17365025d54a95d7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $17365025d54a95d7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $17365025d54a95d7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $17365025d54a95d7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $17365025d54a95d7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $17365025d54a95d7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $17365025d54a95d7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $17365025d54a95d7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($17365025d54a95d7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $17365025d54a95d7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($17365025d54a95d7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $17365025d54a95d7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("dI2iO", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $9fb12b9c7f251928$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $9fb12b9c7f251928$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $9fb12b9c7f251928$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $9fb12b9c7f251928$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $9fb12b9c7f251928$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $9fb12b9c7f251928$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $9fb12b9c7f251928$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $9fb12b9c7f251928$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $9fb12b9c7f251928$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $9fb12b9c7f251928$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $9fb12b9c7f251928$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $9fb12b9c7f251928$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $9fb12b9c7f251928$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $9fb12b9c7f251928$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $9fb12b9c7f251928$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $9fb12b9c7f251928$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $9fb12b9c7f251928$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $9fb12b9c7f251928$export$52b333d321859367; });
/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jGswQ = parcelRequire("jGswQ");

var $1ZyA7 = parcelRequire("1ZyA7");
function $9fb12b9c7f251928$var$_extends() {
    $9fb12b9c7f251928$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9fb12b9c7f251928$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $9fb12b9c7f251928$export$3add0d5dce533e2e = /*#__PURE__*/ $jGswQ.createContext(null);
const $9fb12b9c7f251928$export$145dfa71566a64dc = /*#__PURE__*/ $jGswQ.createContext(null);
const $9fb12b9c7f251928$var$AwaitContext = /*#__PURE__*/ $jGswQ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $9fb12b9c7f251928$export$26749e8557646306 = /*#__PURE__*/ $jGswQ.createContext(null);
const $9fb12b9c7f251928$export$c7914228fb69b0f5 = /*#__PURE__*/ $jGswQ.createContext(null);
const $9fb12b9c7f251928$export$9072aa6dd1f93057 = /*#__PURE__*/ $jGswQ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $9fb12b9c7f251928$var$RouteErrorContext = /*#__PURE__*/ $jGswQ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $9fb12b9c7f251928$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $jGswQ.useContext($9fb12b9c7f251928$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $9fb12b9c7f251928$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1ZyA7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $9fb12b9c7f251928$export$9c954a9d03d32f4a() {
    return $jGswQ.useContext($9fb12b9c7f251928$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $9fb12b9c7f251928$export$45d76561a5302f2b() {
    !$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    return $jGswQ.useContext($9fb12b9c7f251928$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $9fb12b9c7f251928$export$1b3f31771c5d07c() {
    return $jGswQ.useContext($9fb12b9c7f251928$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $9fb12b9c7f251928$export$6c330e8992e8a295(pattern) {
    !$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $9fb12b9c7f251928$export$45d76561a5302f2b();
    return $jGswQ.useMemo(()=>(0, $1ZyA7.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $9fb12b9c7f251928$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9fb12b9c7f251928$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $jGswQ.useContext($9fb12b9c7f251928$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $jGswQ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $9fb12b9c7f251928$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9fb12b9c7f251928$var$useNavigateStable() : $9fb12b9c7f251928$var$useNavigateUnstable();
}
function $9fb12b9c7f251928$var$useNavigateUnstable() {
    !$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    let dataRouterContext = $jGswQ.useContext($9fb12b9c7f251928$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $jGswQ.useContext($9fb12b9c7f251928$export$26749e8557646306);
    let { matches: matches } = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9fb12b9c7f251928$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ZyA7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $jGswQ.useRef(false);
    $9fb12b9c7f251928$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jGswQ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1ZyA7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ZyA7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $9fb12b9c7f251928$var$OutletContext = /*#__PURE__*/ $jGswQ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $9fb12b9c7f251928$export$4138103a3ae699cc() {
    return $jGswQ.useContext($9fb12b9c7f251928$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $9fb12b9c7f251928$export$a3be3530d8e40d0b(context) {
    let outlet = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $9fb12b9c7f251928$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $9fb12b9c7f251928$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $jGswQ.useContext($9fb12b9c7f251928$export$26749e8557646306);
    let { matches: matches } = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9fb12b9c7f251928$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ZyA7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $jGswQ.useMemo(()=>(0, $1ZyA7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $9fb12b9c7f251928$export$5d3fca4a98652595(routes, locationArg) {
    return $9fb12b9c7f251928$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9fb12b9c7f251928$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $jGswQ.useContext($9fb12b9c7f251928$export$26749e8557646306);
    let { matches: parentMatches } = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $9fb12b9c7f251928$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1ZyA7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1ZyA7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1ZyA7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $9fb12b9c7f251928$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1ZyA7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1ZyA7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9fb12b9c7f251928$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1ZyA7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9fb12b9c7f251928$var$DefaultErrorComponent() {
    let error = $9fb12b9c7f251928$export$ed527bf60f6e05f2();
    let message = (0, $1ZyA7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $jGswQ.createElement($jGswQ.Fragment, null, /*#__PURE__*/ $jGswQ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $jGswQ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $jGswQ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $9fb12b9c7f251928$var$defaultErrorElement = /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$DefaultErrorComponent, null);
class $9fb12b9c7f251928$var$RenderErrorBoundary extends $jGswQ.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $9fb12b9c7f251928$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $jGswQ.useContext($9fb12b9c7f251928$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9fb12b9c7f251928$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1ZyA7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9fb12b9c7f251928$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9fb12b9c7f251928$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $jGswQ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9fb12b9c7f251928$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9fb12b9c7f251928$var$DataRouterHook || {});
var $9fb12b9c7f251928$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9fb12b9c7f251928$var$DataRouterStateHook || {});
function $9fb12b9c7f251928$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $9fb12b9c7f251928$var$useDataRouterContext(hookName) {
    let ctx = $jGswQ.useContext($9fb12b9c7f251928$export$3add0d5dce533e2e);
    !ctx && (0, $1ZyA7.UNSAFE_invariant)(false);
    return ctx;
}
function $9fb12b9c7f251928$var$useDataRouterState(hookName) {
    let state = $jGswQ.useContext($9fb12b9c7f251928$export$145dfa71566a64dc);
    !state && (0, $1ZyA7.UNSAFE_invariant)(false);
    return state;
}
function $9fb12b9c7f251928$var$useRouteContext(hookName) {
    let route = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    !route && (0, $1ZyA7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9fb12b9c7f251928$var$useCurrentRouteId(hookName) {
    let route = $9fb12b9c7f251928$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1ZyA7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9fb12b9c7f251928$export$5fc8298006ad9e58() {
    return $9fb12b9c7f251928$var$useCurrentRouteId($9fb12b9c7f251928$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9fb12b9c7f251928$export$d0fd4b7106de2769() {
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9fb12b9c7f251928$export$600dc272ed516c15() {
    let dataRouterContext = $9fb12b9c7f251928$var$useDataRouterContext($9fb12b9c7f251928$var$DataRouterHook.UseRevalidator);
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseRevalidator);
    return $jGswQ.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9fb12b9c7f251928$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseMatches);
    return $jGswQ.useMemo(()=>matches.map((m)=>(0, $1ZyA7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9fb12b9c7f251928$export$1448a5050d252c4d() {
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseLoaderData);
    let routeId = $9fb12b9c7f251928$var$useCurrentRouteId($9fb12b9c7f251928$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9fb12b9c7f251928$export$fd5d37484eab868d(routeId) {
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9fb12b9c7f251928$export$fdc00f3f26066d5e() {
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseActionData);
    let routeId = $9fb12b9c7f251928$var$useCurrentRouteId($9fb12b9c7f251928$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9fb12b9c7f251928$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $jGswQ.useContext($9fb12b9c7f251928$var$RouteErrorContext);
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseRouteError);
    let routeId = $9fb12b9c7f251928$var$useCurrentRouteId($9fb12b9c7f251928$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9fb12b9c7f251928$export$78a72ddb39bdd145() {
    let value = $jGswQ.useContext($9fb12b9c7f251928$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9fb12b9c7f251928$export$17f53340677d5831() {
    let value = $jGswQ.useContext($9fb12b9c7f251928$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $9fb12b9c7f251928$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9fb12b9c7f251928$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $9fb12b9c7f251928$var$useDataRouterContext($9fb12b9c7f251928$var$DataRouterHook.UseBlocker);
    let state = $9fb12b9c7f251928$var$useDataRouterState($9fb12b9c7f251928$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $jGswQ.useState("");
    let blockerFunction = $jGswQ.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $9fb12b9c7f251928$var$_extends({}, currentLocation, {
                pathname: (0, $1ZyA7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9fb12b9c7f251928$var$_extends({}, nextLocation, {
                pathname: (0, $1ZyA7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $jGswQ.useEffect(()=>{
        let key = String(++$9fb12b9c7f251928$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $jGswQ.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1ZyA7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9fb12b9c7f251928$var$useNavigateStable() {
    let { router: router } = $9fb12b9c7f251928$var$useDataRouterContext($9fb12b9c7f251928$var$DataRouterHook.UseNavigateStable);
    let id = $9fb12b9c7f251928$var$useCurrentRouteId($9fb12b9c7f251928$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $jGswQ.useRef(false);
    $9fb12b9c7f251928$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jGswQ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9fb12b9c7f251928$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $9fb12b9c7f251928$var$alreadyWarned = {};
function $9fb12b9c7f251928$var$warningOnce(key, cond, message) {
    if (!cond && !$9fb12b9c7f251928$var$alreadyWarned[key]) $9fb12b9c7f251928$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9fb12b9c7f251928$var$START_TRANSITION = "startTransition";
const $9fb12b9c7f251928$var$startTransitionImpl = $jGswQ[$9fb12b9c7f251928$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9fb12b9c7f251928$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $jGswQ.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jGswQ.useCallback((newState)=>{
        if (v7_startTransition && $9fb12b9c7f251928$var$startTransitionImpl) $9fb12b9c7f251928$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $jGswQ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $jGswQ.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $jGswQ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jGswQ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jGswQ.createElement($jGswQ.Fragment, null, /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9fb12b9c7f251928$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $9fb12b9c7f251928$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $9fb12b9c7f251928$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $jGswQ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ZyA7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jGswQ.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $jGswQ.useCallback((newState)=>{
        v7_startTransition && $9fb12b9c7f251928$var$startTransitionImpl ? $9fb12b9c7f251928$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $jGswQ.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $9fb12b9c7f251928$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $jGswQ.useContext($9fb12b9c7f251928$export$26749e8557646306);
    let { matches: matches } = $jGswQ.useContext($9fb12b9c7f251928$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9fb12b9c7f251928$export$45d76561a5302f2b();
    let navigate = $9fb12b9c7f251928$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1ZyA7.resolveTo)(to, (0, $1ZyA7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $jGswQ.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $9fb12b9c7f251928$export$910ae8079b2c2852(props) {
    return $9fb12b9c7f251928$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $9fb12b9c7f251928$export$e7b0ac011bb776c6(_props) {
    (0, $1ZyA7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $9fb12b9c7f251928$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1ZyA7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$9fb12b9c7f251928$export$9c954a9d03d32f4a() && (0, $1ZyA7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jGswQ.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9fb12b9c7f251928$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1ZyA7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $jGswQ.useMemo(()=>{
        let trailingPathname = (0, $1ZyA7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $9fb12b9c7f251928$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $9fb12b9c7f251928$export$5d3fca4a98652595($9fb12b9c7f251928$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9fb12b9c7f251928$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$ResolveAwait, null, children));
}
var $9fb12b9c7f251928$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9fb12b9c7f251928$var$AwaitRenderStatus || {});
const $9fb12b9c7f251928$var$neverSettledPromise = new Promise(()=>{});
class $9fb12b9c7f251928$var$AwaitErrorBoundary extends $jGswQ.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $9fb12b9c7f251928$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $9fb12b9c7f251928$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $9fb12b9c7f251928$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $9fb12b9c7f251928$var$AwaitRenderStatus.error : promise._data !== undefined ? $9fb12b9c7f251928$var$AwaitRenderStatus.success : $9fb12b9c7f251928$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $9fb12b9c7f251928$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $9fb12b9c7f251928$var$AwaitRenderStatus.error && promise._error instanceof (0, $1ZyA7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $9fb12b9c7f251928$var$neverSettledPromise;
        if (status === $9fb12b9c7f251928$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $9fb12b9c7f251928$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $9fb12b9c7f251928$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $jGswQ.createElement($9fb12b9c7f251928$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9fb12b9c7f251928$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $9fb12b9c7f251928$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $jGswQ.createElement($jGswQ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $9fb12b9c7f251928$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $jGswQ.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $jGswQ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jGswQ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9fb12b9c7f251928$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9fb12b9c7f251928$export$e7b0ac011bb776c6) && (0, $1ZyA7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $1ZyA7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9fb12b9c7f251928$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9fb12b9c7f251928$export$daf73786167a7f72(matches) {
    return $9fb12b9c7f251928$var$_renderMatches(matches);
}
function $9fb12b9c7f251928$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $jGswQ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $jGswQ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $jGswQ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9fb12b9c7f251928$export$f30f7e456d254e83(routes, opts) {
    return (0, $1ZyA7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9fb12b9c7f251928$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ZyA7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9fb12b9c7f251928$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("813nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d610972f3e9275d$export$2e2bcd8739ae039; });
// src/components/Shimmer.jsx

var $5z4M4 = parcelRequire("5z4M4");
parcelRequire("jGswQ");
function $5d610972f3e9275d$export$2e2bcd8739ae039({ count: count = 12 }) {
    const items = Array.from({
        length: count
    });
    return /*#__PURE__*/ (0, $5z4M4.jsx)((0, $5z4M4.Fragment), {
        children: items.map((_, i)=>/*#__PURE__*/ (0, $5z4M4.jsxs)("div", {
                className: "rounded-2xl ring-1 ring-black/5 shadow-sm  bg-white dark:bg-zinc-900 overflow-hidden animate-pulse",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                        className: "aspect-[16/9] bg-zinc-200 dark:bg-zinc-800"
                    }),
                    /*#__PURE__*/ (0, $5z4M4.jsxs)("div", {
                        className: "p-4 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                className: "h-5 w-3/4 rounded-md bg-zinc-200 dark:bg-zinc-800"
                            }),
                            /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                className: "h-4 w-1/2 rounded-md bg-zinc-200 dark:bg-zinc-800"
                            }),
                            /*#__PURE__*/ (0, $5z4M4.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                        className: "h-4 w-16 rounded-md bg-zinc-200 dark:bg-zinc-800"
                                    }),
                                    /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                        className: "h-1 w-1 rounded-full bg-zinc-300 dark:bg-zinc-700"
                                    }),
                                    /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                        className: "h-4 w-20 rounded-md bg-zinc-200 dark:bg-zinc-800"
                                    }),
                                    /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                        className: "h-1 w-1 rounded-full bg-zinc-300 dark:bg-zinc-700"
                                    }),
                                    /*#__PURE__*/ (0, $5z4M4.jsx)("div", {
                                        className: "h-4 w-24 rounded-md bg-zinc-200 dark:bg-zinc-800"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, i))
    });
}

});

parcelRegister("23euK", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $17e71afadabdd908$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useDispatch", function () { return $17e71afadabdd908$export$8ad76b76a4c905f8; });
$parcel$export(module.exports, "useSelector", function () { return $17e71afadabdd908$export$2105062e25df4afe; });

var $jGswQ = parcelRequire("jGswQ");

var $frvSu = parcelRequire("frvSu");
var $17e71afadabdd908$var$__defProp = Object.defineProperty;
var $17e71afadabdd908$var$__defProps = Object.defineProperties;
var $17e71afadabdd908$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $17e71afadabdd908$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $17e71afadabdd908$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $17e71afadabdd908$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $17e71afadabdd908$var$__defNormalProp = (obj, key, value)=>key in obj ? $17e71afadabdd908$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $17e71afadabdd908$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($17e71afadabdd908$var$__hasOwnProp.call(b, prop)) $17e71afadabdd908$var$__defNormalProp(a, prop, b[prop]);
    if ($17e71afadabdd908$var$__getOwnPropSymbols) {
        for (var prop of $17e71afadabdd908$var$__getOwnPropSymbols(b))if ($17e71afadabdd908$var$__propIsEnum.call(b, prop)) $17e71afadabdd908$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $17e71afadabdd908$var$__spreadProps = (a, b)=>$17e71afadabdd908$var$__defProps(a, $17e71afadabdd908$var$__getOwnPropDescs(b));
var $17e71afadabdd908$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($17e71afadabdd908$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $17e71afadabdd908$var$__getOwnPropSymbols) {
        for (var prop of $17e71afadabdd908$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $17e71afadabdd908$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $17e71afadabdd908$var$IS_REACT_19 = /* @__PURE__ */ $jGswQ.version.startsWith("19");
var $17e71afadabdd908$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($17e71afadabdd908$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $17e71afadabdd908$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $17e71afadabdd908$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $17e71afadabdd908$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $17e71afadabdd908$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $17e71afadabdd908$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $17e71afadabdd908$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $17e71afadabdd908$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $17e71afadabdd908$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $17e71afadabdd908$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $17e71afadabdd908$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $17e71afadabdd908$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $17e71afadabdd908$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $17e71afadabdd908$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $17e71afadabdd908$var$ForwardRef = $17e71afadabdd908$var$REACT_FORWARD_REF_TYPE;
var $17e71afadabdd908$var$Memo = $17e71afadabdd908$var$REACT_MEMO_TYPE;
function $17e71afadabdd908$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $17e71afadabdd908$var$REACT_FRAGMENT_TYPE || type === $17e71afadabdd908$var$REACT_PROFILER_TYPE || type === $17e71afadabdd908$var$REACT_STRICT_MODE_TYPE || type === $17e71afadabdd908$var$REACT_SUSPENSE_TYPE || type === $17e71afadabdd908$var$REACT_SUSPENSE_LIST_TYPE || type === $17e71afadabdd908$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $17e71afadabdd908$var$REACT_LAZY_TYPE || type.$$typeof === $17e71afadabdd908$var$REACT_MEMO_TYPE || type.$$typeof === $17e71afadabdd908$var$REACT_CONTEXT_TYPE || type.$$typeof === $17e71afadabdd908$var$REACT_CONSUMER_TYPE || type.$$typeof === $17e71afadabdd908$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $17e71afadabdd908$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $17e71afadabdd908$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $17e71afadabdd908$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $17e71afadabdd908$var$REACT_FRAGMENT_TYPE:
                    case $17e71afadabdd908$var$REACT_PROFILER_TYPE:
                    case $17e71afadabdd908$var$REACT_STRICT_MODE_TYPE:
                    case $17e71afadabdd908$var$REACT_SUSPENSE_TYPE:
                    case $17e71afadabdd908$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $17e71afadabdd908$var$REACT_CONTEXT_TYPE:
                            case $17e71afadabdd908$var$REACT_FORWARD_REF_TYPE:
                            case $17e71afadabdd908$var$REACT_LAZY_TYPE:
                            case $17e71afadabdd908$var$REACT_MEMO_TYPE:
                                return object;
                            case $17e71afadabdd908$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $17e71afadabdd908$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $17e71afadabdd908$var$isContextConsumer(object) {
    return $17e71afadabdd908$var$IS_REACT_19 ? $17e71afadabdd908$var$typeOf(object) === $17e71afadabdd908$var$REACT_CONSUMER_TYPE : $17e71afadabdd908$var$typeOf(object) === $17e71afadabdd908$var$REACT_CONTEXT_TYPE;
}
function $17e71afadabdd908$var$isMemo(object) {
    return $17e71afadabdd908$var$typeOf(object) === $17e71afadabdd908$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $17e71afadabdd908$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $17e71afadabdd908$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $17e71afadabdd908$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $17e71afadabdd908$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $17e71afadabdd908$var$verify(mapStateToProps, "mapStateToProps");
    $17e71afadabdd908$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $17e71afadabdd908$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $17e71afadabdd908$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $17e71afadabdd908$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $17e71afadabdd908$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $17e71afadabdd908$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $17e71afadabdd908$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $17e71afadabdd908$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $17e71afadabdd908$var$verifyPlainObject(value, displayName, methodName) {
    if (!$17e71afadabdd908$var$isPlainObject(value)) $17e71afadabdd908$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $17e71afadabdd908$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $17e71afadabdd908$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $17e71afadabdd908$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $17e71afadabdd908$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $17e71afadabdd908$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $17e71afadabdd908$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $17e71afadabdd908$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $17e71afadabdd908$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $17e71afadabdd908$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $17e71afadabdd908$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $17e71afadabdd908$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $17e71afadabdd908$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $17e71afadabdd908$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $17e71afadabdd908$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $17e71afadabdd908$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $17e71afadabdd908$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $17e71afadabdd908$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $17e71afadabdd908$var$__spreadValues($17e71afadabdd908$var$__spreadValues($17e71afadabdd908$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $17e71afadabdd908$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $17e71afadabdd908$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$17e71afadabdd908$var$defaultMergeProps : typeof mergeProps === "function" ? $17e71afadabdd908$var$wrapMergePropsFunc(mergeProps) : $17e71afadabdd908$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $17e71afadabdd908$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $17e71afadabdd908$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $17e71afadabdd908$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $17e71afadabdd908$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $17e71afadabdd908$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $17e71afadabdd908$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $17e71afadabdd908$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $17e71afadabdd908$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $17e71afadabdd908$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $17e71afadabdd908$var$isDOM = /* @__PURE__ */ $17e71afadabdd908$var$canUseDOM();
var $17e71afadabdd908$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $17e71afadabdd908$var$isReactNative = /* @__PURE__ */ $17e71afadabdd908$var$isRunningInReactNative();
var $17e71afadabdd908$var$getUseIsomorphicLayoutEffect = ()=>$17e71afadabdd908$var$isDOM || $17e71afadabdd908$var$isReactNative ? $jGswQ.useLayoutEffect : $jGswQ.useEffect;
var $17e71afadabdd908$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $17e71afadabdd908$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $17e71afadabdd908$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $17e71afadabdd908$export$d36bdfa510afb180(objA, objB) {
    if ($17e71afadabdd908$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$17e71afadabdd908$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $17e71afadabdd908$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $17e71afadabdd908$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $17e71afadabdd908$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $17e71afadabdd908$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $17e71afadabdd908$var$TYPE_STATICS = {
    [$17e71afadabdd908$var$ForwardRef]: $17e71afadabdd908$var$FORWARD_REF_STATICS,
    [$17e71afadabdd908$var$Memo]: $17e71afadabdd908$var$MEMO_STATICS
};
function $17e71afadabdd908$var$getStatics(component) {
    if ($17e71afadabdd908$var$isMemo(component)) return $17e71afadabdd908$var$MEMO_STATICS;
    return $17e71afadabdd908$var$TYPE_STATICS[component["$$typeof"]] || $17e71afadabdd908$var$REACT_STATICS;
}
var $17e71afadabdd908$var$defineProperty = Object.defineProperty;
var $17e71afadabdd908$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $17e71afadabdd908$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $17e71afadabdd908$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $17e71afadabdd908$var$getPrototypeOf = Object.getPrototypeOf;
var $17e71afadabdd908$var$objectPrototype = Object.prototype;
function $17e71afadabdd908$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($17e71afadabdd908$var$objectPrototype) {
            const inheritedComponent = $17e71afadabdd908$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $17e71afadabdd908$var$objectPrototype) $17e71afadabdd908$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $17e71afadabdd908$var$getOwnPropertyNames(sourceComponent);
        if ($17e71afadabdd908$var$getOwnPropertySymbols) keys = keys.concat($17e71afadabdd908$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $17e71afadabdd908$var$getStatics(targetComponent);
        const sourceStatics = $17e71afadabdd908$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$17e71afadabdd908$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $17e71afadabdd908$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $17e71afadabdd908$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $17e71afadabdd908$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $17e71afadabdd908$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $17e71afadabdd908$var$getContext() {
    var _a;
    if (!$jGswQ.createContext) return {};
    const contextMap = (_a = $17e71afadabdd908$var$gT[$17e71afadabdd908$var$ContextKey]) != null ? _a : $17e71afadabdd908$var$gT[$17e71afadabdd908$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($jGswQ.createContext);
    if (!realContext) {
        realContext = $jGswQ.createContext(null);
        contextMap.set($jGswQ.createContext, realContext);
    }
    return realContext;
}
var $17e71afadabdd908$export$cc80c08dc91f1c00 = /* @__PURE__ */ $17e71afadabdd908$var$getContext();
// src/components/connect.tsx
var $17e71afadabdd908$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $17e71afadabdd908$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $17e71afadabdd908$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $17e71afadabdd908$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $17e71afadabdd908$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $17e71afadabdd908$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $17e71afadabdd908$var$strictEqual(a, b) {
    return a === b;
}
var $17e71afadabdd908$var$hasWarnedAboutDeprecatedPureOption = false;
function $17e71afadabdd908$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $17e71afadabdd908$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $17e71afadabdd908$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $17e71afadabdd908$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $17e71afadabdd908$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $17e71afadabdd908$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $17e71afadabdd908$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $17e71afadabdd908$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $17e71afadabdd908$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $jGswQ.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $17e71afadabdd908$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $jGswQ.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $jGswQ.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $jGswQ.useMemo(()=>{
                return $17e71afadabdd908$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $jGswQ.useMemo(()=>{
                if (!shouldHandleStateChanges) return $17e71afadabdd908$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $17e71afadabdd908$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $jGswQ.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $17e71afadabdd908$var$__spreadProps($17e71afadabdd908$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $jGswQ.useRef(void 0);
            const lastWrapperProps = $jGswQ.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $jGswQ.useRef(void 0);
            const renderIsScheduled = $jGswQ.useRef(false);
            const isMounted = $jGswQ.useRef(false);
            const latestSubscriptionCallbackError = $jGswQ.useRef(void 0);
            $17e71afadabdd908$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $jGswQ.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $jGswQ.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $17e71afadabdd908$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $17e71afadabdd908$var$useIsomorphicLayoutEffectWithArgs($17e71afadabdd908$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $jGswQ.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $17e71afadabdd908$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $jGswQ.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $jGswQ.createElement(WrappedComponent, $17e71afadabdd908$var$__spreadProps($17e71afadabdd908$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $jGswQ.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $jGswQ.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $jGswQ.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $jGswQ.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $jGswQ.createElement(Connect, $17e71afadabdd908$var$__spreadProps($17e71afadabdd908$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $17e71afadabdd908$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $17e71afadabdd908$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $17e71afadabdd908$export$64605811ab45167f = $17e71afadabdd908$var$connect;
// src/components/Provider.tsx
function $17e71afadabdd908$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $jGswQ.useMemo(()=>{
        const subscription = $17e71afadabdd908$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $jGswQ.useMemo(()=>store.getState(), [
        store
    ]);
    $17e71afadabdd908$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $17e71afadabdd908$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $jGswQ.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $17e71afadabdd908$export$2881499e37b75b9a = $17e71afadabdd908$var$Provider;
// src/hooks/useReduxContext.ts
function $17e71afadabdd908$var$createReduxContextHook(context = $17e71afadabdd908$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $jGswQ.useContext(context);
        return contextValue;
    };
}
var $17e71afadabdd908$var$useReduxContext = /* @__PURE__ */ $17e71afadabdd908$var$createReduxContextHook();
// src/hooks/useStore.ts
function $17e71afadabdd908$export$671dba69185d0304(context = $17e71afadabdd908$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $17e71afadabdd908$export$cc80c08dc91f1c00 ? $17e71afadabdd908$var$useReduxContext : // @ts-ignore
    $17e71afadabdd908$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $17e71afadabdd908$export$6ccbb43953eebf8 = /* @__PURE__ */ $17e71afadabdd908$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $17e71afadabdd908$export$bc9b55530897c558(context = $17e71afadabdd908$export$cc80c08dc91f1c00) {
    const useStore2 = context === $17e71afadabdd908$export$cc80c08dc91f1c00 ? $17e71afadabdd908$export$6ccbb43953eebf8 : $17e71afadabdd908$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $17e71afadabdd908$export$8ad76b76a4c905f8 = /* @__PURE__ */ $17e71afadabdd908$export$bc9b55530897c558();
var $17e71afadabdd908$var$refEquality = (a, b)=>a === b;
function $17e71afadabdd908$export$2b53f90d2bd1cbfb(context = $17e71afadabdd908$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $17e71afadabdd908$export$cc80c08dc91f1c00 ? $17e71afadabdd908$var$useReduxContext : $17e71afadabdd908$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $17e71afadabdd908$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $jGswQ.useRef(true);
        const wrappedSelector = $jGswQ.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $frvSu.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $jGswQ.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $17e71afadabdd908$export$2105062e25df4afe = /* @__PURE__ */ $17e71afadabdd908$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $17e71afadabdd908$export$712ea50be43a7858 = $17e71afadabdd908$var$defaultNoopBatch;

});
parcelRegister("frvSu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4vnBz"));

});
parcelRegister("4vnBz", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $347c5e261cc67ba0$export$bf730a2d8bf68b42; }, function (v) { return $347c5e261cc67ba0$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $347c5e261cc67ba0$export$bf730a2d8bf68b42;
"use strict";

var $jGswQ = parcelRequire("jGswQ");
function $347c5e261cc67ba0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $347c5e261cc67ba0$var$objectIs = "function" === typeof Object.is ? Object.is : $347c5e261cc67ba0$var$is, $347c5e261cc67ba0$var$useSyncExternalStore = $jGswQ.useSyncExternalStore, $347c5e261cc67ba0$var$useRef = $jGswQ.useRef, $347c5e261cc67ba0$var$useEffect = $jGswQ.useEffect, $347c5e261cc67ba0$var$useMemo = $jGswQ.useMemo, $347c5e261cc67ba0$var$useDebugValue = $jGswQ.useDebugValue;
$347c5e261cc67ba0$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $347c5e261cc67ba0$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $347c5e261cc67ba0$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($347c5e261cc67ba0$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $347c5e261cc67ba0$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $347c5e261cc67ba0$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $347c5e261cc67ba0$var$useDebugValue(value);
    return value;
};

});



parcelRegister("4mAjV", function(module, exports) {

$parcel$export(module.exports, "addItem", function () { return $32d563fa7746edf1$export$fb9705de59d96855; });
$parcel$export(module.exports, "removeItemById", function () { return $32d563fa7746edf1$export$9df6e8dd71cb4662; });
$parcel$export(module.exports, "decrementQty", function () { return $32d563fa7746edf1$export$21b3bef1bad4302d; });
$parcel$export(module.exports, "clearCart", function () { return $32d563fa7746edf1$export$810121176e3e3671; });
$parcel$export(module.exports, "selectCartCount", function () { return $32d563fa7746edf1$export$4e3e88505866a6ef; });
$parcel$export(module.exports, "selectCartTotal", function () { return $32d563fa7746edf1$export$62731dbd6ef22fce; });
$parcel$export(module.exports, "default", function () { return $32d563fa7746edf1$export$2e2bcd8739ae039; });

var $hpG1k = parcelRequire("hpG1k");
const $32d563fa7746edf1$var$initialState = {
    items: []
};
const $32d563fa7746edf1$var$cartSlice = (0, $hpG1k.createSlice)({
    name: "cart",
    initialState: $32d563fa7746edf1$var$initialState,
    reducers: {
        addItem: (state, action)=>{
            const incoming = action.payload; // {id, name, price, image}
            const found = state.items.find((it)=>it.id === incoming.id);
            if (found) found.qty += 1;
            else state.items.push({
                ...incoming,
                qty: 1
            });
        },
        // Original removeItem kept (pops last) in case you use it elsewhere
        removeItem: (state)=>{
            state.items.pop();
        },
        // NEW: remove by id
        removeItemById: (state, action)=>{
            const id = action.payload;
            state.items = state.items.filter((it)=>it.id !== id);
        },
        // NEW: decrement qty (removes when qty hits 0)
        decrementQty: (state, action)=>{
            const id = action.payload;
            const found = state.items.find((it)=>it.id === id);
            if (found) {
                found.qty -= 1;
                if (found.qty <= 0) state.items = state.items.filter((it)=>it.id !== id);
            }
        },
        clearCart: (state)=>{
            state.items = [];
        }
    }
});
const { addItem: $32d563fa7746edf1$export$fb9705de59d96855, removeItem: $32d563fa7746edf1$export$fe2d9b4e03920b4c, removeItemById: $32d563fa7746edf1$export$9df6e8dd71cb4662, decrementQty: $32d563fa7746edf1$export$21b3bef1bad4302d, clearCart: $32d563fa7746edf1$export$810121176e3e3671 } = $32d563fa7746edf1$var$cartSlice.actions;
const $32d563fa7746edf1$export$4e3e88505866a6ef = (state)=>state.cart.items.reduce((sum, it)=>sum + (it.qty || 0), 0);
const $32d563fa7746edf1$export$62731dbd6ef22fce = (state)=>state.cart.items.reduce((sum, it)=>sum + (it.price || 0) * (it.qty || 0), 0);
var $32d563fa7746edf1$export$2e2bcd8739ae039 = $32d563fa7746edf1$var$cartSlice.reducer;

});
parcelRegister("hpG1k", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $cad55dd54e60aa77$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $cad55dd54e60aa77$export$6abd22dc03e5063f; });
$parcel$export(module.exports, "createSlice", function () { return $cad55dd54e60aa77$export$4d8d9bd83c24ae8b; });

var $aerZj = parcelRequire("aerZj");

var $2bjsT = parcelRequire("2bjsT");

var $fs6kw = parcelRequire("fs6kw");

var $aaIyi = parcelRequire("aaIyi");
var $cad55dd54e60aa77$var$__defProp = Object.defineProperty;
var $cad55dd54e60aa77$var$__defProps = Object.defineProperties;
var $cad55dd54e60aa77$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cad55dd54e60aa77$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cad55dd54e60aa77$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cad55dd54e60aa77$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cad55dd54e60aa77$var$__defNormalProp = (obj, key, value)=>key in obj ? $cad55dd54e60aa77$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cad55dd54e60aa77$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cad55dd54e60aa77$var$__hasOwnProp.call(b, prop)) $cad55dd54e60aa77$var$__defNormalProp(a, prop, b[prop]);
    if ($cad55dd54e60aa77$var$__getOwnPropSymbols) {
        for (var prop of $cad55dd54e60aa77$var$__getOwnPropSymbols(b))if ($cad55dd54e60aa77$var$__propIsEnum.call(b, prop)) $cad55dd54e60aa77$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cad55dd54e60aa77$var$__spreadProps = (a, b)=>$cad55dd54e60aa77$var$__defProps(a, $cad55dd54e60aa77$var$__getOwnPropDescs(b));
var $cad55dd54e60aa77$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($cad55dd54e60aa77$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $cad55dd54e60aa77$var$__getOwnPropSymbols) {
        for (var prop of $cad55dd54e60aa77$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $cad55dd54e60aa77$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $cad55dd54e60aa77$var$__publicField = (obj, key, value)=>$cad55dd54e60aa77$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $cad55dd54e60aa77$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $fs6kw.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $2bjsT.isDraft)(value) ? (0, $2bjsT.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $cad55dd54e60aa77$export$a5d3c27355e35910 = /* @__PURE__ */ $cad55dd54e60aa77$export$aab6de9e3dbb1473((0, $fs6kw.weakMapMemoize));
var $cad55dd54e60aa77$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $aerZj.compose;
    return (0, $aerZj.compose).apply(null, arguments);
};
var $cad55dd54e60aa77$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $cad55dd54e60aa77$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $cad55dd54e60aa77$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(0));
            return $cad55dd54e60aa77$var$__spreadValues($cad55dd54e60aa77$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $aerZj.isAction)(action) && action.type === type;
    return actionCreator;
}
function $cad55dd54e60aa77$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $cad55dd54e60aa77$var$hasMatchFunction(action);
}
function $cad55dd54e60aa77$export$ebd532f9034651f3(action) {
    return (0, $aerZj.isAction)(action) && Object.keys(action).every($cad55dd54e60aa77$var$isValidKey);
}
function $cad55dd54e60aa77$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $cad55dd54e60aa77$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $cad55dd54e60aa77$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $cad55dd54e60aa77$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $cad55dd54e60aa77$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $cad55dd54e60aa77$var$freezeDraftable(val) {
    return (0, $2bjsT.isDraftable)(val) ? (0, $2bjsT.produce)(val, ()=>{}) : val;
}
function $cad55dd54e60aa77$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $cad55dd54e60aa77$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $cad55dd54e60aa77$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $cad55dd54e60aa77$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $cad55dd54e60aa77$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $cad55dd54e60aa77$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $cad55dd54e60aa77$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $cad55dd54e60aa77$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $cad55dd54e60aa77$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $cad55dd54e60aa77$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $cad55dd54e60aa77$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $aerZj.isPlainObject)(val);
}
function $cad55dd54e60aa77$export$ada5dca0b571bc7(value, path = "", isSerializable = $cad55dd54e60aa77$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $cad55dd54e60aa77$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $cad55dd54e60aa77$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $cad55dd54e60aa77$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$cad55dd54e60aa77$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $cad55dd54e60aa77$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $cad55dd54e60aa77$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $cad55dd54e60aa77$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $cad55dd54e60aa77$export$1908877435b1d5e9();
        if (thunk) {
            if ($cad55dd54e60aa77$var$isBoolean(thunk)) middlewareArray.push((0, $aaIyi.thunk));
            else middlewareArray.push((0, $aaIyi.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $cad55dd54e60aa77$export$8fb31c0f05df007b = "RTK_autoBatch";
var $cad55dd54e60aa77$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$cad55dd54e60aa77$export$8fb31c0f05df007b]: true
            }
        });
var $cad55dd54e60aa77$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $cad55dd54e60aa77$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $cad55dd54e60aa77$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $cad55dd54e60aa77$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$cad55dd54e60aa77$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $cad55dd54e60aa77$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $cad55dd54e60aa77$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($cad55dd54e60aa77$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $cad55dd54e60aa77$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $cad55dd54e60aa77$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $aerZj.isPlainObject)(reducer)) rootReducer = (0, $aerZj.combineReducers)(reducer);
    else throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $aerZj.compose);
    if (devTools) finalCompose = $cad55dd54e60aa77$var$composeWithDevTools($cad55dd54e60aa77$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $aerZj.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $cad55dd54e60aa77$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $aerZj.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $cad55dd54e60aa77$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $cad55dd54e60aa77$var$isStateFunction(x) {
    return typeof x === "function";
}
function $cad55dd54e60aa77$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $cad55dd54e60aa77$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($cad55dd54e60aa77$var$isStateFunction(initialState)) getInitialState = ()=>$cad55dd54e60aa77$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $cad55dd54e60aa77$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $2bjsT.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $2bjsT.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $2bjsT.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $cad55dd54e60aa77$var$matches = (matcher, action)=>{
    if ($cad55dd54e60aa77$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $cad55dd54e60aa77$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$cad55dd54e60aa77$var$matches(matcher, action));
    };
}
function $cad55dd54e60aa77$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$cad55dd54e60aa77$var$matches(matcher, action));
    };
}
function $cad55dd54e60aa77$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $cad55dd54e60aa77$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $cad55dd54e60aa77$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cad55dd54e60aa77$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$cad55dd54e60aa77$var$isAsyncThunkArray(asyncThunks)) return $cad55dd54e60aa77$export$872dec21e9a69476()(asyncThunks[0]);
    return $cad55dd54e60aa77$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $cad55dd54e60aa77$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cad55dd54e60aa77$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$cad55dd54e60aa77$var$isAsyncThunkArray(asyncThunks)) return $cad55dd54e60aa77$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $cad55dd54e60aa77$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $cad55dd54e60aa77$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $cad55dd54e60aa77$export$9dd1fb32974da385($cad55dd54e60aa77$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$cad55dd54e60aa77$var$isAsyncThunkArray(asyncThunks)) return $cad55dd54e60aa77$export$fcc3388fb56de601()(asyncThunks[0]);
    return $cad55dd54e60aa77$export$9dd1fb32974da385($cad55dd54e60aa77$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $cad55dd54e60aa77$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cad55dd54e60aa77$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$cad55dd54e60aa77$var$isAsyncThunkArray(asyncThunks)) return $cad55dd54e60aa77$export$1da80a6ef1307441()(asyncThunks[0]);
    return $cad55dd54e60aa77$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $cad55dd54e60aa77$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$cad55dd54e60aa77$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$cad55dd54e60aa77$var$isAsyncThunkArray(asyncThunks)) return $cad55dd54e60aa77$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $cad55dd54e60aa77$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $cad55dd54e60aa77$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $cad55dd54e60aa77$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $cad55dd54e60aa77$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $cad55dd54e60aa77$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $cad55dd54e60aa77$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $cad55dd54e60aa77$var$__publicField(this, "_type");
    }
};
var $cad55dd54e60aa77$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $cad55dd54e60aa77$var$__publicField(this, "_type");
    }
};
var $cad55dd54e60aa77$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $cad55dd54e60aa77$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $cad55dd54e60aa77$var$externalAbortMessage = "External signal was aborted";
var $cad55dd54e60aa77$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $cad55dd54e60aa77$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $cad55dd54e60aa77$var$__spreadProps($cad55dd54e60aa77$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $cad55dd54e60aa77$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $cad55dd54e60aa77$var$__spreadProps($cad55dd54e60aa77$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $cad55dd54e60aa77$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $cad55dd54e60aa77$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $cad55dd54e60aa77$var$__spreadProps($cad55dd54e60aa77$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $cad55dd54e60aa77$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($cad55dd54e60aa77$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($cad55dd54e60aa77$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($cad55dd54e60aa77$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $cad55dd54e60aa77$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $cad55dd54e60aa77$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $cad55dd54e60aa77$var$RejectWithValue) throw result;
                                if (result instanceof $cad55dd54e60aa77$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $cad55dd54e60aa77$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($cad55dd54e60aa77$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $cad55dd54e60aa77$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $cad55dd54e60aa77$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $cad55dd54e60aa77$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $cad55dd54e60aa77$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $cad55dd54e60aa77$export$343355ed40c51c46 = {
    [$cad55dd54e60aa77$var$asyncThunkSymbol]: $cad55dd54e60aa77$export$6abd22dc03e5063f
};
var $cad55dd54e60aa77$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($cad55dd54e60aa77$export$23a094319a4b586 || {});
function $cad55dd54e60aa77$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $cad55dd54e60aa77$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$cad55dd54e60aa77$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($cad55dd54e60aa77$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $cad55dd54e60aa77$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($cad55dd54e60aa77$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $cad55dd54e60aa77$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $cad55dd54e60aa77$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $cad55dd54e60aa77$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $cad55dd54e60aa77$var$__spreadValues($cad55dd54e60aa77$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $cad55dd54e60aa77$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $cad55dd54e60aa77$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $cad55dd54e60aa77$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $cad55dd54e60aa77$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $cad55dd54e60aa77$var$wrapSelector(selector, selectState, ()=>$cad55dd54e60aa77$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $cad55dd54e60aa77$var$__spreadProps($cad55dd54e60aa77$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $cad55dd54e60aa77$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $cad55dd54e60aa77$var$__spreadValues($cad55dd54e60aa77$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $cad55dd54e60aa77$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $cad55dd54e60aa77$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $cad55dd54e60aa77$export$affdea4146de9cf5();
function $cad55dd54e60aa77$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $cad55dd54e60aa77$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $cad55dd54e60aa77$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$cad55dd54e60aa77$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $cad55dd54e60aa77$export$309c7a02b0b0bc62(type, prepareCallback) : $cad55dd54e60aa77$export$309c7a02b0b0bc62(type));
}
function $cad55dd54e60aa77$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $cad55dd54e60aa77$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $cad55dd54e60aa77$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $cad55dd54e60aa77$var$noop,
        pending: pending || $cad55dd54e60aa77$var$noop,
        rejected: rejected || $cad55dd54e60aa77$var$noop,
        settled: settled || $cad55dd54e60aa77$var$noop
    });
}
function $cad55dd54e60aa77$var$noop() {}
// src/entities/entity_state.ts
function $cad55dd54e60aa77$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $cad55dd54e60aa77$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($cad55dd54e60aa77$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $cad55dd54e60aa77$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $cad55dd54e60aa77$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $cad55dd54e60aa77$var$isDraftTyped = (0, $2bjsT.isDraft);
function $cad55dd54e60aa77$var$createSingleArgumentStateOperator(mutator) {
    const operator = $cad55dd54e60aa77$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $cad55dd54e60aa77$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $cad55dd54e60aa77$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($cad55dd54e60aa77$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $2bjsT.produce)(state, runMutator);
    };
}
function $cad55dd54e60aa77$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $cad55dd54e60aa77$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $cad55dd54e60aa77$var$getCurrent(value) {
    return (0, $2bjsT.isDraft)(value) ? (0, $2bjsT.current)(value) : value;
}
function $cad55dd54e60aa77$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $cad55dd54e60aa77$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $cad55dd54e60aa77$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $cad55dd54e60aa77$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $cad55dd54e60aa77$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $cad55dd54e60aa77$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $cad55dd54e60aa77$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $cad55dd54e60aa77$var$__spreadValues($cad55dd54e60aa77$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$cad55dd54e60aa77$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $cad55dd54e60aa77$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $cad55dd54e60aa77$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $cad55dd54e60aa77$var$createStateOperator(addOneMutably),
        addMany: $cad55dd54e60aa77$var$createStateOperator(addManyMutably),
        setOne: $cad55dd54e60aa77$var$createStateOperator(setOneMutably),
        setMany: $cad55dd54e60aa77$var$createStateOperator(setManyMutably),
        setAll: $cad55dd54e60aa77$var$createStateOperator(setAllMutably),
        updateOne: $cad55dd54e60aa77$var$createStateOperator(updateOneMutably),
        updateMany: $cad55dd54e60aa77$var$createStateOperator(updateManyMutably),
        upsertOne: $cad55dd54e60aa77$var$createStateOperator(upsertOneMutably),
        upsertMany: $cad55dd54e60aa77$var$createStateOperator(upsertManyMutably),
        removeOne: $cad55dd54e60aa77$var$createStateOperator(removeOneMutably),
        removeMany: $cad55dd54e60aa77$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $cad55dd54e60aa77$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $cad55dd54e60aa77$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $cad55dd54e60aa77$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $cad55dd54e60aa77$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $cad55dd54e60aa77$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $cad55dd54e60aa77$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($cad55dd54e60aa77$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $cad55dd54e60aa77$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $cad55dd54e60aa77$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $cad55dd54e60aa77$var$getCurrent(state.entities);
        const currentIds = $cad55dd54e60aa77$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $cad55dd54e60aa77$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $cad55dd54e60aa77$var$createStateOperator(addOneMutably),
        updateOne: $cad55dd54e60aa77$var$createStateOperator(updateOneMutably),
        upsertOne: $cad55dd54e60aa77$var$createStateOperator(upsertOneMutably),
        setOne: $cad55dd54e60aa77$var$createStateOperator(setOneMutably),
        setMany: $cad55dd54e60aa77$var$createStateOperator(setManyMutably),
        setAll: $cad55dd54e60aa77$var$createStateOperator(setAllMutably),
        addMany: $cad55dd54e60aa77$var$createStateOperator(addManyMutably),
        updateMany: $cad55dd54e60aa77$var$createStateOperator(updateManyMutably),
        upsertMany: $cad55dd54e60aa77$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $cad55dd54e60aa77$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $cad55dd54e60aa77$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $cad55dd54e60aa77$var$createSortedStateAdapter(selectId, sortComparer) : $cad55dd54e60aa77$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $cad55dd54e60aa77$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $cad55dd54e60aa77$var$createSelectorsFactory();
    return $cad55dd54e60aa77$var$__spreadValues($cad55dd54e60aa77$var$__spreadValues($cad55dd54e60aa77$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $cad55dd54e60aa77$var$task = "task";
var $cad55dd54e60aa77$var$listener = "listener";
var $cad55dd54e60aa77$var$completed = "completed";
var $cad55dd54e60aa77$var$cancelled = "cancelled";
var $cad55dd54e60aa77$var$taskCancelled = `task-${$cad55dd54e60aa77$var$cancelled}`;
var $cad55dd54e60aa77$var$taskCompleted = `task-${$cad55dd54e60aa77$var$completed}`;
var $cad55dd54e60aa77$var$listenerCancelled = `${$cad55dd54e60aa77$var$listener}-${$cad55dd54e60aa77$var$cancelled}`;
var $cad55dd54e60aa77$var$listenerCompleted = `${$cad55dd54e60aa77$var$listener}-${$cad55dd54e60aa77$var$completed}`;
var $cad55dd54e60aa77$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $cad55dd54e60aa77$var$__publicField(this, "name", "TaskAbortError");
        $cad55dd54e60aa77$var$__publicField(this, "message");
        this.message = `${$cad55dd54e60aa77$var$task} ${$cad55dd54e60aa77$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $cad55dd54e60aa77$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($cad55dd54e60aa77$export$378fa86b259c0280(32));
};
var $cad55dd54e60aa77$var$noop2 = ()=>{};
var $cad55dd54e60aa77$var$catchRejection = (promise, onError = $cad55dd54e60aa77$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $cad55dd54e60aa77$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $cad55dd54e60aa77$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $cad55dd54e60aa77$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $cad55dd54e60aa77$export$cb1bdac908fed7f(reason);
    }
};
function $cad55dd54e60aa77$var$raceWithSignal(signal, promise) {
    let cleanup = $cad55dd54e60aa77$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $cad55dd54e60aa77$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $cad55dd54e60aa77$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $cad55dd54e60aa77$var$noop2;
    });
}
var $cad55dd54e60aa77$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $cad55dd54e60aa77$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $cad55dd54e60aa77$var$createPause = (signal)=>{
    return (promise)=>{
        return $cad55dd54e60aa77$var$catchRejection($cad55dd54e60aa77$var$raceWithSignal(signal, promise).then((output)=>{
            $cad55dd54e60aa77$var$validateActive(signal);
            return output;
        }));
    };
};
var $cad55dd54e60aa77$var$createDelay = (signal)=>{
    const pause = $cad55dd54e60aa77$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $cad55dd54e60aa77$var$assign } = Object;
var $cad55dd54e60aa77$var$INTERNAL_NIL_TOKEN = {};
var $cad55dd54e60aa77$var$alm = "listenerMiddleware";
var $cad55dd54e60aa77$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$cad55dd54e60aa77$var$addAbortSignalListener(parentAbortSignal, ()=>$cad55dd54e60aa77$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $cad55dd54e60aa77$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $cad55dd54e60aa77$var$runTask(async ()=>{
            $cad55dd54e60aa77$var$validateActive(parentAbortSignal);
            $cad55dd54e60aa77$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $cad55dd54e60aa77$var$createPause(childAbortController.signal),
                delay: $cad55dd54e60aa77$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $cad55dd54e60aa77$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$cad55dd54e60aa77$var$abortControllerWithReason(childAbortController, $cad55dd54e60aa77$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($cad55dd54e60aa77$var$noop2));
        return {
            result: $cad55dd54e60aa77$var$createPause(parentAbortSignal)(result),
            cancel () {
                $cad55dd54e60aa77$var$abortControllerWithReason(childAbortController, $cad55dd54e60aa77$var$taskCancelled);
            }
        };
    };
};
var $cad55dd54e60aa77$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $cad55dd54e60aa77$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $cad55dd54e60aa77$var$raceWithSignal(signal, Promise.race(promises));
            $cad55dd54e60aa77$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$cad55dd54e60aa77$var$catchRejection(take(predicate, timeout));
};
var $cad55dd54e60aa77$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $cad55dd54e60aa77$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(21));
    $cad55dd54e60aa77$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $cad55dd54e60aa77$var$createListenerEntry = /* @__PURE__ */ $cad55dd54e60aa77$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $cad55dd54e60aa77$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $cad55dd54e60aa77$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$cad55dd54e60aa77$var$createListenerEntry
});
var $cad55dd54e60aa77$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $cad55dd54e60aa77$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $cad55dd54e60aa77$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $cad55dd54e60aa77$var$abortControllerWithReason(controller, $cad55dd54e60aa77$var$listenerCancelled);
    });
};
var $cad55dd54e60aa77$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($cad55dd54e60aa77$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $cad55dd54e60aa77$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $cad55dd54e60aa77$export$f03a6b845d3fb58b = /* @__PURE__ */ $cad55dd54e60aa77$var$assign(/* @__PURE__ */ $cad55dd54e60aa77$export$309c7a02b0b0bc62(`${$cad55dd54e60aa77$var$alm}/add`), {
    withTypes: ()=>$cad55dd54e60aa77$export$f03a6b845d3fb58b
});
var $cad55dd54e60aa77$export$b1b8022855fb2b71 = /* @__PURE__ */ $cad55dd54e60aa77$export$309c7a02b0b0bc62(`${$cad55dd54e60aa77$var$alm}/removeAll`);
var $cad55dd54e60aa77$export$b03e9483f936dccb = /* @__PURE__ */ $cad55dd54e60aa77$var$assign(/* @__PURE__ */ $cad55dd54e60aa77$export$309c7a02b0b0bc62(`${$cad55dd54e60aa77$var$alm}/remove`), {
    withTypes: ()=>$cad55dd54e60aa77$export$b03e9483f936dccb
});
var $cad55dd54e60aa77$var$defaultErrorHandler = (...args)=>{
    console.error(`${$cad55dd54e60aa77$var$alm}/error`, ...args);
};
var $cad55dd54e60aa77$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $cad55dd54e60aa77$var$defaultErrorHandler } = middlewareOptions;
    $cad55dd54e60aa77$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $cad55dd54e60aa77$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $cad55dd54e60aa77$var$findListenerEntry(listenerMap, options)) != null ? _a : $cad55dd54e60aa77$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $cad55dd54e60aa77$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $cad55dd54e60aa77$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $cad55dd54e60aa77$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $cad55dd54e60aa77$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $cad55dd54e60aa77$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $cad55dd54e60aa77$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $cad55dd54e60aa77$var$createDelay(internalTaskController.signal),
                pause: $cad55dd54e60aa77$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $cad55dd54e60aa77$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $cad55dd54e60aa77$var$abortControllerWithReason(controller, $cad55dd54e60aa77$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $cad55dd54e60aa77$var$abortControllerWithReason(internalTaskController, $cad55dd54e60aa77$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $cad55dd54e60aa77$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $cad55dd54e60aa77$export$cb1bdac908fed7f)) $cad55dd54e60aa77$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $cad55dd54e60aa77$var$abortControllerWithReason(internalTaskController, $cad55dd54e60aa77$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $cad55dd54e60aa77$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $aerZj.isAction)(action)) return next(action);
                if ($cad55dd54e60aa77$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($cad55dd54e60aa77$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($cad55dd54e60aa77$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $cad55dd54e60aa77$var$INTERNAL_NIL_TOKEN) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $cad55dd54e60aa77$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $cad55dd54e60aa77$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $cad55dd54e60aa77$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $cad55dd54e60aa77$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $cad55dd54e60aa77$export$4bb1606a79445586 = ()=>{
    const instanceId = $cad55dd54e60aa77$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($cad55dd54e60aa77$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $cad55dd54e60aa77$var$getOrInsertComputed(middlewareMap, middleware2, $cad55dd54e60aa77$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$cad55dd54e60aa77$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $aerZj.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $cad55dd54e60aa77$export$9dd1fb32974da385(withMiddleware, $cad55dd54e60aa77$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $cad55dd54e60aa77$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $cad55dd54e60aa77$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$cad55dd54e60aa77$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $cad55dd54e60aa77$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $cad55dd54e60aa77$var$isStateProxy = (value)=>!!value && !!value[$cad55dd54e60aa77$var$ORIGINAL_STATE];
var $cad55dd54e60aa77$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $cad55dd54e60aa77$var$createStateProxy = (state, reducerMap, initialStateCache)=>$cad55dd54e60aa77$var$getOrInsertComputed($cad55dd54e60aa77$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $cad55dd54e60aa77$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $cad55dd54e60aa77$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $cad55dd54e60aa77$var$original = (state)=>{
    if (!$cad55dd54e60aa77$var$isStateProxy(state)) throw new Error($cad55dd54e60aa77$export$378fa86b259c0280(25));
    return state[$cad55dd54e60aa77$var$ORIGINAL_STATE];
};
var $cad55dd54e60aa77$var$emptyObject = {};
var $cad55dd54e60aa77$var$noopReducer = (state = $cad55dd54e60aa77$var$emptyObject)=>state;
function $cad55dd54e60aa77$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($cad55dd54e60aa77$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $aerZj.combineReducers)(reducerMap) : $cad55dd54e60aa77$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($cad55dd54e60aa77$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $cad55dd54e60aa77$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $cad55dd54e60aa77$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("aerZj", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $7730ec01d6e0ed35$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "createStore", function () { return $7730ec01d6e0ed35$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $7730ec01d6e0ed35$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $7730ec01d6e0ed35$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $7730ec01d6e0ed35$export$9ff26e0402cc7b7; });
$parcel$export(module.exports, "isAction", function () { return $7730ec01d6e0ed35$export$b956e38827fca970; });
// src/utils/formatProdErrorMessage.ts
function $7730ec01d6e0ed35$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $7730ec01d6e0ed35$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $7730ec01d6e0ed35$var$symbol_observable_default = $7730ec01d6e0ed35$var$$$observable;
// src/utils/actionTypes.ts
var $7730ec01d6e0ed35$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $7730ec01d6e0ed35$var$ActionTypes = {
    INIT: `@@redux/INIT${$7730ec01d6e0ed35$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$7730ec01d6e0ed35$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$7730ec01d6e0ed35$var$randomString()}`
};
var $7730ec01d6e0ed35$export$4219e499db7ca678 = $7730ec01d6e0ed35$var$ActionTypes;
// src/utils/isPlainObject.ts
function $7730ec01d6e0ed35$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $7730ec01d6e0ed35$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($7730ec01d6e0ed35$var$isDate(val)) return "date";
    if ($7730ec01d6e0ed35$var$isError(val)) return "error";
    const constructorName = $7730ec01d6e0ed35$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $7730ec01d6e0ed35$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $7730ec01d6e0ed35$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $7730ec01d6e0ed35$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $7730ec01d6e0ed35$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $7730ec01d6e0ed35$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(1));
        return enhancer($7730ec01d6e0ed35$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$7730ec01d6e0ed35$export$53b83ca8eaab0383(action)) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $7730ec01d6e0ed35$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$7730ec01d6e0ed35$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $7730ec01d6e0ed35$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$7730ec01d6e0ed35$var$symbol_observable_default]: observable
    };
    return store;
}
function $7730ec01d6e0ed35$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $7730ec01d6e0ed35$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $7730ec01d6e0ed35$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $7730ec01d6e0ed35$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $7730ec01d6e0ed35$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$7730ec01d6e0ed35$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$7730ec01d6e0ed35$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $7730ec01d6e0ed35$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $7730ec01d6e0ed35$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $7730ec01d6e0ed35$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $7730ec01d6e0ed35$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(13));
    });
}
function $7730ec01d6e0ed35$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $7730ec01d6e0ed35$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $7730ec01d6e0ed35$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $7730ec01d6e0ed35$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $7730ec01d6e0ed35$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $7730ec01d6e0ed35$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $7730ec01d6e0ed35$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $7730ec01d6e0ed35$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($7730ec01d6e0ed35$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $7730ec01d6e0ed35$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $7730ec01d6e0ed35$export$b956e38827fca970(action) {
    return $7730ec01d6e0ed35$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("2bjsT", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $196bb52fa95b7a22$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $196bb52fa95b7a22$export$16e3aed3edb85946; });
$parcel$export(module.exports, "current", function () { return $196bb52fa95b7a22$export$97aac956da55dae9; });
$parcel$export(module.exports, "produce", function () { return $196bb52fa95b7a22$export$b46cabe22e78bc00; });
var $196bb52fa95b7a22$var$__defProp = Object.defineProperty;
var $196bb52fa95b7a22$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $196bb52fa95b7a22$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $196bb52fa95b7a22$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $196bb52fa95b7a22$var$__defNormalProp = (obj, key, value)=>key in obj ? $196bb52fa95b7a22$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $196bb52fa95b7a22$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($196bb52fa95b7a22$var$__hasOwnProp.call(b, prop)) $196bb52fa95b7a22$var$__defNormalProp(a, prop, b[prop]);
    if ($196bb52fa95b7a22$var$__getOwnPropSymbols) {
        for (var prop of $196bb52fa95b7a22$var$__getOwnPropSymbols(b))if ($196bb52fa95b7a22$var$__propIsEnum.call(b, prop)) $196bb52fa95b7a22$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $196bb52fa95b7a22$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $196bb52fa95b7a22$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $196bb52fa95b7a22$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $196bb52fa95b7a22$var$errors = [];
function $196bb52fa95b7a22$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $196bb52fa95b7a22$var$getPrototypeOf = Object.getPrototypeOf;
function $196bb52fa95b7a22$export$541ac630993a4c84(value) {
    return !!value && !!value[$196bb52fa95b7a22$var$DRAFT_STATE];
}
function $196bb52fa95b7a22$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $196bb52fa95b7a22$var$isPlainObject(value) || Array.isArray(value) || !!value[$196bb52fa95b7a22$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$196bb52fa95b7a22$export$6ee2082928bcb0ee]) || $196bb52fa95b7a22$var$isMap(value) || $196bb52fa95b7a22$var$isSet(value);
}
var $196bb52fa95b7a22$var$objectCtorString = Object.prototype.constructor.toString();
function $196bb52fa95b7a22$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $196bb52fa95b7a22$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $196bb52fa95b7a22$var$objectCtorString;
}
function $196bb52fa95b7a22$export$22e8af3f75a010e3(value) {
    if (!$196bb52fa95b7a22$export$541ac630993a4c84(value)) $196bb52fa95b7a22$var$die(15, value);
    return value[$196bb52fa95b7a22$var$DRAFT_STATE].base_;
}
function $196bb52fa95b7a22$var$each(obj, iter) {
    if ($196bb52fa95b7a22$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $196bb52fa95b7a22$var$getArchtype(thing) {
    const state = thing[$196bb52fa95b7a22$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $196bb52fa95b7a22$var$isMap(thing) ? 2 /* Map */  : $196bb52fa95b7a22$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $196bb52fa95b7a22$var$has(thing, prop) {
    return $196bb52fa95b7a22$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $196bb52fa95b7a22$var$get(thing, prop) {
    return $196bb52fa95b7a22$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $196bb52fa95b7a22$var$set(thing, propOrOldValue, value) {
    const t = $196bb52fa95b7a22$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $196bb52fa95b7a22$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $196bb52fa95b7a22$var$isMap(target) {
    return target instanceof Map;
}
function $196bb52fa95b7a22$var$isSet(target) {
    return target instanceof Set;
}
function $196bb52fa95b7a22$var$latest(state) {
    return state.copy_ || state.base_;
}
function $196bb52fa95b7a22$var$shallowCopy(base, strict) {
    if ($196bb52fa95b7a22$var$isMap(base)) return new Map(base);
    if ($196bb52fa95b7a22$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $196bb52fa95b7a22$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$196bb52fa95b7a22$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($196bb52fa95b7a22$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $196bb52fa95b7a22$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $196bb52fa95b7a22$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $196bb52fa95b7a22$export$792f3d81ea979f55(obj, deep = false) {
    if ($196bb52fa95b7a22$var$isFrozen(obj) || $196bb52fa95b7a22$export$541ac630993a4c84(obj) || !$196bb52fa95b7a22$export$16e3aed3edb85946(obj)) return obj;
    if ($196bb52fa95b7a22$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $196bb52fa95b7a22$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$196bb52fa95b7a22$export$792f3d81ea979f55(value, true));
    return obj;
}
function $196bb52fa95b7a22$var$dontMutateFrozenCollections() {
    $196bb52fa95b7a22$var$die(2);
}
function $196bb52fa95b7a22$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $196bb52fa95b7a22$var$plugins = {};
function $196bb52fa95b7a22$var$getPlugin(pluginKey) {
    const plugin = $196bb52fa95b7a22$var$plugins[pluginKey];
    if (!plugin) $196bb52fa95b7a22$var$die(0, pluginKey);
    return plugin;
}
function $196bb52fa95b7a22$var$loadPlugin(pluginKey, implementation) {
    if (!$196bb52fa95b7a22$var$plugins[pluginKey]) $196bb52fa95b7a22$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $196bb52fa95b7a22$var$currentScope;
function $196bb52fa95b7a22$var$getCurrentScope() {
    return $196bb52fa95b7a22$var$currentScope;
}
function $196bb52fa95b7a22$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $196bb52fa95b7a22$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $196bb52fa95b7a22$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $196bb52fa95b7a22$var$revokeScope(scope) {
    $196bb52fa95b7a22$var$leaveScope(scope);
    scope.drafts_.forEach($196bb52fa95b7a22$var$revokeDraft);
    scope.drafts_ = null;
}
function $196bb52fa95b7a22$var$leaveScope(scope) {
    if (scope === $196bb52fa95b7a22$var$currentScope) $196bb52fa95b7a22$var$currentScope = scope.parent_;
}
function $196bb52fa95b7a22$var$enterScope(immer2) {
    return $196bb52fa95b7a22$var$currentScope = $196bb52fa95b7a22$var$createScope($196bb52fa95b7a22$var$currentScope, immer2);
}
function $196bb52fa95b7a22$var$revokeDraft(draft) {
    const state = draft[$196bb52fa95b7a22$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $196bb52fa95b7a22$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$196bb52fa95b7a22$var$DRAFT_STATE].modified_) {
            $196bb52fa95b7a22$var$revokeScope(scope);
            $196bb52fa95b7a22$var$die(4);
        }
        if ($196bb52fa95b7a22$export$16e3aed3edb85946(result)) {
            result = $196bb52fa95b7a22$var$finalize(scope, result);
            if (!scope.parent_) $196bb52fa95b7a22$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $196bb52fa95b7a22$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$196bb52fa95b7a22$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $196bb52fa95b7a22$var$finalize(scope, baseDraft, []);
    $196bb52fa95b7a22$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $196bb52fa95b7a22$export$45b790e32b2810ee ? result : void 0;
}
function $196bb52fa95b7a22$var$finalize(rootScope, value, path) {
    if ($196bb52fa95b7a22$var$isFrozen(value)) return value;
    const state = value[$196bb52fa95b7a22$var$DRAFT_STATE];
    if (!state) {
        $196bb52fa95b7a22$var$each(value, (key, childValue)=>$196bb52fa95b7a22$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $196bb52fa95b7a22$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $196bb52fa95b7a22$var$each(resultEach, (key, childValue)=>$196bb52fa95b7a22$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $196bb52fa95b7a22$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $196bb52fa95b7a22$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $196bb52fa95b7a22$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($196bb52fa95b7a22$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$196bb52fa95b7a22$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $196bb52fa95b7a22$var$finalize(rootScope, childValue, path);
        $196bb52fa95b7a22$var$set(targetObject, prop, res);
        if ($196bb52fa95b7a22$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($196bb52fa95b7a22$export$16e3aed3edb85946(childValue) && !$196bb52fa95b7a22$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $196bb52fa95b7a22$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $196bb52fa95b7a22$var$maybeFreeze(rootScope, childValue);
    }
}
function $196bb52fa95b7a22$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $196bb52fa95b7a22$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $196bb52fa95b7a22$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $196bb52fa95b7a22$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $196bb52fa95b7a22$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $196bb52fa95b7a22$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $196bb52fa95b7a22$var$objectTraps = {
    get (state, prop) {
        if (prop === $196bb52fa95b7a22$var$DRAFT_STATE) return state;
        const source = $196bb52fa95b7a22$var$latest(state);
        if (!$196bb52fa95b7a22$var$has(source, prop)) return $196bb52fa95b7a22$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$196bb52fa95b7a22$export$16e3aed3edb85946(value)) return value;
        if (value === $196bb52fa95b7a22$var$peek(state.base_, prop)) {
            $196bb52fa95b7a22$var$prepareCopy(state);
            return state.copy_[prop] = $196bb52fa95b7a22$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $196bb52fa95b7a22$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($196bb52fa95b7a22$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $196bb52fa95b7a22$var$getDescriptorFromProto($196bb52fa95b7a22$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $196bb52fa95b7a22$var$peek($196bb52fa95b7a22$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$196bb52fa95b7a22$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($196bb52fa95b7a22$var$is(value, current2) && (value !== void 0 || $196bb52fa95b7a22$var$has(state.base_, prop))) return true;
            $196bb52fa95b7a22$var$prepareCopy(state);
            $196bb52fa95b7a22$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($196bb52fa95b7a22$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $196bb52fa95b7a22$var$prepareCopy(state);
            $196bb52fa95b7a22$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $196bb52fa95b7a22$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $196bb52fa95b7a22$var$die(11);
    },
    getPrototypeOf (state) {
        return $196bb52fa95b7a22$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $196bb52fa95b7a22$var$die(12);
    }
};
var $196bb52fa95b7a22$var$arrayTraps = {};
$196bb52fa95b7a22$var$each($196bb52fa95b7a22$var$objectTraps, (key, fn)=>{
    $196bb52fa95b7a22$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$196bb52fa95b7a22$var$arrayTraps.deleteProperty = function(state, prop) {
    return $196bb52fa95b7a22$var$arrayTraps.set.call(this, state, prop, void 0);
};
$196bb52fa95b7a22$var$arrayTraps.set = function(state, prop, value) {
    return $196bb52fa95b7a22$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $196bb52fa95b7a22$var$peek(draft, prop) {
    const state = draft[$196bb52fa95b7a22$var$DRAFT_STATE];
    const source = state ? $196bb52fa95b7a22$var$latest(state) : draft;
    return source[prop];
}
function $196bb52fa95b7a22$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $196bb52fa95b7a22$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $196bb52fa95b7a22$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $196bb52fa95b7a22$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $196bb52fa95b7a22$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $196bb52fa95b7a22$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $196bb52fa95b7a22$var$markChanged(state.parent_);
    }
}
function $196bb52fa95b7a22$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $196bb52fa95b7a22$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $196bb52fa95b7a22$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $196bb52fa95b7a22$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $196bb52fa95b7a22$var$die(7);
            let result;
            if ($196bb52fa95b7a22$export$16e3aed3edb85946(base)) {
                const scope = $196bb52fa95b7a22$var$enterScope(this);
                const proxy = $196bb52fa95b7a22$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $196bb52fa95b7a22$var$revokeScope(scope);
                    else $196bb52fa95b7a22$var$leaveScope(scope);
                }
                $196bb52fa95b7a22$var$usePatchesInScope(scope, patchListener);
                return $196bb52fa95b7a22$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $196bb52fa95b7a22$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $196bb52fa95b7a22$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $196bb52fa95b7a22$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $196bb52fa95b7a22$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$196bb52fa95b7a22$export$16e3aed3edb85946(base)) $196bb52fa95b7a22$var$die(8);
        if ($196bb52fa95b7a22$export$541ac630993a4c84(base)) base = $196bb52fa95b7a22$export$97aac956da55dae9(base);
        const scope = $196bb52fa95b7a22$var$enterScope(this);
        const proxy = $196bb52fa95b7a22$var$createProxy(base, void 0);
        proxy[$196bb52fa95b7a22$var$DRAFT_STATE].isManual_ = true;
        $196bb52fa95b7a22$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$196bb52fa95b7a22$var$DRAFT_STATE];
        if (!state || !state.isManual_) $196bb52fa95b7a22$var$die(9);
        const { scope_: scope } = state;
        $196bb52fa95b7a22$var$usePatchesInScope(scope, patchListener);
        return $196bb52fa95b7a22$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $196bb52fa95b7a22$var$getPlugin("Patches").applyPatches_;
        if ($196bb52fa95b7a22$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $196bb52fa95b7a22$var$createProxy(value, parent) {
    const draft = $196bb52fa95b7a22$var$isMap(value) ? $196bb52fa95b7a22$var$getPlugin("MapSet").proxyMap_(value, parent) : $196bb52fa95b7a22$var$isSet(value) ? $196bb52fa95b7a22$var$getPlugin("MapSet").proxySet_(value, parent) : $196bb52fa95b7a22$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $196bb52fa95b7a22$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $196bb52fa95b7a22$export$97aac956da55dae9(value) {
    if (!$196bb52fa95b7a22$export$541ac630993a4c84(value)) $196bb52fa95b7a22$var$die(10, value);
    return $196bb52fa95b7a22$var$currentImpl(value);
}
function $196bb52fa95b7a22$var$currentImpl(value) {
    if (!$196bb52fa95b7a22$export$16e3aed3edb85946(value) || $196bb52fa95b7a22$var$isFrozen(value)) return value;
    const state = value[$196bb52fa95b7a22$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $196bb52fa95b7a22$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $196bb52fa95b7a22$var$shallowCopy(value, true);
    $196bb52fa95b7a22$var$each(copy, (key, childValue)=>{
        $196bb52fa95b7a22$var$set(copy, key, $196bb52fa95b7a22$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $196bb52fa95b7a22$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $196bb52fa95b7a22$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $196bb52fa95b7a22$var$get(base_, key);
            const value = $196bb52fa95b7a22$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $196bb52fa95b7a22$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $196bb52fa95b7a22$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $196bb52fa95b7a22$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $196bb52fa95b7a22$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $196bb52fa95b7a22$var$die(errorOffset + 3);
                base = $196bb52fa95b7a22$var$get(base, p);
                if (typeof base !== "object") $196bb52fa95b7a22$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $196bb52fa95b7a22$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $196bb52fa95b7a22$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $196bb52fa95b7a22$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$196bb52fa95b7a22$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($196bb52fa95b7a22$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($196bb52fa95b7a22$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($196bb52fa95b7a22$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($196bb52fa95b7a22$var$has(obj, $196bb52fa95b7a22$export$6ee2082928bcb0ee)) cloned[$196bb52fa95b7a22$export$6ee2082928bcb0ee] = obj[$196bb52fa95b7a22$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($196bb52fa95b7a22$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $196bb52fa95b7a22$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $196bb52fa95b7a22$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$196bb52fa95b7a22$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $196bb52fa95b7a22$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $196bb52fa95b7a22$var$latest(this[$196bb52fa95b7a22$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $196bb52fa95b7a22$var$latest(this[$196bb52fa95b7a22$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$196bb52fa95b7a22$var$latest(state).has(key) || $196bb52fa95b7a22$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $196bb52fa95b7a22$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $196bb52fa95b7a22$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($196bb52fa95b7a22$var$latest(state).size) {
                prepareMapCopy(state);
                $196bb52fa95b7a22$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $196bb52fa95b7a22$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            $196bb52fa95b7a22$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $196bb52fa95b7a22$var$latest(state).get(key);
            if (state.finalized_ || !$196bb52fa95b7a22$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $196bb52fa95b7a22$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $196bb52fa95b7a22$var$latest(this[$196bb52fa95b7a22$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($196bb52fa95b7a22$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$196bb52fa95b7a22$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $196bb52fa95b7a22$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $196bb52fa95b7a22$var$latest(this[$196bb52fa95b7a22$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $196bb52fa95b7a22$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $196bb52fa95b7a22$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($196bb52fa95b7a22$var$latest(state).size) {
                prepareSetCopy(state);
                $196bb52fa95b7a22$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$196bb52fa95b7a22$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($196bb52fa95b7a22$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($196bb52fa95b7a22$export$16e3aed3edb85946(value)) {
                    const draft = $196bb52fa95b7a22$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $196bb52fa95b7a22$var$die(3, JSON.stringify($196bb52fa95b7a22$var$latest(state)));
    }
    $196bb52fa95b7a22$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $196bb52fa95b7a22$var$immer = new $196bb52fa95b7a22$export$aaadc6ff0f822719();
var $196bb52fa95b7a22$export$b46cabe22e78bc00 = $196bb52fa95b7a22$var$immer.produce;
var $196bb52fa95b7a22$export$4da66d41c9492c78 = $196bb52fa95b7a22$var$immer.produceWithPatches.bind($196bb52fa95b7a22$var$immer);
var $196bb52fa95b7a22$export$573f26f60825c493 = $196bb52fa95b7a22$var$immer.setAutoFreeze.bind($196bb52fa95b7a22$var$immer);
var $196bb52fa95b7a22$export$333ce65961cbe047 = $196bb52fa95b7a22$var$immer.setUseStrictShallowCopy.bind($196bb52fa95b7a22$var$immer);
var $196bb52fa95b7a22$export$a8b8e03e6bbe5473 = $196bb52fa95b7a22$var$immer.applyPatches.bind($196bb52fa95b7a22$var$immer);
var $196bb52fa95b7a22$export$3c3214997190395f = $196bb52fa95b7a22$var$immer.createDraft.bind($196bb52fa95b7a22$var$immer);
var $196bb52fa95b7a22$export$c60f5e69c521b528 = $196bb52fa95b7a22$var$immer.finishDraft.bind($196bb52fa95b7a22$var$immer);
function $196bb52fa95b7a22$export$c05b21e3257751e5(value) {
    return value;
}
function $196bb52fa95b7a22$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("fs6kw", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", function () { return $b3fe618e02bdfd69$export$8402dc26d96f6902; });
$parcel$export(module.exports, "createSelectorCreator", function () { return $b3fe618e02bdfd69$export$5943f4447f6ef248; });
var $b3fe618e02bdfd69$var$__defProp = Object.defineProperty;
var $b3fe618e02bdfd69$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b3fe618e02bdfd69$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b3fe618e02bdfd69$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b3fe618e02bdfd69$var$__defNormalProp = (obj, key, value)=>key in obj ? $b3fe618e02bdfd69$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b3fe618e02bdfd69$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b3fe618e02bdfd69$var$__hasOwnProp.call(b, prop)) $b3fe618e02bdfd69$var$__defNormalProp(a, prop, b[prop]);
    if ($b3fe618e02bdfd69$var$__getOwnPropSymbols) {
        for (var prop of $b3fe618e02bdfd69$var$__getOwnPropSymbols(b))if ($b3fe618e02bdfd69$var$__propIsEnum.call(b, prop)) $b3fe618e02bdfd69$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b3fe618e02bdfd69$var$__publicField = (obj, key, value)=>{
    $b3fe618e02bdfd69$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b3fe618e02bdfd69$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b3fe618e02bdfd69$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b3fe618e02bdfd69$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b3fe618e02bdfd69$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($b3fe618e02bdfd69$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b3fe618e02bdfd69$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $b3fe618e02bdfd69$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b3fe618e02bdfd69$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $b3fe618e02bdfd69$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $b3fe618e02bdfd69$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b3fe618e02bdfd69$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b3fe618e02bdfd69$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $b3fe618e02bdfd69$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b3fe618e02bdfd69$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $b3fe618e02bdfd69$var$__spreadValues($b3fe618e02bdfd69$var$__spreadValues({}, $b3fe618e02bdfd69$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b3fe618e02bdfd69$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b3fe618e02bdfd69$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b3fe618e02bdfd69$var$$REVISION = 0;
var $b3fe618e02bdfd69$var$CURRENT_TRACKER = null;
var $b3fe618e02bdfd69$var$Cell = class {
    constructor(initialValue, isEqual = $b3fe618e02bdfd69$var$tripleEq){
        $b3fe618e02bdfd69$var$__publicField(this, "revision", $b3fe618e02bdfd69$var$$REVISION);
        $b3fe618e02bdfd69$var$__publicField(this, "_value");
        $b3fe618e02bdfd69$var$__publicField(this, "_lastValue");
        $b3fe618e02bdfd69$var$__publicField(this, "_isEqual", $b3fe618e02bdfd69$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $b3fe618e02bdfd69$var$CURRENT_TRACKER == null || $b3fe618e02bdfd69$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$b3fe618e02bdfd69$var$$REVISION;
    }
};
function $b3fe618e02bdfd69$var$tripleEq(a, b) {
    return a === b;
}
var $b3fe618e02bdfd69$var$TrackingCache = class {
    constructor(fn){
        $b3fe618e02bdfd69$var$__publicField(this, "_cachedValue");
        $b3fe618e02bdfd69$var$__publicField(this, "_cachedRevision", -1);
        $b3fe618e02bdfd69$var$__publicField(this, "_deps", []);
        $b3fe618e02bdfd69$var$__publicField(this, "hits", 0);
        $b3fe618e02bdfd69$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $b3fe618e02bdfd69$var$CURRENT_TRACKER;
            $b3fe618e02bdfd69$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $b3fe618e02bdfd69$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $b3fe618e02bdfd69$var$CURRENT_TRACKER == null || $b3fe618e02bdfd69$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $b3fe618e02bdfd69$var$getValue(cell) {
    if (!(cell instanceof $b3fe618e02bdfd69$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b3fe618e02bdfd69$var$setValue(storage, value) {
    if (!(storage instanceof $b3fe618e02bdfd69$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b3fe618e02bdfd69$var$createCell(initialValue, isEqual = $b3fe618e02bdfd69$var$tripleEq) {
    return new $b3fe618e02bdfd69$var$Cell(initialValue, isEqual);
}
function $b3fe618e02bdfd69$var$createCache(fn) {
    $b3fe618e02bdfd69$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b3fe618e02bdfd69$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b3fe618e02bdfd69$var$neverEq = (a, b)=>false;
function $b3fe618e02bdfd69$var$createTag() {
    return $b3fe618e02bdfd69$var$createCell(null, $b3fe618e02bdfd69$var$neverEq);
}
function $b3fe618e02bdfd69$var$dirtyTag(tag, value) {
    $b3fe618e02bdfd69$var$setValue(tag, value);
}
var $b3fe618e02bdfd69$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b3fe618e02bdfd69$var$createTag();
    $b3fe618e02bdfd69$var$getValue(tag);
};
var $b3fe618e02bdfd69$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $b3fe618e02bdfd69$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b3fe618e02bdfd69$var$REDUX_PROXY_LABEL = Symbol();
var $b3fe618e02bdfd69$var$nextId = 0;
var $b3fe618e02bdfd69$var$proto = Object.getPrototypeOf({});
var $b3fe618e02bdfd69$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $b3fe618e02bdfd69$var$__publicField(this, "proxy", new Proxy(this, $b3fe618e02bdfd69$var$objectProxyHandler));
        $b3fe618e02bdfd69$var$__publicField(this, "tag", $b3fe618e02bdfd69$var$createTag());
        $b3fe618e02bdfd69$var$__publicField(this, "tags", {});
        $b3fe618e02bdfd69$var$__publicField(this, "children", {});
        $b3fe618e02bdfd69$var$__publicField(this, "collectionTag", null);
        $b3fe618e02bdfd69$var$__publicField(this, "id", $b3fe618e02bdfd69$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $b3fe618e02bdfd69$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $b3fe618e02bdfd69$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b3fe618e02bdfd69$var$createNode(childValue);
                if (childNode.tag) $b3fe618e02bdfd69$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b3fe618e02bdfd69$var$createTag();
                    tag.value = childValue;
                }
                $b3fe618e02bdfd69$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $b3fe618e02bdfd69$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b3fe618e02bdfd69$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $b3fe618e02bdfd69$var$__publicField(this, "proxy", new Proxy([
            this
        ], $b3fe618e02bdfd69$var$arrayProxyHandler));
        $b3fe618e02bdfd69$var$__publicField(this, "tag", $b3fe618e02bdfd69$var$createTag());
        $b3fe618e02bdfd69$var$__publicField(this, "tags", {});
        $b3fe618e02bdfd69$var$__publicField(this, "children", {});
        $b3fe618e02bdfd69$var$__publicField(this, "collectionTag", null);
        $b3fe618e02bdfd69$var$__publicField(this, "id", $b3fe618e02bdfd69$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $b3fe618e02bdfd69$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $b3fe618e02bdfd69$var$consumeCollection(node);
        return $b3fe618e02bdfd69$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $b3fe618e02bdfd69$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $b3fe618e02bdfd69$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $b3fe618e02bdfd69$var$objectProxyHandler.has(node, prop);
    }
};
function $b3fe618e02bdfd69$var$createNode(value) {
    if (Array.isArray(value)) return new $b3fe618e02bdfd69$var$ArrayTreeNode(value);
    return new $b3fe618e02bdfd69$var$ObjectTreeNode(value);
}
function $b3fe618e02bdfd69$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b3fe618e02bdfd69$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b3fe618e02bdfd69$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $b3fe618e02bdfd69$var$dirtyCollection(node);
            $b3fe618e02bdfd69$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $b3fe618e02bdfd69$var$updateNode(childNode, newChildValue);
        else {
            $b3fe618e02bdfd69$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $b3fe618e02bdfd69$var$deleteNode(node) {
    if (node.tag) $b3fe618e02bdfd69$var$dirtyTag(node.tag, null);
    $b3fe618e02bdfd69$var$dirtyCollection(node);
    for(const key in node.tags)$b3fe618e02bdfd69$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$b3fe618e02bdfd69$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $b3fe618e02bdfd69$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b3fe618e02bdfd69$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $b3fe618e02bdfd69$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b3fe618e02bdfd69$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b3fe618e02bdfd69$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b3fe618e02bdfd69$export$3f025202a230c6dd = (a, b)=>a === b;
function $b3fe618e02bdfd69$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b3fe618e02bdfd69$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $b3fe618e02bdfd69$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $b3fe618e02bdfd69$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $b3fe618e02bdfd69$var$createSingletonCache(comparator) : $b3fe618e02bdfd69$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $b3fe618e02bdfd69$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b3fe618e02bdfd69$export$c8f9cf88d9fdee55(func) {
    const node = $b3fe618e02bdfd69$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $b3fe618e02bdfd69$var$createCacheKeyComparator($b3fe618e02bdfd69$export$3f025202a230c6dd);
    const cache = $b3fe618e02bdfd69$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b3fe618e02bdfd69$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b3fe618e02bdfd69$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $b3fe618e02bdfd69$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b3fe618e02bdfd69$var$StrongRef;
var $b3fe618e02bdfd69$var$UNTERMINATED = 0;
var $b3fe618e02bdfd69$var$TERMINATED = 1;
function $b3fe618e02bdfd69$var$createCacheNode() {
    return {
        s: $b3fe618e02bdfd69$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b3fe618e02bdfd69$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $b3fe618e02bdfd69$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b3fe618e02bdfd69$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b3fe618e02bdfd69$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $b3fe618e02bdfd69$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $b3fe618e02bdfd69$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $b3fe618e02bdfd69$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $b3fe618e02bdfd69$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b3fe618e02bdfd69$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b3fe618e02bdfd69$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $b3fe618e02bdfd69$var$__spreadValues($b3fe618e02bdfd69$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $b3fe618e02bdfd69$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $b3fe618e02bdfd69$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $b3fe618e02bdfd69$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $b3fe618e02bdfd69$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $b3fe618e02bdfd69$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $b3fe618e02bdfd69$export$595d22ed68ca2841 = /* @__PURE__ */ $b3fe618e02bdfd69$export$5943f4447f6ef248($b3fe618e02bdfd69$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b3fe618e02bdfd69$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $b3fe618e02bdfd69$export$595d22ed68ca2841)=>{
    $b3fe618e02bdfd69$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$b3fe618e02bdfd69$export$75979cfcd91bf38f
});

});

parcelRegister("aaIyi", function(module, exports) {

$parcel$export(module.exports, "thunk", function () { return $767d65adfb1b736a$export$dd164f5517779f15; });
$parcel$export(module.exports, "withExtraArgument", function () { return $767d65adfb1b736a$export$16d06542a1949d9e; });
// src/index.ts
function $767d65adfb1b736a$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $767d65adfb1b736a$export$dd164f5517779f15 = $767d65adfb1b736a$var$createThunkMiddleware();
var $767d65adfb1b736a$export$16d06542a1949d9e = $767d65adfb1b736a$var$createThunkMiddleware;

});



parcelRegister("8ayi5", function(module, exports) {

$parcel$export(module.exports, "registerAsync", function () { return $5f29db4e3a2aa45e$export$808262bc0638b75; });
$parcel$export(module.exports, "loginAsync", function () { return $5f29db4e3a2aa45e$export$c5f62253ff4bf5a6; });
$parcel$export(module.exports, "logoutAsync", function () { return $5f29db4e3a2aa45e$export$2e0103b21fc452d3; });
$parcel$export(module.exports, "openAuthModal", function () { return $5f29db4e3a2aa45e$export$7cf92498e76d037e; });
$parcel$export(module.exports, "closeAuthModal", function () { return $5f29db4e3a2aa45e$export$ecd5e78931ba149d; });
$parcel$export(module.exports, "switchMode", function () { return $5f29db4e3a2aa45e$export$c43e41d2ed1b3347; });
$parcel$export(module.exports, "default", function () { return $5f29db4e3a2aa45e$export$2e2bcd8739ae039; });

var $hpG1k = parcelRequire("hpG1k");
// 🔒 Demo helpers (NOT for production)
const $5f29db4e3a2aa45e$var$sleep = (ms)=>new Promise((r)=>setTimeout(r, ms));
const $5f29db4e3a2aa45e$var$hash = (s)=>btoa(unescape(encodeURIComponent(s))); // demo-only
const $5f29db4e3a2aa45e$var$readUsers = ()=>{
    try {
        return JSON.parse(localStorage.getItem("users") || "[]");
    } catch  {
        return [];
    }
};
const $5f29db4e3a2aa45e$var$writeUsers = (arr)=>localStorage.setItem("users", JSON.stringify(arr));
const $5f29db4e3a2aa45e$export$808262bc0638b75 = (0, $hpG1k.createAsyncThunk)("auth/registerAsync", async ({ name: name, email: email, password: password })=>{
    await $5f29db4e3a2aa45e$var$sleep(500);
    const users = $5f29db4e3a2aa45e$var$readUsers();
    const exists = users.find((u)=>u.email.toLowerCase() === email.toLowerCase());
    if (exists) throw new Error("An account with this email already exists.");
    const newUser = {
        name: name,
        email: email,
        passwordHash: $5f29db4e3a2aa45e$var$hash(password)
    };
    users.push(newUser);
    $5f29db4e3a2aa45e$var$writeUsers(users);
    return {
        token: "demo-token",
        user: {
            name: name,
            email: email
        }
    };
});
const $5f29db4e3a2aa45e$export$c5f62253ff4bf5a6 = (0, $hpG1k.createAsyncThunk)("auth/loginAsync", async ({ email: email, password: password })=>{
    await $5f29db4e3a2aa45e$var$sleep(500);
    const users = $5f29db4e3a2aa45e$var$readUsers();
    const found = users.find((u)=>u.email.toLowerCase() === email.toLowerCase());
    if (!found || found.passwordHash !== $5f29db4e3a2aa45e$var$hash(password)) throw new Error("Invalid email or password.");
    return {
        token: "demo-token",
        user: {
            name: found.name,
            email: found.email
        }
    };
});
const $5f29db4e3a2aa45e$export$2e0103b21fc452d3 = (0, $hpG1k.createAsyncThunk)("auth/logoutAsync", async ()=>{
    await $5f29db4e3a2aa45e$var$sleep(250);
    return true;
});
const $5f29db4e3a2aa45e$var$initialState = {
    isAuthenticated: !!localStorage.getItem("auth_token"),
    user: JSON.parse(localStorage.getItem("auth_user") || "null"),
    status: "idle",
    error: null,
    // UI state for modal
    modalOpen: false,
    mode: "signin"
};
const $5f29db4e3a2aa45e$var$authSlice = (0, $hpG1k.createSlice)({
    name: "auth",
    initialState: $5f29db4e3a2aa45e$var$initialState,
    reducers: {
        openAuthModal (state, action) {
            const users = $5f29db4e3a2aa45e$var$readUsers();
            state.mode = users.length ? "signin" : "signup";
            if (action?.payload?.mode) state.mode = action.payload.mode;
            state.modalOpen = true;
            state.error = null;
        },
        closeAuthModal (state) {
            state.modalOpen = false;
            state.error = null;
        },
        switchMode (state, action) {
            state.mode = action.payload; // 'signin' or 'signup'
            state.error = null;
        }
    },
    extraReducers: (builder)=>{
        builder// register
        .addCase($5f29db4e3a2aa45e$export$808262bc0638b75.pending, (s)=>{
            s.status = "loading";
            s.error = null;
        }).addCase($5f29db4e3a2aa45e$export$808262bc0638b75.fulfilled, (s, { payload: payload })=>{
            s.status = "succeeded";
            s.isAuthenticated = true;
            s.user = payload.user;
            s.modalOpen = false;
            localStorage.setItem("auth_token", payload.token);
            localStorage.setItem("auth_user", JSON.stringify(payload.user));
        }).addCase($5f29db4e3a2aa45e$export$808262bc0638b75.rejected, (s, a)=>{
            s.status = "failed";
            s.error = a.error.message;
        })// login
        .addCase($5f29db4e3a2aa45e$export$c5f62253ff4bf5a6.pending, (s)=>{
            s.status = "loading";
            s.error = null;
        }).addCase($5f29db4e3a2aa45e$export$c5f62253ff4bf5a6.fulfilled, (s, { payload: payload })=>{
            s.status = "succeeded";
            s.isAuthenticated = true;
            s.user = payload.user;
            s.modalOpen = false;
            localStorage.setItem("auth_token", payload.token);
            localStorage.setItem("auth_user", JSON.stringify(payload.user));
        }).addCase($5f29db4e3a2aa45e$export$c5f62253ff4bf5a6.rejected, (s, a)=>{
            s.status = "failed";
            s.error = a.error.message;
        })// logout
        .addCase($5f29db4e3a2aa45e$export$2e0103b21fc452d3.pending, (s)=>{
            s.status = "loading";
            s.error = null;
        }).addCase($5f29db4e3a2aa45e$export$2e0103b21fc452d3.fulfilled, (s)=>{
            s.status = "succeeded";
            s.isAuthenticated = false;
            s.user = null;
            localStorage.removeItem("auth_token");
            localStorage.removeItem("auth_user");
        }).addCase($5f29db4e3a2aa45e$export$2e0103b21fc452d3.rejected, (s, a)=>{
            s.status = "failed";
            s.error = a.error.message;
        });
    }
});
const { openAuthModal: $5f29db4e3a2aa45e$export$7cf92498e76d037e, closeAuthModal: $5f29db4e3a2aa45e$export$ecd5e78931ba149d, switchMode: $5f29db4e3a2aa45e$export$c43e41d2ed1b3347 } = $5f29db4e3a2aa45e$var$authSlice.actions;
var $5f29db4e3a2aa45e$export$2e2bcd8739ae039 = $5f29db4e3a2aa45e$var$authSlice.reducer;

});

parcelRegister("1glGL", function(module, exports) {

$parcel$export(module.exports, "hydrateOrders", function () { return $0eb81bfa8d187b35$export$5e5b21a23bef1c4b; });
$parcel$export(module.exports, "addOrder", function () { return $0eb81bfa8d187b35$export$e0b7ffbb35a861bd; });
$parcel$export(module.exports, "default", function () { return $0eb81bfa8d187b35$export$2e2bcd8739ae039; });
// src/Utils/ordersSlice.js

var $hpG1k = parcelRequire("hpG1k");
const $0eb81bfa8d187b35$var$initialState = {
    list: []
};
const $0eb81bfa8d187b35$var$ordersSlice = (0, $hpG1k.createSlice)({
    name: "orders",
    initialState: $0eb81bfa8d187b35$var$initialState,
    reducers: {
        hydrateOrders: (state, action)=>{
            state.list = action.payload || [];
        },
        addOrder: (state, action)=>{
            state.list.unshift(action.payload);
        }
    }
});
const { hydrateOrders: $0eb81bfa8d187b35$export$5e5b21a23bef1c4b, addOrder: $0eb81bfa8d187b35$export$e0b7ffbb35a861bd } = $0eb81bfa8d187b35$var$ordersSlice.actions;
var $0eb81bfa8d187b35$export$2e2bcd8739ae039 = $0eb81bfa8d187b35$var$ordersSlice.reducer;

});

parcelRegister("cFs3v", function(module, exports) {
module.exports = $parcel$import("jCP3b").then(()=>parcelRequire('5kFbV'));

});

parcelRegister("kb5JE", function(module, exports) {
module.exports = $parcel$import("7KF41").then(()=>parcelRequire('03ie5'));

});

parcelRegister("6X4A1", function(module, exports) {
module.exports = $parcel$import("3kJqF").then(()=>parcelRequire('d8qIf'));

});

parcelRegister("ef8a6", function(module, exports) {
module.exports = $parcel$import("aLcMV").then(()=>parcelRequire('70lMn'));

});

parcelRegister("kaXFZ", function(module, exports) {
module.exports = $parcel$import("rJK5O").then(()=>parcelRequire('1XraA'));

});

parcelRegister("3VqVI", function(module, exports) {
module.exports = $parcel$import("87VqI").then(()=>parcelRequire('duH4r'));

});

parcelRegister("02lGK", function(module, exports) {
module.exports = $parcel$import("h3cWh").then(()=>parcelRequire('flheW'));

});

parcelRegister("818UC", function(module, exports) {
module.exports = $parcel$import("8GnhA").then(()=>parcelRequire('5E16S'));

});

parcelRegister("gdAEZ", function(module, exports) {
module.exports = $parcel$import("eVeFG").then(()=>parcelRequire('2PTP1'));

});

parcelRegister("fhWtk", function(module, exports) {
module.exports = $parcel$import("7GFTh").then(()=>parcelRequire('dKZak'));

});

parcelRegister("cmYgB", function(module, exports) {
module.exports = $parcel$import("7QShh").then(()=>parcelRequire('lfCzl'));

});

var $1acc80bea5548a68$exports = {};
$parcel$extendImportMap({
    "jCP3b": "Header.75f3302a.js",
    "7KF41": "Footer.394bb901.js",
    "3kJqF": "Body.e94988fc.js",
    "aLcMV": "Error.a74a8269.js",
    "rJK5O": "About.aad77837.js",
    "87VqI": "Contact.05bfadaf.js",
    "h3cWh": "RestaurantMenu.b392dc69.js",
    "8GnhA": "Cart.ee001bda.js",
    "eVeFG": "AuthModal.00d3060b.js",
    "7GFTh": "Checkout.77ef4420.js",
    "7QShh": "ThankYou.0f3ff4ce.js"
});


var $5z4M4 = parcelRequire("5z4M4");

var $jGswQ = parcelRequire("jGswQ");
var $9c391b1d92b7475a$exports = {};
'use strict';
function $9c391b1d92b7475a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9c391b1d92b7475a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9c391b1d92b7475a$var$checkDCE();

$9c391b1d92b7475a$exports = (parcelRequire("He5iZ"));



var $8CEvx = parcelRequire("8CEvx");
var $dI2iO = parcelRequire("dI2iO");

var $813nt = parcelRequire("813nt");

var $23euK = parcelRequire("23euK");
// src/Utils/appStore.js

var $hpG1k = parcelRequire("hpG1k");

var $4mAjV = parcelRequire("4mAjV");

var $8ayi5 = parcelRequire("8ayi5");

var $1glGL = parcelRequire("1glGL");
const $47001b6ed6fa8382$var$appStore = (0, $hpG1k.configureStore)({
    reducer: {
        cart: (0, $4mAjV.default),
        auth: (0, $8ayi5.default),
        orders: (0, $1glGL.default)
    }
});
var $47001b6ed6fa8382$export$2e2bcd8739ae039 = $47001b6ed6fa8382$var$appStore;



// Lazy-load components/pages
const $20283afb70f105de$var$Header = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("cFs3v")));

const $20283afb70f105de$var$Footer = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("kb5JE")));

const $20283afb70f105de$var$Body = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("6X4A1")));

const $20283afb70f105de$var$Error = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("ef8a6")));

const $20283afb70f105de$var$About = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("kaXFZ")));

const $20283afb70f105de$var$Contact = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("3VqVI")));

const $20283afb70f105de$var$RestaurantMenu = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("02lGK")));

const $20283afb70f105de$var$Cart = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("818UC")));

const $20283afb70f105de$var$AuthModal = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("gdAEZ")));

// NEW pages (you can place them in /pages or /components—adjust paths accordingly)
const $20283afb70f105de$var$Checkout = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("fhWtk"))); // ← NEW

const $20283afb70f105de$var$ThankYou = /*#__PURE__*/ (0, $jGswQ.lazy)(()=>(parcelRequire("cmYgB"))); // ← NEW (with :id param)
const $20283afb70f105de$var$AppLayout = ()=>/*#__PURE__*/ (0, $5z4M4.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, $5z4M4.jsxs)((0, $jGswQ.Suspense), {
            fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
            children: [
                /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Header, {}),
                /*#__PURE__*/ (0, $5z4M4.jsx)((0, $dI2iO.Outlet), {}),
                /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Footer, {}),
                /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$AuthModal, {}),
                /*#__PURE__*/ (0, $5z4M4.jsx)((0, $8CEvx.ScrollRestoration), {})
            ]
        })
    });
const $20283afb70f105de$var$appRouter = (0, $8CEvx.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
            fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
            children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Error, {})
        }),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Body, {})
                })
            },
            {
                path: "about",
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$About, {})
                })
            },
            {
                path: "contact",
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Contact, {})
                })
            },
            {
                path: "restaurant/:id",
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$RestaurantMenu, {})
                })
            },
            {
                path: "cart",
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Cart, {})
                })
            },
            /* ---------- NEW ROUTES ---------- */ {
                path: "checkout",
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$Checkout, {})
                })
            },
            {
                path: "thank-you/:id",
                element: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $jGswQ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $813nt.default), {}),
                    children: /*#__PURE__*/ (0, $5z4M4.jsx)($20283afb70f105de$var$ThankYou, {})
                })
            }
        ]
    }
]);
const $20283afb70f105de$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($9c391b1d92b7475a$exports))).createRoot(document.getElementById("root"));
$20283afb70f105de$var$root.render(/*#__PURE__*/ (0, $5z4M4.jsx)((0, $23euK.Provider), {
    store: (0, $47001b6ed6fa8382$export$2e2bcd8739ae039),
    children: /*#__PURE__*/ (0, $5z4M4.jsx)((0, $8CEvx.RouterProvider), {
        router: $20283afb70f105de$var$appRouter
    })
}));


//# sourceMappingURL=path0.c820c42d.js.map
